export const ICONS = {
    fonts: [
        {
            fontName: 'FlatIconSolidRounded',
            glyphPrefix: '',
            default: true,
        },
        {
            fontName: 'Roundies',
            glyphPrefix: 'roundies:',
            default: false,
        },
        {
            fontName: 'MaterialSymbolsRounded',
            glyphPrefix: 'material:',
            default: false,
        },
    ],
    glyphs: {
        '0': '\uf101',
        '1': '\uf102',
        '2': '\uf103',
        '3': '\uf104',
        '360-degrees': '\uf105',
        '4': '\uf106',
        '5': '\uf107',
        '6': '\uf108',
        '7': '\uf109',
        '8': '\uf10a',
        '9': '\uf10b',
        a: '\uf10c',
        acorn: '\uf10d',
        ad: '\uf10e',
        'add-document': '\uf10f',
        'add-folder': '\uf110',
        add: '\uf111',
        'address-book': '\uf112',
        'address-card': '\uf113',
        'air-conditioner': '\uf114',
        'air-freshener': '\uf115',
        airplay: '\uf116',
        'alarm-clock': '\uf117',
        'alarm-exclamation': '\uf118',
        'alarm-plus': '\uf119',
        'alarm-snooze': '\uf11a',
        'album-circle-plus': '\uf11b',
        'album-circle-user': '\uf11c',
        'album-collection': '\uf11d',
        album: '\uf11e',
        alien: '\uf11f',
        'align-center': '\uf120',
        'align-justify': '\uf121',
        'align-left': '\uf122',
        'align-slash': '\uf123',
        ambulance: '\uf124',
        'amusement-park': '\uf125',
        anchor: '\uf126',
        angel: '\uf127',
        'angle-circle-down': '\uf128',
        'angle-circle-left': '\uf129',
        'angle-circle-right': '\uf12a',
        'angle-circle-up': '\uf12b',
        'angle-double-left': '\uf12c',
        'angle-double-right': '\uf12d',
        'angle-double-small-down': '\uf12e',
        'angle-double-small-left': '\uf12f',
        'angle-double-small-right': '\uf130',
        'angle-double-small-up': '\uf131',
        'angle-down': '\uf132',
        'angle-left': '\uf133',
        'angle-right': '\uf134',
        'angle-small-down': '\uf135',
        'angle-small-left': '\uf136',
        'angle-small-right': '\uf137',
        'angle-small-up': '\uf138',
        'angle-square-down': '\uf139',
        'angle-square-left': '\uf13a',
        'angle-square-right': '\uf13b',
        'angle-square-up': '\uf13c',
        'angle-up': '\uf13d',
        angry: '\uf13e',
        'animated-icon': '\uf13f',
        apartment: '\uf140',
        aperture: '\uf141',
        api: '\uf142',
        'apple-crate': '\uf143',
        'apple-whole': '\uf144',
        'apps-add': '\uf145',
        'apps-delete': '\uf146',
        'apps-sort': '\uf147',
        apps: '\uf148',
        archive: '\uf149',
        archway: '\uf14a',
        'arrow-alt-circle-down': '\uf14b',
        'arrow-alt-circle-left': '\uf14c',
        'arrow-alt-circle-right': '\uf14d',
        'arrow-alt-circle-up': '\uf14e',
        'arrow-alt-down': '\uf14f',
        'arrow-alt-from-bottom': '\uf150',
        'arrow-alt-from-left': '\uf151',
        'arrow-alt-from-right': '\uf152',
        'arrow-alt-from-top': '\uf153',
        'arrow-alt-left': '\uf154',
        'arrow-alt-right': '\uf155',
        'arrow-alt-square-down': '\uf156',
        'arrow-alt-square-left': '\uf157',
        'arrow-alt-square-right': '\uf158',
        'arrow-alt-square-up': '\uf159',
        'arrow-alt-to-bottom': '\uf15a',
        'arrow-alt-to-left': '\uf15b',
        'arrow-alt-to-right': '\uf15c',
        'arrow-alt-to-top': '\uf15d',
        'arrow-alt-up': '\uf15e',
        'arrow-circle-down': '\uf15f',
        'arrow-circle-left': '\uf160',
        'arrow-circle-right': '\uf161',
        'arrow-circle-up': '\uf162',
        'arrow-down-from-dotted-line': '\uf163',
        'arrow-down-left': '\uf164',
        'arrow-down-small-big': '\uf165',
        'arrow-down-to-dotted-line': '\uf166',
        'arrow-down-to-square': '\uf167',
        'arrow-down-triangle-square': '\uf168',
        'arrow-down': '\uf169',
        'arrow-from-bottom': '\uf16a',
        'arrow-from-left': '\uf16b',
        'arrow-from-right': '\uf16c',
        'arrow-from-top': '\uf16d',
        'arrow-left-from-line': '\uf16e',
        'arrow-left': '\uf16f',
        'arrow-right-to-bracket': '\uf170',
        'arrow-right': '\uf171',
        'arrow-small-down': '\uf172',
        'arrow-small-left': '\uf173',
        'arrow-small-right': '\uf174',
        'arrow-small-up': '\uf175',
        'arrow-square-down': '\uf176',
        'arrow-square-left': '\uf177',
        'arrow-square-right': '\uf178',
        'arrow-square-up': '\uf179',
        'arrow-to-bottom': '\uf17a',
        'arrow-to-left': '\uf17b',
        'arrow-to-right': '\uf17c',
        'arrow-to-top': '\uf17d',
        'arrow-trend-down': '\uf17e',
        'arrow-trend-up': '\uf17f',
        'arrow-turn-down-left': '\uf180',
        'arrow-turn-down-right': '\uf181',
        'arrow-up-from-dotted-line': '\uf182',
        'arrow-up-from-square': '\uf183',
        'arrow-up-left-from-circle': '\uf184',
        'arrow-up-left': '\uf185',
        'arrow-up-right-and-arrow-down-left-from-center': '\uf186',
        'arrow-up-right-from-square': '\uf187',
        'arrow-up-right': '\uf188',
        'arrow-up-small-big': '\uf189',
        'arrow-up-square-triangle': '\uf18a',
        'arrow-up-to-dotted-line': '\uf18b',
        'arrow-up': '\uf18c',
        'arrows-alt-h': '\uf18d',
        'arrows-alt-v': '\uf18e',
        'arrows-alt': '\uf18f',
        'arrows-cross': '\uf190',
        'arrows-from-dotted-line': '\uf191',
        'arrows-from-line': '\uf192',
        'arrows-h-copy': '\uf193',
        'arrows-h': '\uf194',
        'arrows-repeat-1': '\uf195',
        'arrows-repeat': '\uf196',
        'arrows-retweet': '\uf197',
        'arrows-to-dotted-line': '\uf198',
        'arrows-to-line': '\uf199',
        arrows: '\uf19a',
        'assept-document': '\uf19b',
        'assistive-listening-systems': '\uf19c',
        asterik: '\uf19d',
        at: '\uf19e',
        'attribution-pen': '\uf19f',
        'attribution-pencil': '\uf1a0',
        aubergine: '\uf1a1',
        'audio-description-slash': '\uf1a2',
        'austral-sign': '\uf1a3',
        avocado: '\uf1a4',
        b: '\uf1a5',
        'baby-carriage': '\uf1a6',
        baby: '\uf1a7',
        background: '\uf1a8',
        backpack: '\uf1a9',
        bacon: '\uf1aa',
        bacteria: '\uf1ab',
        bacterium: '\uf1ac',
        'badge-check': '\uf1ad',
        'badge-dollar': '\uf1ae',
        'badge-percent': '\uf1af',
        'badge-sheriff': '\uf1b0',
        badge: '\uf1b1',
        'bags-shopping': '\uf1b2',
        bahai: '\uf1b3',
        'baht-sign': '\uf1b4',
        'balance-scale-left': '\uf1b5',
        'balance-scale-right': '\uf1b6',
        'balance-scale': '\uf1b7',
        'ball-pile': '\uf1b8',
        balloons: '\uf1b9',
        'ballot-check': '\uf1ba',
        ballot: '\uf1bb',
        'ban-bug': '\uf1bc',
        ban: '\uf1bd',
        'band-aid': '\uf1be',
        'bangladeshi-taka-sign': '\uf1bf',
        banjo: '\uf1c0',
        bank: '\uf1c1',
        'barber-shop': '\uf1c2',
        'barcode-read': '\uf1c3',
        'barcode-scan': '\uf1c4',
        barcode: '\uf1c5',
        'bars-filter': '\uf1c6',
        'bars-progress': '\uf1c7',
        'bars-sort': '\uf1c8',
        'bars-staggered': '\uf1c9',
        'baseball-alt': '\uf1ca',
        baseball: '\uf1cb',
        'basket-shopping-simple': '\uf1cc',
        'basketball-hoop': '\uf1cd',
        basketball: '\uf1ce',
        'battery-bolt': '\uf1cf',
        'battery-empty': '\uf1d0',
        'battery-exclamation': '\uf1d1',
        'battery-full': '\uf1d2',
        'battery-half': '\uf1d3',
        'battery-quarter': '\uf1d4',
        'battery-slash': '\uf1d5',
        'battery-three-quarters': '\uf1d6',
        beacon: '\uf1d7',
        'bed-alt': '\uf1d8',
        bed: '\uf1d9',
        beer: '\uf1da',
        'bell-concierge': '\uf1db',
        'bell-ring': '\uf1dc',
        'bell-school': '\uf1dd',
        'bell-slash': '\uf1de',
        bell: '\uf1df',
        bells: '\uf1e0',
        'bench-tree': '\uf1e1',
        betamax: '\uf1e2',
        bike: '\uf1e3',
        'biking-mountain': '\uf1e4',
        biking: '\uf1e5',
        billiard: '\uf1e6',
        'binary-circle-check': '\uf1e7',
        'binary-lock': '\uf1e8',
        'binary-slash': '\uf1e9',
        binary: '\uf1ea',
        binoculars: '\uf1eb',
        biohazard: '\uf1ec',
        'bitcoin-sign': '\uf1ed',
        'blender-phone': '\uf1ee',
        'blinds-open': '\uf1ef',
        'blinds-raised': '\uf1f0',
        blinds: '\uf1f1',
        'block-brick': '\uf1f2',
        'block-quote': '\uf1f3',
        block: '\uf1f4',
        'blog-pencil': '\uf1f5',
        'blog-text': '\uf1f6',
        blossom: '\uf1f7',
        bold: '\uf1f8',
        'bolt-auto': '\uf1f9',
        'bolt-slash': '\uf1fa',
        bolt: '\uf1fb',
        bomb: '\uf1fc',
        'bone-break': '\uf1fd',
        bone: '\uf1fe',
        bong: '\uf1ff',
        'book-alt': '\uf200',
        'book-arrow-right': '\uf201',
        'book-arrow-up': '\uf202',
        'book-atlas': '\uf203',
        'book-bookmark': '\uf204',
        'book-circle-arrow-right': '\uf205',
        'book-circle-arrow-up': '\uf206',
        'book-copy': '\uf207',
        'book-dead': '\uf208',
        'book-font': '\uf209',
        'book-medical': '\uf20a',
        'book-open-cover': '\uf20b',
        'book-open-reader': '\uf20c',
        'book-quran': '\uf20d',
        'book-section': '\uf20e',
        'book-spells': '\uf20f',
        'book-tanakh': '\uf210',
        'book-user': '\uf211',
        book: '\uf212',
        'bookmark-slash': '\uf213',
        bookmark: '\uf214',
        'books-medical': '\uf215',
        books: '\uf216',
        'border-all': '\uf217',
        'border-bottom': '\uf218',
        'border-center-h': '\uf219',
        'border-center-v': '\uf21a',
        'border-inner': '\uf21b',
        'border-left': '\uf21c',
        'border-none': '\uf21d',
        'border-outer': '\uf21e',
        'border-right': '\uf21f',
        'border-style-alt': '\uf220',
        'border-style': '\uf221',
        'border-top': '\uf222',
        bottle: '\uf223',
        'bow-arrow': '\uf224',
        'bowl-chopsticks-noodles': '\uf225',
        'bowl-chopsticks': '\uf226',
        'bowl-rice': '\uf227',
        'bowling-ball': '\uf228',
        'bowling-pins': '\uf229',
        bowling: '\uf22a',
        'box-alt': '\uf22b',
        'box-ballot': '\uf22c',
        'box-check': '\uf22d',
        'box-dollar': '\uf22e',
        'box-fragile': '\uf22f',
        'box-heart': '\uf230',
        'box-open-full': '\uf231',
        'box-open': '\uf232',
        'box-tissue': '\uf233',
        'box-up': '\uf234',
        box: '\uf235',
        boxes: '\uf236',
        'boxing-glove': '\uf237',
        'bracket-curly-right': '\uf238',
        'bracket-curly': '\uf239',
        'bracket-round-right': '\uf23a',
        'bracket-round': '\uf23b',
        'bracket-square-right': '\uf23c',
        'bracket-square': '\uf23d',
        'brackets-curly': '\uf23e',
        'brackets-round': '\uf23f',
        'brackets-square': '\uf240',
        braille: '\uf241',
        'brain-circuit': '\uf242',
        brain: '\uf243',
        'bread-loaf': '\uf244',
        'bread-slice': '\uf245',
        bread: '\uf246',
        'briefcase-arrow-right': '\uf247',
        'briefcase-blank': '\uf248',
        briefcase: '\uf249',
        'brightness-low': '\uf24a',
        brightness: '\uf24b',
        'bring-forward': '\uf24c',
        'bring-front': '\uf24d',
        'broadcast-tower': '\uf24e',
        broccoli: '\uf24f',
        'broken-image': '\uf250',
        broom: '\uf251',
        browser: '\uf252',
        browsers: '\uf253',
        brush: '\uf254',
        'bug-slash': '\uf255',
        bug: '\uf256',
        building: '\uf257',
        bulb: '\uf258',
        bullet: '\uf259',
        bullhorn: '\uf25a',
        'bullseye-arrow': '\uf25b',
        'bullseye-pointer': '\uf25c',
        bullseye: '\uf25d',
        'burger-alt': '\uf25e',
        'burger-fries': '\uf25f',
        'burger-glass': '\uf260',
        burrito: '\uf261',
        'bus-alt': '\uf262',
        bus: '\uf263',
        'business-time': '\uf264',
        butterfly: '\uf265',
        c: '\uf266',
        cabin: '\uf267',
        cactus: '\uf268',
        'cake-birthday': '\uf269',
        'cake-wedding': '\uf26a',
        'calculator-simple': '\uf26b',
        calculator: '\uf26c',
        'calendar-arrow-down': '\uf26d',
        'calendar-arrow-up': '\uf26e',
        'calendar-check': '\uf26f',
        'calendar-clock': '\uf270',
        'calendar-day': '\uf271',
        'calendar-days': '\uf272',
        'calendar-exclamation': '\uf273',
        'calendar-heart': '\uf274',
        'calendar-image': '\uf275',
        'calendar-lines-pen': '\uf276',
        'calendar-lines': '\uf277',
        'calendar-minus': '\uf278',
        'calendar-pen': '\uf279',
        'calendar-plus': '\uf27a',
        'calendar-star': '\uf27b',
        'calendar-week': '\uf27c',
        'calendar-xmark': '\uf27d',
        calendar: '\uf27e',
        calendars: '\uf27f',
        'call-history': '\uf280',
        'call-incoming': '\uf281',
        'call-missed': '\uf282',
        'call-outgoing': '\uf283',
        camcorder: '\uf284',
        'camera-cctv': '\uf285',
        'camera-movie': '\uf286',
        'camera-retro': '\uf287',
        'camera-rotate': '\uf288',
        'camera-security': '\uf289',
        'camera-slash': '\uf28a',
        'camera-viewfinder': '\uf28b',
        camera: '\uf28c',
        campfire: '\uf28d',
        camping: '\uf28e',
        'candle-holder': '\uf28f',
        'candy-alt': '\uf290',
        'candy-cane': '\uf291',
        'candy-corn': '\uf292',
        candy: '\uf293',
        Cannabis: '\uf294',
        'canned-food': '\uf295',
        capsules: '\uf296',
        'car-alt': '\uf297',
        'car-battery': '\uf298',
        'car-bolt': '\uf299',
        'car-building': '\uf29a',
        'car-bump': '\uf29b',
        'car-bus': '\uf29c',
        'car-circle-bolt': '\uf29d',
        'car-crash': '\uf29e',
        'car-garage': '\uf29f',
        'car-mechanic': '\uf2a0',
        'car-side-bolt': '\uf2a1',
        'car-side': '\uf2a2',
        'car-tilt': '\uf2a3',
        'car-wash': '\uf2a4',
        car: '\uf2a5',
        'caravan-alt': '\uf2a6',
        caravan: '\uf2a7',
        'caret-circle-down': '\uf2a8',
        'caret-circle-right': '\uf2a9',
        'caret-circle-up': '\uf2aa',
        'caret-down': '\uf2ab',
        'caret-left': '\uf2ac',
        'caret-quare-up': '\uf2ad',
        'caret-right': '\uf2ae',
        'caret-square-down': '\uf2af',
        'caret-square-left-1': '\uf2b0',
        'caret-square-left': '\uf2b1',
        'caret-square-right': '\uf2b2',
        'caret-up': '\uf2b3',
        carrot: '\uf2b4',
        cars: '\uf2b5',
        'cart-arrow-down': '\uf2b6',
        'cart-minus': '\uf2b7',
        'cart-shopping-fast': '\uf2b8',
        'cash-register': '\uf2b9',
        'cassette-tape': '\uf2ba',
        'cassette-vhs': '\uf2bb',
        castle: '\uf2bc',
        cauldron: '\uf2bd',
        'cedi-sign': '\uf2be',
        cello: '\uf2bf',
        'cent-sign': '\uf2c0',
        'chair-office': '\uf2c1',
        chair: '\uf2c2',
        'chalkboard-user': '\uf2c3',
        'charging-station': '\uf2c4',
        'chart-area': '\uf2c5',
        'chart-bullet': '\uf2c6',
        'chart-candlestick': '\uf2c7',
        'chart-connected': '\uf2c8',
        'chart-gantt': '\uf2c9',
        'chart-histogram': '\uf2ca',
        'chart-line-up': '\uf2cb',
        'chart-mixed': '\uf2cc',
        'chart-network': '\uf2cd',
        'chart-pie-alt': '\uf2ce',
        'chart-pie': '\uf2cf',
        'chart-pyramid': '\uf2d0',
        'chart-radar': '\uf2d1',
        'chart-scatter-3d': '\uf2d2',
        'chart-scatter-bubble': '\uf2d3',
        'chart-scatter': '\uf2d4',
        'chart-set-theory': '\uf2d5',
        'chart-simple-horizontal': '\uf2d6',
        'chart-simple': '\uf2d7',
        'chart-tree-map': '\uf2d8',
        'chart-tree': '\uf2d9',
        'chart-user': '\uf2da',
        'chart-waterfall': '\uf2db',
        'chat-arrow-down': '\uf2dc',
        'chat-arrow-grow': '\uf2dd',
        'check-circle': '\uf2de',
        'check-double': '\uf2df',
        check: '\uf2e0',
        checkbox: '\uf2e1',
        'cheese-alt': '\uf2e2',
        cheese: '\uf2e3',
        cheeseburger: '\uf2e4',
        cherry: '\uf2e5',
        'chess-bishop': '\uf2e6',
        'chess-board': '\uf2e7',
        'chess-clock-alt': '\uf2e8',
        'chess-clock': '\uf2e9',
        'chess-king-alt': '\uf2ea',
        'chess-king': '\uf2eb',
        'chess-knight-alt': '\uf2ec',
        'chess-knight': '\uf2ed',
        'chess-pawn-alt': '\uf2ee',
        'chess-pawn': '\uf2ef',
        'chess-piece': '\uf2f0',
        'chess-queen-alt': '\uf2f1',
        'chess-queen': '\uf2f2',
        'chess-rook-alt': '\uf2f3',
        'chess-rook': '\uf2f4',
        chess: '\uf2f5',
        'chevron-double-down': '\uf2f6',
        'chevron-double-up': '\uf2f7',
        'child-head': '\uf2f8',
        chocolate: '\uf2f9',
        'circle-0': '\uf2fa',
        'circle-1': '\uf2fb',
        'circle-2': '\uf2fc',
        'circle-3': '\uf2fd',
        'circle-4': '\uf2fe',
        'circle-5': '\uf2ff',
        'circle-6': '\uf300',
        'circle-7': '\uf301',
        'circle-8': '\uf302',
        'circle-9': '\uf303',
        'circle-a': '\uf304',
        'circle-b': '\uf305',
        'circle-bolt': '\uf306',
        'circle-book-open': '\uf307',
        'circle-bookmark': '\uf308',
        'circle-c': '\uf309',
        'circle-calendar': '\uf30a',
        'circle-camera': '\uf30b',
        'circle-d': '\uf30c',
        'circle-dashed': '\uf30d',
        'circle-e': '\uf30e',
        'circle-ellipsis-vertical': '\uf30f',
        'circle-ellipsis': '\uf310',
        'circle-envelope': '\uf311',
        'circle-exclamation-check': '\uf312',
        'circle-f': '\uf313',
        'circle-g': '\uf314',
        'circle-h': '\uf315',
        'circle-half-stroke': '\uf316',
        'circle-half': '\uf317',
        'circle-heart': '\uf318',
        'circle-i': '\uf319',
        'circle-j': '\uf31a',
        'circle-k': '\uf31b',
        'circle-l': '\uf31c',
        'circle-m': '\uf31d',
        'circle-microphone-lines': '\uf31e',
        'circle-microphone': '\uf31f',
        'circle-n': '\uf320',
        'circle-o': '\uf321',
        'circle-p': '\uf322',
        'circle-phone-flip': '\uf323',
        'circle-phone-hangup': '\uf324',
        'circle-phone': '\uf325',
        'circle-q': '\uf326',
        'circle-quarter': '\uf327',
        'circle-quarters-alt': '\uf328',
        'circle-r': '\uf329',
        'circle-s': '\uf32a',
        'circle-small': '\uf32b',
        'circle-star': '\uf32c',
        'circle-t': '\uf32d',
        'circle-three-quarters': '\uf32e',
        'circle-trash': '\uf32f',
        'circle-u': '\uf330',
        'circle-user': '\uf331',
        'circle-v': '\uf332',
        'circle-video': '\uf333',
        'circle-w': '\uf334',
        'circle-waveform-lines': '\uf335',
        'circle-x': '\uf336',
        'circle-xmark': '\uf337',
        'circle-y': '\uf338',
        'circle-z': '\uf339',
        circle: '\uf33a',
        city: '\uf33b',
        'clapperboard-play': '\uf33c',
        clapperboard: '\uf33d',
        clarinet: '\uf33e',
        'claw-marks': '\uf33f',
        clip: '\uf340',
        'clipboard-list-check': '\uf341',
        'clipboard-list': '\uf342',
        'clipboard-prescription': '\uf343',
        'clipboard-user': '\uf344',
        clipboard: '\uf345',
        'clock-eight-thirty': '\uf346',
        'clock-eleven-thirty': '\uf347',
        'clock-eleven': '\uf348',
        'clock-five-thirty': '\uf349',
        'clock-five': '\uf34a',
        'clock-four-thirty': '\uf34b',
        'clock-nine-thirty': '\uf34c',
        'clock-nine': '\uf34d',
        'clock-one-thirty': '\uf34e',
        'clock-one': '\uf34f',
        'clock-seven-thirty': '\uf350',
        'clock-seven': '\uf351',
        'clock-six-thirty': '\uf352',
        'clock-six': '\uf353',
        'clock-ten-thirty': '\uf354',
        'clock-ten': '\uf355',
        'clock-three-thirty': '\uf356',
        'clock-three': '\uf357',
        'clock-twelve-thirty': '\uf358',
        'clock-twelve': '\uf359',
        'clock-two-thirty': '\uf35a',
        'clock-two': '\uf35b',
        clock: '\uf35c',
        clone: '\uf35d',
        'closed-captioning-slash': '\uf35e',
        'cloud-check': '\uf35f',
        'cloud-disabled': '\uf360',
        'cloud-download-alt': '\uf361',
        'cloud-download': '\uf362',
        'cloud-drizzle': '\uf363',
        'cloud-exclamation': '\uf364',
        'cloud-hail-mixed': '\uf365',
        'cloud-hail': '\uf366',
        'cloud-meatball': '\uf367',
        'cloud-moon-rain': '\uf368',
        'cloud-moon': '\uf369',
        'cloud-question': '\uf36a',
        'cloud-rain': '\uf36b',
        'cloud-rainbow': '\uf36c',
        'cloud-share': '\uf36d',
        'cloud-showers-heavy': '\uf36e',
        'cloud-showers': '\uf36f',
        'cloud-sleet': '\uf370',
        'cloud-snow': '\uf371',
        'cloud-sun-rain': '\uf372',
        'cloud-sun': '\uf373',
        'cloud-upload-alt': '\uf374',
        'cloud-upload': '\uf375',
        cloud: '\uf376',
        'clouds-moon': '\uf377',
        'clouds-sun': '\uf378',
        clouds: '\uf379',
        club: '\uf37a',
        'cocktail-alt': '\uf37b',
        cocktail: '\uf37c',
        'code-branch': '\uf37d',
        'code-commit': '\uf37e',
        'code-compare': '\uf37f',
        'code-fork': '\uf380',
        'code-merge': '\uf381',
        'code-pull-request-closed': '\uf382',
        'code-pull-request-draft': '\uf383',
        'code-pull-request': '\uf384',
        'code-simple': '\uf385',
        'coffee-bean': '\uf386',
        'coffee-beans': '\uf387',
        'coffee-pot': '\uf388',
        coffee: '\uf389',
        'coffin-cross': '\uf38a',
        coffin: '\uf38b',
        coin: '\uf38c',
        coins: '\uf38d',
        'colon-sign': '\uf38e',
        'columns-3': '\uf38f',
        comet: '\uf390',
        command: '\uf391',
        'comment-alt-check': '\uf392',
        'comment-alt-dots': '\uf393',
        'comment-alt-edit': '\uf394',
        'comment-alt-medical': '\uf395',
        'comment-alt-middle-top': '\uf396',
        'comment-alt-middle': '\uf397',
        'comment-alt-minus': '\uf398',
        'comment-alt-music': '\uf399',
        'comment-alt': '\uf39a',
        'comment-arrow-down': '\uf39b',
        'comment-arrow-up-right': '\uf39c',
        'comment-arrow-up': '\uf39d',
        'comment-check': '\uf39e',
        'comment-code': '\uf39f',
        'comment-dollar': '\uf3a0',
        'comment-dots': '\uf3a1',
        'comment-exclamation': '\uf3a2',
        'comment-heart': '\uf3a3',
        'comment-image': '\uf3a4',
        'comment-info': '\uf3a5',
        'comment-medical': '\uf3a6',
        'comment-minus': '\uf3a7',
        'comment-pen': '\uf3a8',
        'comment-question': '\uf3a9',
        'comment-quote': '\uf3aa',
        'comment-slash': '\uf3ab',
        'comment-smile': '\uf3ac',
        'comment-sms': '\uf3ad',
        'comment-text': '\uf3ae',
        'comment-user': '\uf3af',
        'comment-xmark': '\uf3b0',
        comment: '\uf3b1',
        'comments-dollar': '\uf3b2',
        'comments-question-check': '\uf3b3',
        'comments-question': '\uf3b4',
        comments: '\uf3b5',
        'compass-slash': '\uf3b6',
        'compress-alt': '\uf3b7',
        compress: '\uf3b8',
        'computer-speaker': '\uf3b9',
        computer: '\uf3ba',
        'concierge-bell': '\uf3bb',
        confetti: '\uf3bc',
        'cookie-alt': '\uf3bd',
        cookie: '\uf3be',
        'copy-alt': '\uf3bf',
        'copy-image': '\uf3c0',
        copy: '\uf3c1',
        copyright: '\uf3c2',
        corn: '\uf3c3',
        cow: '\uf3c4',
        'cowbell-circle-plus': '\uf3c5',
        'cowbell-more': '\uf3c6',
        cowbell: '\uf3c7',
        cream: '\uf3c8',
        'credit-card': '\uf3c9',
        cricket: '\uf3ca',
        croissant: '\uf3cb',
        'cross-circle': '\uf3cc',
        'cross-religion': '\uf3cd',
        'cross-small': '\uf3ce',
        cross: '\uf3cf',
        crown: '\uf3d0',
        crutch: '\uf3d1',
        crutches: '\uf3d2',
        'cruzeiro-sign': '\uf3d3',
        'crystal-ball': '\uf3d4',
        cube: '\uf3d5',
        cubes: '\uf3d6',
        cupcake: '\uf3d7',
        curling: '\uf3d8',
        'cursor-finger': '\uf3d9',
        'cursor-plus': '\uf3da',
        'cursor-text-alt': '\uf3db',
        'cursor-text': '\uf3dc',
        cursor: '\uf3dd',
        d: '\uf3de',
        dart: '\uf3df',
        dashboard: '\uf3e0',
        'data-transfer': '\uf3e1',
        database: '\uf3e2',
        'delete-document': '\uf3e3',
        'delete-right': '\uf3e4',
        'delete-user': '\uf3e5',
        delete: '\uf3e6',
        democrat: '\uf3e7',
        'desktop-wallpaper': '\uf3e8',
        devices: '\uf3e9',
        dewpoint: '\uf3ea',
        dharmachakra: '\uf3eb',
        'diagram-cells': '\uf3ec',
        'diagram-lean-canvas': '\uf3ed',
        'diagram-nested': '\uf3ee',
        'diagram-next': '\uf3ef',
        'diagram-predecessor': '\uf3f0',
        'diagram-previous': '\uf3f1',
        'diagram-project': '\uf3f2',
        'diagram-sankey': '\uf3f3',
        'diagram-subtask': '\uf3f4',
        'diagram-successor': '\uf3f5',
        'diagram-venn': '\uf3f6',
        'dial-high': '\uf3f7',
        'dial-low': '\uf3f8',
        'dial-max': '\uf3f9',
        'dial-med-low': '\uf3fa',
        'dial-med': '\uf3fb',
        'dial-min': '\uf3fc',
        'dial-off': '\uf3fd',
        dial: '\uf3fe',
        'diamond-exclamation': '\uf3ff',
        'diamond-turn-right': '\uf400',
        diamond: '\uf401',
        'dice-alt': '\uf402',
        'dice-d10': '\uf403',
        'dice-d12': '\uf404',
        'dice-d20': '\uf405',
        'dice-d4': '\uf406',
        'dice-d6': '\uf407',
        'dice-d8': '\uf408',
        'dice-four': '\uf409',
        'dice-one': '\uf40a',
        'dice-six': '\uf40b',
        'dice-three': '\uf40c',
        'dice-two': '\uf40d',
        dice: '\uf40e',
        diploma: '\uf40f',
        disease: '\uf410',
        disk: '\uf411',
        'display-code': '\uf412',
        'distribute-spacing-horizontal': '\uf413',
        'distribute-spacing-vertical': '\uf414',
        dizzy: '\uf415',
        dna: '\uf416',
        doctor: '\uf417',
        'document-signed': '\uf418',
        document: '\uf419',
        dollar: '\uf41a',
        donate: '\uf41b',
        'dong-sign': '\uf41c',
        'door-closed': '\uf41d',
        'door-open': '\uf41e',
        'dot-circle': '\uf41f',
        'down-left-and-up-right-to-center': '\uf420',
        'down-left': '\uf421',
        'down-right': '\uf422',
        'down-to-line': '\uf423',
        down: '\uf424',
        download: '\uf425',
        'drafting-compass': '\uf426',
        'draw-polygon': '\uf427',
        'draw-square': '\uf428',
        dreidel: '\uf429',
        'drink-alt': '\uf42a',
        'drone-front': '\uf42b',
        'drum-steelpan': '\uf42c',
        drum: '\uf42d',
        'drumstick-bite': '\uf42e',
        drumstick: '\uf42f',
        dungeon: '\uf430',
        duplicate: '\uf431',
        'e-learning': '\uf432',
        e: '\uf433',
        'ear-deaf': '\uf434',
        'ear-muffs': '\uf435',
        ear: '\uf436',
        earnings: '\uf437',
        'earth-africa': '\uf438',
        'earth-americas': '\uf439',
        'earth-asia': '\uf43a',
        'earth-europa': '\uf43b',
        'eclipse-alt': '\uf43c',
        eclipse: '\uf43d',
        'edit-alt': '\uf43e',
        edit: '\uf43f',
        'egg-fried': '\uf440',
        egg: '\uf441',
        eject: '\uf442',
        elevator: '\uf443',
        'engine-warning': '\uf444',
        enter: '\uf445',
        entertainment: '\uf446',
        'envelope-ban': '\uf447',
        'envelope-bulk': '\uf448',
        'envelope-dot': '\uf449',
        'envelope-download': '\uf44a',
        'envelope-marker': '\uf44b',
        'envelope-open-dollar': '\uf44c',
        'envelope-open-text': '\uf44d',
        'envelope-open': '\uf44e',
        'envelope-plus': '\uf44f',
        envelope: '\uf450',
        envelopes: '\uf451',
        equipment: '\uf452',
        eraser: '\uf453',
        escalator: '\uf454',
        euro: '\uf455',
        'exchange-alt': '\uf456',
        exchange: '\uf457',
        exclamation: '\uf458',
        exit: '\uf459',
        'expand-arrows-alt': '\uf45a',
        'expand-arrows': '\uf45b',
        expand: '\uf45c',
        'eye-crossed': '\uf45d',
        'eye-dropper-half': '\uf45e',
        eye: '\uf45f',
        eyes: '\uf460',
        f: '\uf461',
        'face-angry-horns': '\uf462',
        'face-anguished': '\uf463',
        'face-anxious-sweat': '\uf464',
        'face-astonished': '\uf465',
        'face-awesome': '\uf466',
        'face-beam-hand-over-mouth': '\uf467',
        'face-confounded': '\uf468',
        'face-confused': '\uf469',
        'face-cowboy-hat': '\uf46a',
        'face-disappointed': '\uf46b',
        'face-disguise': '\uf46c',
        'face-downcast-sweat': '\uf46d',
        'face-drooling': '\uf46e',
        'face-explode': '\uf46f',
        'face-expressionless': '\uf470',
        'face-eyes-xmarks': '\uf471',
        'face-fearful': '\uf472',
        'face-glasses': '\uf473',
        'face-grin-tongue-wink': '\uf474',
        'face-hand-yawn': '\uf475',
        'face-head-bandage': '\uf476',
        'face-hushed': '\uf477',
        'face-icicles': '\uf478',
        'face-lying': '\uf479',
        'face-mask': '\uf47a',
        'face-monocle': '\uf47b',
        'face-nauseated': '\uf47c',
        'face-nose-steam': '\uf47d',
        'face-party': '\uf47e',
        'face-pensive': '\uf47f',
        'face-persevering': '\uf480',
        'face-pleading': '\uf481',
        'face-raised-eyebrow': '\uf482',
        'face-relieved': '\uf483',
        'face-sad-sweat': '\uf484',
        'face-scream': '\uf485',
        'face-shush': '\uf486',
        'face-sleeping': '\uf487',
        'face-sleepy': '\uf488',
        'face-smile-halo': '\uf489',
        'face-smile-hearts': '\uf48a',
        'face-smile-horns': '\uf48b',
        'face-smile-tear': '\uf48c',
        'face-smile-tongue': '\uf48d',
        'face-smile-upside-down': '\uf48e',
        'face-smiling-hands': '\uf48f',
        'face-smirking': '\uf490',
        'face-sunglasses': '\uf491',
        'face-swear': '\uf492',
        'face-thermometer': '\uf493',
        'face-thinking': '\uf494',
        'face-tissue': '\uf495',
        'face-tongue-money': '\uf496',
        'face-tongue-sweat': '\uf497',
        'face-unamused': '\uf498',
        'face-viewfinder': '\uf499',
        'face-vomit': '\uf49a',
        'face-weary': '\uf49b',
        'face-woozy': '\uf49c',
        'face-worried': '\uf49d',
        'face-zany': '\uf49e',
        'face-zipper': '\uf49f',
        farm: '\uf4a0',
        fax: '\uf4a1',
        'feather-pointed': '\uf4a2',
        feather: '\uf4a3',
        fence: '\uf4a4',
        'field-hockey': '\uf4a5',
        'fighter-jet': '\uf4a6',
        'file-ai': '\uf4a7',
        'file-audio': '\uf4a8',
        'file-binary': '\uf4a9',
        'file-chart-line': '\uf4aa',
        'file-chart-pie': '\uf4ab',
        'file-circle-info': '\uf4ac',
        'file-code': '\uf4ad',
        'file-csv': '\uf4ae',
        'file-download': '\uf4af',
        'file-edit': '\uf4b0',
        'file-eps': '\uf4b1',
        'file-excel': '\uf4b2',
        'file-exclamation': '\uf4b3',
        'file-export': '\uf4b4',
        'file-image': '\uf4b5',
        'file-import': '\uf4b6',
        'file-invoice-dollar': '\uf4b7',
        'file-invoice': '\uf4b8',
        'file-medical-alt': '\uf4b9',
        'file-medical': '\uf4ba',
        'file-minus': '\uf4bb',
        'file-pdf': '\uf4bc',
        'file-powerpoint': '\uf4bd',
        'file-prescription': '\uf4be',
        'file-psd': '\uf4bf',
        'file-signature': '\uf4c0',
        'file-spreadsheet': '\uf4c1',
        'file-upload': '\uf4c2',
        'file-user': '\uf4c3',
        'file-video': '\uf4c4',
        'file-word': '\uf4c5',
        'file-zipper': '\uf4c6',
        file: '\uf4c7',
        'files-medical': '\uf4c8',
        fill: '\uf4c9',
        'film-canister': '\uf4ca',
        'film-slash': '\uf4cb',
        film: '\uf4cc',
        films: '\uf4cd',
        'filter-slash': '\uf4ce',
        filter: '\uf4cf',
        filters: '\uf4d0',
        fingerprint: '\uf4d1',
        'fire-flame-curved': '\uf4d2',
        'fire-smoke': '\uf4d3',
        'fish-cooked': '\uf4d4',
        fish: '\uf4d5',
        'fishing-rod': '\uf4d6',
        'flag-alt': '\uf4d7',
        'flag-checkered': '\uf4d8',
        'flag-usa': '\uf4d9',
        flag: '\uf4da',
        flame: '\uf4db',
        'flask-poison': '\uf4dc',
        'flask-potion': '\uf4dd',
        'flip-horizontal': '\uf4de',
        'floppy-disk-circle-arrow-right': '\uf4df',
        'floppy-disk-circle-xmark': '\uf4e0',
        'florin-sign': '\uf4e1',
        'flower-daffodil': '\uf4e2',
        'flower-tulip': '\uf4e3',
        flower: '\uf4e4',
        flushed: '\uf4e5',
        flute: '\uf4e6',
        'flux-capacitor': '\uf4e7',
        fog: '\uf4e8',
        'folder-download': '\uf4e9',
        'folder-minus': '\uf4ea',
        'folder-open': '\uf4eb',
        'folder-times': '\uf4ec',
        'folder-tree': '\uf4ed',
        'folder-upload': '\uf4ee',
        'folder-xmark': '\uf4ef',
        folder: '\uf4f0',
        folders: '\uf4f1',
        'follow-folder': '\uf4f2',
        followcollection: '\uf4f3',
        following: '\uf4f4',
        football: '\uf4f5',
        fork: '\uf4f6',
        form: '\uf4f7',
        fort: '\uf4f8',
        'forward-fast': '\uf4f9',
        forward: '\uf4fa',
        fox: '\uf4fb',
        'franc-sign': '\uf4fc',
        'french-fries': '\uf4fd',
        frown: '\uf4fe',
        ftp: '\uf4ff',
        'funnel-dollar': '\uf500',
        g: '\uf501',
        galaxy: '\uf502',
        'gallery-thumbnails': '\uf503',
        gallery: '\uf504',
        'game-board-alt': '\uf505',
        game: '\uf506',
        gamepad: '\uf507',
        games: '\uf508',
        'garage-car': '\uf509',
        'garage-open': '\uf50a',
        garage: '\uf50b',
        garlic: '\uf50c',
        'gas-pump-alt': '\uf50d',
        'gas-pump-slash': '\uf50e',
        'gas-pump': '\uf50f',
        gavel: '\uf510',
        gears: '\uf511',
        gem: '\uf512',
        ghost: '\uf513',
        'gif-square': '\uf514',
        gif: '\uf515',
        'gift-card': '\uf516',
        gift: '\uf517',
        gifts: '\uf518',
        'gingerbread-man': '\uf519',
        'glass-champagne': '\uf51a',
        'glass-cheers': '\uf51b',
        'glass-citrus': '\uf51c',
        'glass-whiskey-rocks': '\uf51d',
        'glass-whiskey': '\uf51e',
        glass: '\uf51f',
        glasses: '\uf520',
        'globe-alt': '\uf521',
        'globe-snow': '\uf522',
        globe: '\uf523',
        'golf-ball': '\uf524',
        'golf-club': '\uf525',
        golf: '\uf526',
        'graduation-cap': '\uf527',
        gramophone: '\uf528',
        grape: '\uf529',
        'graphic-style': '\uf52a',
        'graphic-tablet': '\uf52b',
        'grid-alt': '\uf52c',
        'grid-dividers': '\uf52d',
        grid: '\uf52e',
        grill: '\uf52f',
        grimace: '\uf530',
        'grin-alt': '\uf531',
        'grin-beam-sweat': '\uf532',
        'grin-beam': '\uf533',
        'grin-hearts': '\uf534',
        'grin-squint-tears': '\uf535',
        'grin-squint': '\uf536',
        'grin-stars': '\uf537',
        'grin-tears': '\uf538',
        'grin-tongue-squint': '\uf539',
        'grin-tongue-wink': '\uf53a',
        'grin-tongue': '\uf53b',
        'grin-wink': '\uf53c',
        grin: '\uf53d',
        'grip-dots-vertical': '\uf53e',
        'grip-dots': '\uf53f',
        'grip-horizontal': '\uf540',
        'grip-lines-vertical': '\uf541',
        'grip-lines': '\uf542',
        'grip-vertical': '\uf543',
        'guarani-sign': '\uf544',
        'guitar-electric': '\uf545',
        guitar: '\uf546',
        guitars: '\uf547',
        gym: '\uf548',
        'h-square': '\uf549',
        h: '\uf54a',
        h1: '\uf54b',
        h2: '\uf54c',
        h3: '\uf54d',
        h4: '\uf54e',
        'hamburger-soda': '\uf54f',
        hamburger: '\uf550',
        'hammer-crash': '\uf551',
        'hammer-war': '\uf552',
        hammer: '\uf553',
        'hand-back-fist': '\uf554',
        'hand-back-point-down': '\uf555',
        'hand-back-point-left': '\uf556',
        'hand-back-point-ribbon': '\uf557',
        'hand-back-point-right': '\uf558',
        'hand-dots': '\uf559',
        'hand-fingers-crossed': '\uf55a',
        'hand-heart': '\uf55b',
        'hand-holding-box': '\uf55c',
        'hand-holding-heart': '\uf55d',
        'hand-holding-medical': '\uf55e',
        'hand-holding-seeding': '\uf55f',
        'hand-holding-skull': '\uf560',
        'hand-holding-usd': '\uf561',
        'hand-holding-water': '\uf562',
        'hand-horns': '\uf563',
        'hand-lizard': '\uf564',
        'hand-love': '\uf565',
        'hand-middle-finger': '\uf566',
        'hand-paper': '\uf567',
        'hand-peace': '\uf568',
        'hand-point-ribbon': '\uf569',
        'hand-scissors': '\uf56a',
        'hand-sparkles': '\uf56b',
        'hand-spock': '\uf56c',
        'hand-wave': '\uf56d',
        'hands-bubbles': '\uf56e',
        'hands-clapping': '\uf56f',
        'hands-holding-diamond': '\uf570',
        'hands-holding': '\uf571',
        'hands-usd': '\uf572',
        'handshake-angle': '\uf573',
        'handshake-simple-slash': '\uf574',
        handshake: '\uf575',
        hastag: '\uf576',
        'hat-birthday': '\uf577',
        'hat-chef': '\uf578',
        'hat-santa': '\uf579',
        'hat-witch': '\uf57a',
        'hat-wizard': '\uf57b',
        hdd: '\uf57c',
        'head-side-brain': '\uf57d',
        'head-side-cough-slash': '\uf57e',
        'head-side-cough': '\uf57f',
        'head-side-headphones': '\uf580',
        'head-side-heart': '\uf581',
        'head-side-mask': '\uf582',
        'head-side-medical': '\uf583',
        'head-side-thinking': '\uf584',
        'head-side-virus': '\uf585',
        'head-side': '\uf586',
        'head-vr': '\uf587',
        heading: '\uf588',
        headphones: '\uf589',
        headset: '\uf58a',
        'heart-arrow': '\uf58b',
        'heart-crack': '\uf58c',
        'heart-half-stroke': '\uf58d',
        'heart-half': '\uf58e',
        'heart-rate': '\uf58f',
        heart: '\uf590',
        heat: '\uf591',
        'helicopter-side': '\uf592',
        'hexagon-check': '\uf593',
        'hexagon-exclamation': '\uf594',
        hexagon: '\uf595',
        'high-definition': '\uf596',
        'highlighter-line': '\uf597',
        highlighter: '\uf598',
        hiking: '\uf599',
        'hockey-mask': '\uf59a',
        'hockey-puck': '\uf59b',
        'hockey-sticks': '\uf59c',
        'holly-berry': '\uf59d',
        'home-heart': '\uf59e',
        'home-location-alt': '\uf59f',
        'home-location': '\uf5a0',
        home: '\uf5a1',
        'hood-cloak': '\uf5a2',
        'horizontal-rule': '\uf5a3',
        'hospital-symbol': '\uf5a4',
        'hospital-user': '\uf5a5',
        hospital: '\uf5a6',
        hospitals: '\uf5a7',
        'hot-tub': '\uf5a8',
        hotdog: '\uf5a9',
        hotel: '\uf5aa',
        'hourglass-end': '\uf5ab',
        'hourglass-start': '\uf5ac',
        hourglass: '\uf5ad',
        'house-blank': '\uf5ae',
        'house-building': '\uf5af',
        'house-chimney-blank': '\uf5b0',
        'house-chimney-crack': '\uf5b1',
        'house-chimney-medical': '\uf5b2',
        'house-chimney-window': '\uf5b3',
        'house-chimney': '\uf5b4',
        'house-crack': '\uf5b5',
        'house-flood': '\uf5b6',
        'house-laptop': '\uf5b7',
        'house-medical': '\uf5b8',
        'house-tree': '\uf5b9',
        'house-turret': '\uf5ba',
        'house-window': '\uf5bb',
        hryvnia: '\uf5bc',
        humidity: '\uf5bd',
        'hundred-points': '\uf5be',
        hurricane: '\uf5bf',
        i: '\uf5c0',
        'ice-cream': '\uf5c1',
        icicles: '\uf5c2',
        'icon-star': '\uf5c3',
        'id-badge': '\uf5c4',
        'id-card-clip-alt': '\uf5c5',
        igloo: '\uf5c6',
        'image-slash': '\uf5c7',
        'images-user': '\uf5c8',
        images: '\uf5c9',
        'inbox-in': '\uf5ca',
        'inbox-out': '\uf5cb',
        inbox: '\uf5cc',
        inboxes: '\uf5cd',
        incognito: '\uf5ce',
        indent: '\uf5cf',
        'indian-rupee-sign': '\uf5d0',
        'industry-windows': '\uf5d1',
        infinity: '\uf5d2',
        info: '\uf5d3',
        information: '\uf5d4',
        inhaler: '\uf5d5',
        'input-numeric': '\uf5d6',
        'input-pipe': '\uf5d7',
        'input-text': '\uf5d8',
        interactive: '\uf5d9',
        interlining: '\uf5da',
        interrogation: '\uf5db',
        'island-tropical': '\uf5dc',
        'italian-lira-sign': '\uf5dd',
        italic: '\uf5de',
        j: '\uf5df',
        jam: '\uf5e0',
        joint: '\uf5e1',
        joystick: '\uf5e2',
        jpg: '\uf5e3',
        jug: '\uf5e4',
        k: '\uf5e5',
        kazoo: '\uf5e6',
        kerning: '\uf5e7',
        'key-skeleton-left-right': '\uf5e8',
        key: '\uf5e9',
        'keyboard-brightness-low': '\uf5ea',
        'keyboard-brightness': '\uf5eb',
        keyboard: '\uf5ec',
        keynote: '\uf5ed',
        kidneys: '\uf5ee',
        'kip-sign': '\uf5ef',
        'kiss-beam': '\uf5f0',
        'kiss-wink-heart': '\uf5f1',
        kiss: '\uf5f2',
        kite: '\uf5f3',
        'knife-kitchen': '\uf5f4',
        knife: '\uf5f5',
        l: '\uf5f6',
        label: '\uf5f7',
        'landmark-alt': '\uf5f8',
        language: '\uf5f9',
        'laptop-code': '\uf5fa',
        'laptop-medical': '\uf5fb',
        'laptop-mobile': '\uf5fc',
        laptop: '\uf5fd',
        'lari-sign': '\uf5fe',
        'lasso-sparkles': '\uf5ff',
        lasso: '\uf600',
        'laugh-beam': '\uf601',
        'laugh-squint': '\uf602',
        'laugh-wink': '\uf603',
        laugh: '\uf604',
        'layer-minus': '\uf605',
        'layer-plus': '\uf606',
        layers: '\uf607',
        'layout-fluid': '\uf608',
        'leaf-heart': '\uf609',
        'leaf-maple': '\uf60a',
        'leaf-oak': '\uf60b',
        leaf: '\uf60c',
        left: '\uf60d',
        lemon: '\uf60e',
        'letter-case': '\uf60f',
        lettuce: '\uf610',
        'level-down-alt': '\uf611',
        'level-down': '\uf612',
        'level-up-alt': '\uf613',
        'level-up': '\uf614',
        license: '\uf615',
        'life-ring': '\uf616',
        'light-emergency-on': '\uf617',
        'light-emergency': '\uf618',
        'light-switch-off': '\uf619',
        'light-switch-on': '\uf61a',
        'light-switch': '\uf61b',
        'lightbulb-dollar': '\uf61c',
        'lightbulb-exclamation': '\uf61d',
        'lightbulb-question': '\uf61e',
        'lightbulb-slash': '\uf61f',
        'lights-holiday': '\uf620',
        'line-width': '\uf621',
        'link-alt': '\uf622',
        'link-horizontal-slash': '\uf623',
        'link-horizontal': '\uf624',
        'link-slash-alt': '\uf625',
        'link-slash': '\uf626',
        link: '\uf627',
        lips: '\uf628',
        lipstick: '\uf629',
        'lira-sign': '\uf62a',
        'list-check': '\uf62b',
        'list-dropdown': '\uf62c',
        'list-music': '\uf62d',
        'list-timeline': '\uf62e',
        list: '\uf62f',
        'litecoin-sign': '\uf630',
        loading: '\uf631',
        'location-alt': '\uf632',
        'location-crosshairs-slash': '\uf633',
        'location-crosshairs': '\uf634',
        'location-dot-slash': '\uf635',
        'location-exclamation': '\uf636',
        'lock-alt': '\uf637',
        lock: '\uf638',
        'low-vision': '\uf639',
        luchador: '\uf63a',
        'luggage-cart': '\uf63b',
        'luggage-rolling': '\uf63c',
        'lungs-virus': '\uf63d',
        lungs: '\uf63e',
        m: '\uf63f',
        mailbox: '\uf640',
        'makeup-brush': '\uf641',
        'man-head': '\uf642',
        'manat-sign': '\uf643',
        mandolin: '\uf644',
        'map-marker-check': '\uf645',
        'map-marker-cross': '\uf646',
        'map-marker-edit': '\uf647',
        'map-marker-home': '\uf648',
        'map-marker-minus': '\uf649',
        'map-marker-plus': '\uf64a',
        'map-marker-question': '\uf64b',
        'map-marker-slash': '\uf64c',
        'map-marker-smile': '\uf64d',
        'map-marker': '\uf64e',
        'map-pin': '\uf64f',
        map: '\uf650',
        'marker-time': '\uf651',
        marker: '\uf652',
        'mars-double': '\uf653',
        'mars-stroke-right': '\uf654',
        'mars-stroke-up': '\uf655',
        mars: '\uf656',
        'mask-carnival': '\uf657',
        'mask-face': '\uf658',
        meat: '\uf659',
        'medical-star': '\uf65a',
        medicine: '\uf65b',
        megaphone: '\uf65c',
        'meh-blank': '\uf65d',
        'meh-rolling-eyes': '\uf65e',
        meh: '\uf65f',
        melon: '\uf660',
        'memo-circle-check': '\uf661',
        'memo-pad': '\uf662',
        memo: '\uf663',
        memory: '\uf664',
        'menu-burger': '\uf665',
        'menu-dots-vertical': '\uf666',
        'menu-dots': '\uf667',
        mercury: '\uf668',
        'message-arrow-down': '\uf669',
        'message-arrow-up-right': '\uf66a',
        'message-arrow-up': '\uf66b',
        'message-bot': '\uf66c',
        'message-code': '\uf66d',
        'message-dollar': '\uf66e',
        'message-image': '\uf66f',
        'message-question': '\uf670',
        'message-quote': '\uf671',
        'message-slash': '\uf672',
        'message-sms': '\uf673',
        'message-text': '\uf674',
        'message-xmark': '\uf675',
        'messages-dollar': '\uf676',
        'messages-question': '\uf677',
        messages: '\uf678',
        meteor: '\uf679',
        microchip: '\uf67a',
        'microphone-alt': '\uf67b',
        'microphone-slash': '\uf67c',
        microphone: '\uf67d',
        microscope: '\uf67e',
        'mill-sign': '\uf67f',
        'mind-share': '\uf680',
        'minus-circle': '\uf681',
        'minus-hexagon': '\uf682',
        'minus-small': '\uf683',
        minus: '\uf684',
        mistletoe: '\uf685',
        'mobile-button': '\uf686',
        'mobile-notch': '\uf687',
        mobile: '\uf688',
        mockup: '\uf689',
        'mode-landscape': '\uf68a',
        'mode-portrait': '\uf68b',
        'money-bill-simple': '\uf68c',
        'money-bill-wave-alt': '\uf68d',
        'money-bill-wave': '\uf68e',
        'money-bills-simple': '\uf68f',
        'money-bills': '\uf690',
        'money-check-edit-alt': '\uf691',
        'money-check-edit': '\uf692',
        'money-check': '\uf693',
        'money-from-bracket': '\uf694',
        'money-simple-from-bracket': '\uf695',
        money: '\uf696',
        monument: '\uf697',
        'moon-stars': '\uf698',
        moon: '\uf699',
        'mortar-pestle': '\uf69a',
        motorcycle: '\uf69b',
        mountain: '\uf69c',
        mountains: '\uf69d',
        mouse: '\uf69e',
        'move-to-folder-2': '\uf69f',
        'move-to-folder': '\uf6a0',
        'mp3-player': '\uf6a1',
        'mug-alt': '\uf6a2',
        'mug-hot-alt': '\uf6a3',
        'mug-hot': '\uf6a4',
        'mug-marshmallows': '\uf6a5',
        'mug-tea': '\uf6a6',
        mug: '\uf6a7',
        mushroom: '\uf6a8',
        'music-alt-slash': '\uf6a9',
        'music-alt': '\uf6aa',
        'music-file': '\uf6ab',
        'music-note': '\uf6ac',
        'music-slash': '\uf6ad',
        music: '\uf6ae',
        n: '\uf6af',
        'naira-sign': '\uf6b0',
        navigation: '\uf6b1',
        'network-cloud': '\uf6b2',
        network: '\uf6b3',
        neuter: '\uf6b4',
        'nfc-lock': '\uf6b5',
        'nfc-magnifying-glass': '\uf6b6',
        'nfc-pen': '\uf6b7',
        'nfc-slash': '\uf6b8',
        'nfc-trash': '\uf6b9',
        nfc: '\uf6ba',
        'no-people': '\uf6bb',
        noodles: '\uf6bc',
        notdef: '\uf6bd',
        'note-medical': '\uf6be',
        'note-sticky': '\uf6bf',
        note: '\uf6c0',
        'notebook-alt': '\uf6c1',
        notebook: '\uf6c2',
        'notes-medical': '\uf6c3',
        notes: '\uf6c4',
        o: '\uf6c5',
        'object-exclude': '\uf6c6',
        'object-group': '\uf6c7',
        'object-intersect': '\uf6c8',
        'object-subtract': '\uf6c9',
        'object-ungroup': '\uf6ca',
        'object-union': '\uf6cb',
        'objects-column': '\uf6cc',
        octagon: '\uf6cd',
        'oil-can': '\uf6ce',
        'oil-temp': '\uf6cf',
        'olive-oil': '\uf6d0',
        olives: '\uf6d1',
        onion: '\uf6d2',
        opacity: '\uf6d3',
        ornament: '\uf6d4',
        outdent: '\uf6d5',
        overline: '\uf6d6',
        p: '\uf6d7',
        package: '\uf6d8',
        'page-break': '\uf6d9',
        pager: '\uf6da',
        'paint-roller': '\uf6db',
        paint: '\uf6dc',
        'paintbrush-pencil': '\uf6dd',
        palette: '\uf6de',
        pan: '\uf6df',
        panorama: '\uf6e0',
        'paper-plane-top': '\uf6e1',
        'paper-plane': '\uf6e2',
        'paperclip-vertical': '\uf6e3',
        'parachute-box': '\uf6e4',
        'paragraph-left': '\uf6e5',
        paragraph: '\uf6e6',
        'parking-circle-slash': '\uf6e7',
        'parking-circle': '\uf6e8',
        'parking-slash': '\uf6e9',
        parking: '\uf6ea',
        'party-bell': '\uf6eb',
        'party-horn': '\uf6ec',
        party: '\uf6ed',
        passport: '\uf6ee',
        password: '\uf6ef',
        paste: '\uf6f0',
        pattern: '\uf6f1',
        'pause-circle': '\uf6f2',
        pause: '\uf6f3',
        paw: '\uf6f4',
        peace: '\uf6f5',
        peach: '\uf6f6',
        'pen-circle': '\uf6f7',
        'pen-clip-slash': '\uf6f8',
        'pen-clip': '\uf6f9',
        'pen-fancy-slash': '\uf6fa',
        'pen-fancy': '\uf6fb',
        'pen-field': '\uf6fc',
        'pen-nib-slash': '\uf6fd',
        'pen-nib': '\uf6fe',
        'pen-slash': '\uf6ff',
        'pen-square': '\uf700',
        'pen-swirl': '\uf701',
        'pencil-paintbrush': '\uf702',
        'pencil-ruler': '\uf703',
        'pencil-slash': '\uf704',
        pencil: '\uf705',
        pennant: '\uf706',
        'people-arrows-left-right': '\uf707',
        'people-carry-box': '\uf708',
        'people-dress': '\uf709',
        'people-pants': '\uf70a',
        'people-poll': '\uf70b',
        people: '\uf70c',
        'pepper-hot': '\uf70d',
        pepper: '\uf70e',
        percentage: '\uf70f',
        'person-dolly-empty': '\uf710',
        'person-dolly': '\uf711',
        'person-dress-simple': '\uf712',
        'person-dress': '\uf713',
        'person-praying': '\uf714',
        'person-pregnant': '\uf715',
        'person-seat-reclined': '\uf716',
        'person-seat': '\uf717',
        'person-simple': '\uf718',
        'person-walking-with-cane': '\uf719',
        'peseta-sign': '\uf71a',
        'peso-sign': '\uf71b',
        pharmacy: '\uf71c',
        'phone-call': '\uf71d',
        'phone-cross': '\uf71e',
        'phone-flip': '\uf71f',
        'phone-office': '\uf720',
        'phone-pause': '\uf721',
        'phone-plus': '\uf722',
        'phone-slash': '\uf723',
        'photo-film-music': '\uf724',
        'photo-video': '\uf725',
        physics: '\uf726',
        Pi: '\uf727',
        'piano-keyboard': '\uf728',
        piano: '\uf729',
        picnic: '\uf72a',
        'picpeople-filled': '\uf72b',
        picpeople: '\uf72c',
        picture: '\uf72d',
        pie: '\uf72e',
        'piggy-bank': '\uf72f',
        pills: '\uf730',
        pineapple: '\uf731',
        'pipe-smoking': '\uf732',
        pipette: '\uf733',
        'pizza-slice': '\uf734',
        'plane-alt': '\uf735',
        'plane-arrival': '\uf736',
        'plane-departure': '\uf737',
        'plane-prop': '\uf738',
        'plane-tail': '\uf739',
        plane: '\uf73a',
        'planet-moon': '\uf73b',
        'planet-ringed': '\uf73c',
        plate: '\uf73d',
        'play-alt': '\uf73e',
        'play-circle': '\uf73f',
        'play-pause': '\uf740',
        play: '\uf741',
        'plus-hexagon': '\uf742',
        'plus-minus': '\uf743',
        'plus-small': '\uf744',
        plus: '\uf745',
        podcast: '\uf746',
        'podium-star': '\uf747',
        podium: '\uf748',
        'police-box': '\uf749',
        'poll-h': '\uf74a',
        'poo-bolt': '\uf74b',
        poo: '\uf74c',
        poop: '\uf74d',
        popcorn: '\uf74e',
        'portal-enter': '\uf74f',
        'portal-exit': '\uf750',
        portrait: '\uf751',
        pot: '\uf752',
        pound: '\uf753',
        power: '\uf754',
        'prescription-bottle-alt': '\uf755',
        'prescription-bottle-pill': '\uf756',
        'prescription-bottle': '\uf757',
        prescription: '\uf758',
        presentation: '\uf759',
        'print-magnifying-glass': '\uf75a',
        print: '\uf75b',
        procedures: '\uf75c',
        projector: '\uf75d',
        protractor: '\uf75e',
        pulse: '\uf75f',
        'pump-medical': '\uf760',
        'pumpkin-alt': '\uf761',
        pumpkin: '\uf762',
        'puzzle-alt': '\uf763',
        'puzzle-piece': '\uf764',
        pyramid: '\uf765',
        q: '\uf766',
        qrcode: '\uf767',
        'question-square': '\uf768',
        question: '\uf769',
        'quote-right': '\uf76a',
        r: '\uf76b',
        racquet: '\uf76c',
        radar: '\uf76d',
        'radiation-alt': '\uf76e',
        radiation: '\uf76f',
        'radio-alt': '\uf770',
        radio: '\uf771',
        radish: '\uf772',
        rainbow: '\uf773',
        raindrops: '\uf774',
        'ramp-loading': '\uf775',
        raygun: '\uf776',
        rec: '\uf777',
        receipt: '\uf778',
        'record-vinyl': '\uf779',
        'rectabgle-vertical': '\uf77a',
        'rectangle-barcode': '\uf77b',
        'rectangle-code': '\uf77c',
        'rectangle-horizontal': '\uf77d',
        'rectangle-list': '\uf77e',
        'rectangle-panoramic': '\uf77f',
        'rectangle-pro': '\uf780',
        'rectangle-vertical-history': '\uf781',
        'rectangle-vertical': '\uf782',
        'rectangle-xmark': '\uf783',
        'rectangles-mixed': '\uf784',
        recycle: '\uf785',
        'redo-alt': '\uf786',
        redo: '\uf787',
        reel: '\uf788',
        'reflect-horizontal': '\uf789',
        'reflect-vertical': '\uf78a',
        reflect: '\uf78b',
        refresh: '\uf78c',
        registered: '\uf78d',
        'remove-folder': '\uf78e',
        'remove-user': '\uf78f',
        replace: '\uf790',
        'reply-all': '\uf791',
        republican: '\uf792',
        resize: '\uf793',
        resources: '\uf794',
        restaurant: '\uf795',
        'restroom-simple': '\uf796',
        rewind: '\uf797',
        rhombus: '\uf798',
        ribbon: '\uf799',
        right: '\uf79a',
        'rings-wedding': '\uf79b',
        road: '\uf79c',
        'rocket-lunch': '\uf79d',
        rocket: '\uf79e',
        'roller-coaster': '\uf79f',
        'room-service': '\uf7a0',
        'rotate-exclamation': '\uf7a1',
        'rotate-left': '\uf7a2',
        'rotate-right': '\uf7a3',
        'route-highway': '\uf7a4',
        'route-interstate': '\uf7a5',
        route: '\uf7a6',
        'rss-alt': '\uf7a7',
        rss: '\uf7a8',
        'ruble-sign': '\uf7a9',
        'rugby-helmet': '\uf7aa',
        rugby: '\uf7ab',
        'ruler-combined': '\uf7ac',
        'ruler-horizontal': '\uf7ad',
        'ruler-triangle': '\uf7ae',
        'ruler-vertical': '\uf7af',
        running: '\uf7b0',
        'rupee-sign': '\uf7b1',
        'rupiah-sign': '\uf7b2',
        rv: '\uf7b3',
        s: '\uf7b4',
        'sack-dollar': '\uf7b5',
        sack: '\uf7b6',
        'sad-cry': '\uf7b7',
        'sad-tear': '\uf7b8',
        sad: '\uf7b9',
        sailboat: '\uf7ba',
        salad: '\uf7bb',
        'salt-pepper': '\uf7bc',
        sandwich: '\uf7bd',
        sauce: '\uf7be',
        sausage: '\uf7bf',
        'sax-hot': '\uf7c0',
        saxophone: '\uf7c1',
        scale: '\uf7c2',
        'scalpel-path': '\uf7c3',
        scalpel: '\uf7c4',
        scarecrow: '\uf7c5',
        'school-bus': '\uf7c6',
        school: '\uf7c7',
        scissors: '\uf7c8',
        screen: '\uf7c9',
        screencast: '\uf7ca',
        scribble: '\uf7cb',
        'scroll-torah': '\uf7cc',
        scrubber: '\uf7cd',
        scythe: '\uf7ce',
        'seal-exclamation': '\uf7cf',
        'seal-question': '\uf7d0',
        'search-alt': '\uf7d1',
        'search-dollar': '\uf7d2',
        'search-heart': '\uf7d3',
        'search-location': '\uf7d4',
        search: '\uf7d5',
        'seat-airline': '\uf7d6',
        seedling: '\uf7d7',
        select: '\uf7d8',
        'send-back': '\uf7d9',
        'send-backward': '\uf7da',
        'sensor-alert': '\uf7db',
        'sensor-fire': '\uf7dc',
        'sensor-on': '\uf7dd',
        'sensor-smoke': '\uf7de',
        sensor: '\uf7df',
        'settings-sliders': '\uf7e0',
        settings: '\uf7e1',
        'share-alt-square': '\uf7e2',
        'share-square': '\uf7e3',
        share: '\uf7e4',
        'shekel-sign': '\uf7e5',
        'shield-check': '\uf7e6',
        'shield-exclamation': '\uf7e7',
        'shield-interrogation': '\uf7e8',
        'shield-plus': '\uf7e9',
        'shield-virus': '\uf7ea',
        shield: '\uf7eb',
        'ship-side': '\uf7ec',
        ship: '\uf7ed',
        'shoe-prints': '\uf7ee',
        'shop-lock': '\uf7ef',
        'shop-slash': '\uf7f0',
        shop: '\uf7f1',
        'shopping-bag-add': '\uf7f2',
        'shopping-bag': '\uf7f3',
        'shopping-basket': '\uf7f4',
        'shopping-cart-add': '\uf7f5',
        'shopping-cart-check': '\uf7f6',
        'shopping-cart': '\uf7f7',
        shredder: '\uf7f8',
        shrimp: '\uf7f9',
        shuffle: '\uf7fa',
        'shuttle-van': '\uf7fb',
        shuttlecock: '\uf7fc',
        'sidebar-flip': '\uf7fd',
        sidebar: '\uf7fe',
        sigma: '\uf7ff',
        'sign-hanging': '\uf800',
        'sign-in-alt': '\uf801',
        'sign-out-alt': '\uf802',
        'signal-alt-1': '\uf803',
        'signal-alt-2': '\uf804',
        'signal-alt-slash': '\uf805',
        'signal-alt': '\uf806',
        'signal-bars-fair': '\uf807',
        'signal-bars-good': '\uf808',
        'signal-bars-weak': '\uf809',
        'signal-stream-slash': '\uf80a',
        'signal-stream': '\uf80b',
        'signature-lock': '\uf80c',
        'signature-slash': '\uf80d',
        signature: '\uf80e',
        sitemap: '\uf80f',
        skateboard: '\uf810',
        skating: '\uf811',
        skeleton: '\uf812',
        skewer: '\uf813',
        'ski-jump': '\uf814',
        'ski-lift': '\uf815',
        'skiing-nordic': '\uf816',
        skiing: '\uf817',
        'skull-crossbones': '\uf818',
        skull: '\uf819',
        slash: '\uf81a',
        sledding: '\uf81b',
        sleigh: '\uf81c',
        'sliders-h-square': '\uf81d',
        'sliders-v-square': '\uf81e',
        'sliders-v': '\uf81f',
        smartphone: '\uf820',
        'smile-beam': '\uf821',
        'smile-plus': '\uf822',
        'smile-wink': '\uf823',
        smile: '\uf824',
        'smiley-comment-alt': '\uf825',
        smog: '\uf826',
        smoke: '\uf827',
        'smoking-ban': '\uf828',
        smoking: '\uf829',
        snooze: '\uf82a',
        'snow-blowing': '\uf82b',
        snowboarding: '\uf82c',
        snowflake: '\uf82d',
        snowflakes: '\uf82e',
        'snowman-alt': '\uf82f',
        'snowman-head': '\uf830',
        snowmobile: '\uf831',
        snowplow: '\uf832',
        soap: '\uf833',
        'solar-system': '\uf834',
        'sort-alpha-down-alt': '\uf835',
        'sort-alpha-down': '\uf836',
        'sort-alpha-up-alt': '\uf837',
        'sort-alpha-up': '\uf838',
        'sort-alt': '\uf839',
        'sort-amount-down-alt': '\uf83a',
        'sort-amount-down': '\uf83b',
        'sort-amount-up-alt': '\uf83c',
        'sort-amount-up': '\uf83d',
        'sort-down': '\uf83e',
        'sort-numeric-down-alt': '\uf83f',
        'sort-numeric-down': '\uf840',
        'sort-shapes-down': '\uf841',
        'sort-shapes-up': '\uf842',
        'sort-size-down': '\uf843',
        'sort-size-up': '\uf844',
        sort: '\uf845',
        soup: '\uf846',
        spa: '\uf847',
        'space-shuttle': '\uf848',
        'space-station-moon-alt': '\uf849',
        'space-station-moon': '\uf84a',
        spade: '\uf84b',
        'spaghetti-monster-flying': '\uf84c',
        sparkles: '\uf84d',
        speaker: '\uf84e',
        speakers: '\uf84f',
        sphere: '\uf850',
        'spider-web': '\uf851',
        spinner: '\uf852',
        split: '\uf853',
        splotch: '\uf854',
        spoon: '\uf855',
        'spray-can': '\uf856',
        'square-0': '\uf857',
        'square-1': '\uf858',
        'square-2': '\uf859',
        'square-3': '\uf85a',
        'square-4': '\uf85b',
        'square-5': '\uf85c',
        'square-6': '\uf85d',
        'square-7': '\uf85e',
        'square-8': '\uf85f',
        'square-9': '\uf860',
        'square-a': '\uf861',
        'square-b': '\uf862',
        'square-bolt': '\uf863',
        'square-c': '\uf864',
        'square-code': '\uf865',
        'square-d': '\uf866',
        'square-dashed': '\uf867',
        'square-e': '\uf868',
        'square-ellipsis-vertical': '\uf869',
        'square-ellipsis': '\uf86a',
        'square-exclamation': '\uf86b',
        'square-f': '\uf86c',
        'square-g': '\uf86d',
        'square-h': '\uf86e',
        'square-heart': '\uf86f',
        'square-i': '\uf870',
        'square-info': '\uf871',
        'square-j': '\uf872',
        'square-k': '\uf873',
        'square-kanban': '\uf874',
        'square-l': '\uf875',
        'square-m': '\uf876',
        'square-minus': '\uf877',
        'square-n': '\uf878',
        'square-o': '\uf879',
        'square-p': '\uf87a',
        'square-phone-hangup': '\uf87b',
        'square-plus': '\uf87c',
        'square-poll-horizontal': '\uf87d',
        'square-poll-vertical': '\uf87e',
        'square-q': '\uf87f',
        'square-quote': '\uf880',
        'square-r': '\uf881',
        'square-root': '\uf882',
        'square-s': '\uf883',
        'square-small': '\uf884',
        'square-star': '\uf885',
        'square-t': '\uf886',
        'square-terminal': '\uf887',
        'square-u': '\uf888',
        'square-v': '\uf889',
        'square-w': '\uf88a',
        'square-x': '\uf88b',
        'square-y': '\uf88c',
        'square-z': '\uf88d',
        square: '\uf88e',
        squircle: '\uf88f',
        stamp: '\uf890',
        'standard-definition': '\uf891',
        'star-and-crescent': '\uf892',
        'star-christmas': '\uf893',
        'star-comment-alt': '\uf894',
        'star-exclamation': '\uf895',
        'star-octogram': '\uf896',
        'star-of-david': '\uf897',
        'star-sharp-half-stroke': '\uf898',
        'star-sharp-half': '\uf899',
        'star-shooting': '\uf89a',
        star: '\uf89b',
        starfighter: '\uf89c',
        stars: '\uf89d',
        stats: '\uf89e',
        steak: '\uf89f',
        'steering-wheel': '\uf8a0',
        'step-backward': '\uf8a1',
        'step-forward': '\uf8a2',
        'sterling-sign': '\uf8a3',
        stethoscope: '\uf8a4',
        sticker: '\uf8a5',
        stocking: '\uf8a6',
        stomach: '\uf8a7',
        'stop-circle': '\uf8a8',
        stop: '\uf8a9',
        stopwatch: '\uf8aa',
        'store-alt': '\uf8ab',
        'store-lock': '\uf8ac',
        'store-slash': '\uf8ad',
        strawberry: '\uf8ae',
        'street-view': '\uf8af',
        stretcher: '\uf8b0',
        strikethrough: '\uf8b1',
        stroopwafel: '\uf8b2',
        subscript: '\uf8b3',
        subtitles: '\uf8b4',
        subway: '\uf8b5',
        'suitcase-alt': '\uf8b6',
        summer: '\uf8b7',
        'sun-dust': '\uf8b8',
        sun: '\uf8b9',
        'sunrise-alt': '\uf8ba',
        sunrise: '\uf8bb',
        sunset: '\uf8bc',
        superscript: '\uf8bd',
        surfing: '\uf8be',
        surprise: '\uf8bf',
        sushi: '\uf8c0',
        swatchbook: '\uf8c1',
        swimmer: '\uf8c2',
        sword: '\uf8c3',
        symbol: '\uf8c4',
        symbols: '\uf8c5',
        syringe: '\uf8c6',
        t: '\uf8c7',
        'table-columns': '\uf8c8',
        'table-layout': '\uf8c9',
        'table-list': '\uf8ca',
        'table-picnic': '\uf8cb',
        'table-pivot': '\uf8cc',
        'table-rows': '\uf8cd',
        'table-tree': '\uf8ce',
        table: '\uf8cf',
        tablet: '\uf8d0',
        'tachometer-alt-average': '\uf8d1',
        'tachometer-alt-fastest': '\uf8d2',
        'tachometer-alt-slow': '\uf8d3',
        'tachometer-alt-slowest': '\uf8d4',
        'tachometer-average': '\uf8d5',
        'tachometer-fast': '\uf8d6',
        'tachometer-fastest': '\uf8d7',
        'tachometer-slow': '\uf8d8',
        'tachometer-slowest': '\uf8d9',
        tachometer: '\uf8da',
        taco: '\uf8db',
        tags: '\uf8dc',
        'tally-1': '\uf8dd',
        'tally-2': '\uf8de',
        'tally-3': '\uf8df',
        'tally-4': '\uf8e0',
        tally: '\uf8e1',
        target: '\uf8e2',
        'taxi-bus': '\uf8e3',
        taxi: '\uf8e4',
        'teddy-bear': '\uf8e5',
        'teeth-open': '\uf8e6',
        telescope: '\uf8e7',
        'temperature-down': '\uf8e8',
        'temperature-frigid': '\uf8e9',
        'temperature-high': '\uf8ea',
        'temperature-list': '\uf8eb',
        'temperature-low': '\uf8ec',
        'temperature-up': '\uf8ed',
        'template-alt': '\uf8ee',
        template: '\uf8ef',
        tenge: '\uf8f0',
        tennis: '\uf8f1',
        terminal: '\uf8f2',
        terrace: '\uf8f3',
        'test-tube': '\uf8f4',
        test: '\uf8f5',
        'text-check': '\uf8f6',
        'text-height': '\uf8f7',
        'text-shadow': '\uf8f8',
        'text-size': '\uf8f9',
        'text-slash': '\uf8fa',
        'text-width': '\uf8fb',
        text: '\uf8fc',
        'theater-masks': '\uf8fd',
        'thermometer-empty': '\uf8fe',
        'thermometer-full': '\uf8ff',
        'thermometer-half': '\uf900',
        'thermometer-quarter': '\uf901',
        'thermometer-three-quarters': '\uf902',
        theta: '\uf903',
        'thought-bubble': '\uf904',
        'thumbs-down': '\uf905',
        'thumbs-up': '\uf906',
        thumbtack: '\uf907',
        'thunderstorm-moon': '\uf908',
        'thunderstorm-sun': '\uf909',
        thunderstorm: '\uf90a',
        'ticket-airline': '\uf90b',
        'ticket-alt': '\uf90c',
        ticket: '\uf90d',
        'tickets-airline': '\uf90e',
        tilde: '\uf90f',
        'time-add': '\uf910',
        'time-check': '\uf911',
        'time-delete': '\uf912',
        'time-fast': '\uf913',
        'time-forward-sixty': '\uf914',
        'time-forward-ten': '\uf915',
        'time-forward': '\uf916',
        'time-half-past': '\uf917',
        'time-oclock': '\uf918',
        'time-past': '\uf919',
        'time-quarter-past': '\uf91a',
        'time-quarter-to': '\uf91b',
        'time-twenty-four': '\uf91c',
        'times-hexagon': '\uf91d',
        'tint-slash': '\uf91e',
        'tire-flat': '\uf91f',
        'tire-pressure-warning': '\uf920',
        'tire-rugged': '\uf921',
        tire: '\uf922',
        tired: '\uf923',
        'toggle-off': '\uf924',
        'toggle-on': '\uf925',
        'toilet-paper-blank': '\uf926',
        tomato: '\uf927',
        'tombstone-alt': '\uf928',
        tombstone: '\uf929',
        'tool-box': '\uf92a',
        'tool-crop': '\uf92b',
        'tool-marquee': '\uf92c',
        tooth: '\uf92d',
        toothbrush: '\uf92e',
        tornado: '\uf92f',
        'tower-control': '\uf930',
        tractor: '\uf931',
        trademark: '\uf932',
        'traffic-light-go': '\uf933',
        'traffic-light-slow': '\uf934',
        'traffic-light-stop': '\uf935',
        'traffic-light': '\uf936',
        trailer: '\uf937',
        'train-side': '\uf938',
        'train-subway-tunnel': '\uf939',
        'train-tram': '\uf93a',
        train: '\uf93b',
        tram: '\uf93c',
        transform: '\uf93d',
        'transporter-1': '\uf93e',
        'transporter-2': '\uf93f',
        'transporter-3': '\uf940',
        'transporter-4': '\uf941',
        'transporter-5': '\uf942',
        'transporter-6': '\uf943',
        'transporter-7': '\uf944',
        'transporter-empty': '\uf945',
        transporter: '\uf946',
        'trash-can-check': '\uf947',
        'trash-can-clock': '\uf948',
        'trash-can-list': '\uf949',
        'trash-can-plus': '\uf94a',
        'trash-can-slash': '\uf94b',
        'trash-check': '\uf94c',
        'trash-clock': '\uf94d',
        'trash-list': '\uf94e',
        'trash-plus': '\uf94f',
        'trash-restore-alt': '\uf950',
        'trash-restore': '\uf951',
        'trash-slash': '\uf952',
        'trash-undo-alt': '\uf953',
        'trash-undo': '\uf954',
        'trash-xmark': '\uf955',
        trash: '\uf956',
        'treasure-chest': '\uf957',
        treatment: '\uf958',
        'tree-christmas': '\uf959',
        'tree-deciduous': '\uf95a',
        tree: '\uf95b',
        trees: '\uf95c',
        'triangle-music': '\uf95d',
        'triangle-warning': '\uf95e',
        triangle: '\uf95f',
        'trophy-star': '\uf960',
        trophy: '\uf961',
        'truck-container': '\uf962',
        'truck-couch': '\uf963',
        'truck-loading': '\uf964',
        'truck-monster': '\uf965',
        'truck-moving': '\uf966',
        'truck-pickup': '\uf967',
        'truck-plow': '\uf968',
        'truck-ramp': '\uf969',
        'truck-side': '\uf96a',
        'truck-tow': '\uf96b',
        trumpet: '\uf96c',
        tty: '\uf96d',
        tubes: '\uf96e',
        'tugrik-sign': '\uf96f',
        turkey: '\uf970',
        turntable: '\uf971',
        'tv-music': '\uf972',
        typewriter: '\uf973',
        u: '\uf974',
        'ufo-beam': '\uf975',
        ufo: '\uf976',
        'umbrella-beach': '\uf977',
        umbrella: '\uf978',
        underline: '\uf979',
        'undo-alt': '\uf97a',
        undo: '\uf97b',
        'uniform-martial-arts': '\uf97c',
        'universal-access': '\uf97d',
        unlock: '\uf97e',
        'up-left': '\uf97f',
        'up-right': '\uf980',
        up: '\uf981',
        upload: '\uf982',
        'usb-pendrive': '\uf983',
        'usd-circle': '\uf984',
        'usd-square': '\uf985',
        'user-add': '\uf986',
        'user-alien': '\uf987',
        'user-astronaut': '\uf988',
        'user-crown': '\uf989',
        'user-gear': '\uf98a',
        'user-md-chat': '\uf98b',
        'user-md': '\uf98c',
        'user-nurse': '\uf98d',
        'user-pen': '\uf98e',
        'user-pilot-tie': '\uf98f',
        'user-pilot': '\uf990',
        'user-robot': '\uf991',
        'user-slash': '\uf992',
        'user-time': '\uf993',
        'user-visor': '\uf994',
        user: '\uf995',
        'users-alt': '\uf996',
        'users-gear': '\uf997',
        'users-medical': '\uf998',
        users: '\uf999',
        utensils: '\uf99a',
        v: '\uf99b',
        'value-absolute': '\uf99c',
        vault: '\uf99d',
        'vector-alt': '\uf99e',
        'vector-circle': '\uf99f',
        'vector-polygon': '\uf9a0',
        vector: '\uf9a1',
        'venus-double': '\uf9a2',
        'venus-mars': '\uf9a3',
        venus: '\uf9a4',
        'vest-patches': '\uf9a5',
        vest: '\uf9a6',
        'video-arrow-down-left': '\uf9a7',
        'video-arrow-up-right': '\uf9a8',
        'video-camera-alt': '\uf9a9',
        'video-camera': '\uf9aa',
        'video-plus': '\uf9ab',
        'video-slash': '\uf9ac',
        'virus-slash': '\uf9ad',
        virus: '\uf9ae',
        viruses: '\uf9af',
        voicemail: '\uf9b0',
        volcano: '\uf9b1',
        volleyball: '\uf9b2',
        'volume-down': '\uf9b3',
        'volume-mute': '\uf9b4',
        'volume-off': '\uf9b5',
        'volume-slash': '\uf9b6',
        volume: '\uf9b7',
        'vote-nay': '\uf9b8',
        'vote-yea': '\uf9b9',
        w: '\uf9ba',
        'wagon-covered': '\uf9bb',
        walker: '\uf9bc',
        'walkie-talkie': '\uf9bd',
        wallet: '\uf9be',
        'warehouse-alt': '\uf9bf',
        'watch-calculator': '\uf9c0',
        'watch-fitness': '\uf9c1',
        'watch-smart': '\uf9c2',
        watch: '\uf9c3',
        'water-bottle': '\uf9c4',
        'water-ladder': '\uf9c5',
        'water-lower': '\uf9c6',
        'water-rise': '\uf9c7',
        water: '\uf9c8',
        watermelon: '\uf9c9',
        'wave-sine': '\uf9ca',
        'wave-square': '\uf9cb',
        'wave-triangle': '\uf9cc',
        'waveform-path': '\uf9cd',
        waveform: '\uf9ce',
        'webcam-slash': '\uf9cf',
        webcam: '\uf9d0',
        wheat: '\uf9d1',
        'wheelchair-move': '\uf9d2',
        wheelchair: '\uf9d3',
        whistle: '\uf9d4',
        'wifi-1': '\uf9d5',
        'wifi-2': '\uf9d6',
        'wifi-alt': '\uf9d7',
        'wifi-exclamation': '\uf9d8',
        'wifi-slash': '\uf9d9',
        wifi: '\uf9da',
        'wind-warning': '\uf9db',
        wind: '\uf9dc',
        'window-alt': '\uf9dd',
        'window-maximize': '\uf9de',
        'window-minimize': '\uf9df',
        'window-restore': '\uf9e0',
        windsock: '\uf9e1',
        'wine-bottle': '\uf9e2',
        'wine-glass-crack': '\uf9e3',
        'woman-head': '\uf9e4',
        'won-sign': '\uf9e5',
        world: '\uf9e6',
        wreath: '\uf9e7',
        'wrench-simple': '\uf9e8',
        'x-ray': '\uf9e9',
        x: '\uf9ea',
        y: '\uf9eb',
        yen: '\uf9ec',
        'yin-yang': '\uf9ed',
        z: '\uf9ee',
        'zoom-in': '\uf9ef',
        'zoom-out': '\uf9f0',

        'roundies:airport-and-hotels-airconditioner': '\uea01',
        'roundies:airport-and-hotels-airplane-alert': '\uea02',
        'roundies:airport-and-hotels-airplane-computer': '\uea03',
        'roundies:airport-and-hotels-airplane-information': '\uea04',
        'roundies:airport-and-hotels-airplane-laptop': '\uea05',
        'roundies:airport-and-hotels-airplane-location': '\uea06',
        'roundies:airport-and-hotels-airplane-storage': '\uea07',
        'roundies:airport-and-hotels-airplane-ticket': '\uea08',
        'roundies:airport-and-hotels-airport-tower': '\uea09',
        'roundies:airport-and-hotels-alert-case': '\uea0a',
        'roundies:airport-and-hotels-arrival': '\uea0b',
        'roundies:airport-and-hotels-baggage-trolley': '\uea0c',
        'roundies:airport-and-hotels-bath': '\uea0d',
        'roundies:airport-and-hotels-bathrooms': '\uea0e',
        'roundies:airport-and-hotels-beach': '\uea0f',
        'roundies:airport-and-hotels-bed-one-person': '\uea10',
        'roundies:airport-and-hotels-bed-rating': '\uea11',
        'roundies:airport-and-hotels-bed-two-person': '\uea12',
        'roundies:airport-and-hotels-bed': '\uea13',
        'roundies:airport-and-hotels-buildings': '\uea14',
        'roundies:airport-and-hotels-cafe': '\uea15',
        'roundies:airport-and-hotels-changing-room': '\uea16',
        'roundies:airport-and-hotels-check-in-desk': '\uea17',
        'roundies:airport-and-hotels-chef-hat': '\uea18',
        'roundies:airport-and-hotels-chef': '\uea19',
        'roundies:airport-and-hotels-computer-hotel': '\uea1a',
        'roundies:airport-and-hotels-confirm-case': '\uea1b',
        'roundies:airport-and-hotels-currency-exchange': '\uea1c',
        'roundies:airport-and-hotels-departure': '\uea1d',
        'roundies:airport-and-hotels-desk': '\uea1e',
        'roundies:airport-and-hotels-do-not-disturb': '\uea1f',
        'roundies:airport-and-hotels-elevator': '\uea20',
        'roundies:airport-and-hotels-escalator-down': '\uea21',
        'roundies:airport-and-hotels-escalator-up': '\uea22',
        'roundies:airport-and-hotels-fan': '\uea23',
        'roundies:airport-and-hotels-front-desk': '\uea24',
        'roundies:airport-and-hotels-game': '\uea25',
        'roundies:airport-and-hotels-gym': '\uea26',
        'roundies:airport-and-hotels-heater': '\uea27',
        'roundies:airport-and-hotels-hospital-direction': '\uea28',
        'roundies:airport-and-hotels-hospital-location': '\uea29',
        'roundies:airport-and-hotels-hospital': '\uea2a',
        'roundies:airport-and-hotels-information-desk': '\uea2b',
        'roundies:airport-and-hotels-information': '\uea2c',
        'roundies:airport-and-hotels-international-airplane-travel': '\uea2d',
        'roundies:airport-and-hotels-international-plane-travel': '\uea2e',
        'roundies:airport-and-hotels-key-card': '\uea2f',
        'roundies:airport-and-hotels-key-case': '\uea30',
        'roundies:airport-and-hotels-laptop-hotel': '\uea31',
        'roundies:airport-and-hotels-laundry-service': '\uea32',
        'roundies:airport-and-hotels-location': '\uea33',
        'roundies:airport-and-hotels-locker': '\uea34',
        'roundies:airport-and-hotels-luggage-trolley': '\uea35',
        'roundies:airport-and-hotels-luggage': '\uea36',
        'roundies:airport-and-hotels-man': '\uea37',
        'roundies:airport-and-hotels-meeting-point': '\uea38',
        'roundies:airport-and-hotels-mobile-hotel': '\uea39',
        'roundies:airport-and-hotels-mobile-plane': '\uea3a',
        'roundies:airport-and-hotels-no-drinks': '\uea3b',
        'roundies:airport-and-hotels-no-group': '\uea3c',
        'roundies:airport-and-hotels-no-smoking': '\uea3d',
        'roundies:airport-and-hotels-no-weapons': '\uea3e',
        'roundies:airport-and-hotels-passport': '\uea3f',
        'roundies:airport-and-hotels-plane-airport': '\uea40',
        'roundies:airport-and-hotels-plane-calendar': '\uea41',
        'roundies:airport-and-hotels-plane-ticket': '\uea42',
        'roundies:airport-and-hotels-pool': '\uea43',
        'roundies:airport-and-hotels-prohibited': '\uea44',
        'roundies:airport-and-hotels-question-case': '\uea45',
        'roundies:airport-and-hotels-radar': '\uea46',
        'roundies:airport-and-hotels-radiation-case': '\uea47',
        'roundies:airport-and-hotels-restaurant-sign': '\uea48',
        'roundies:airport-and-hotels-restaurant': '\uea49',
        'roundies:airport-and-hotels-room-key': '\uea4a',
        'roundies:airport-and-hotels-room-service': '\uea4b',
        'roundies:airport-and-hotels-rotations': '\uea4c',
        'roundies:airport-and-hotels-runway': '\uea4d',
        'roundies:airport-and-hotels-safe': '\uea4e',
        'roundies:airport-and-hotels-search-case': '\uea4f',
        'roundies:airport-and-hotels-search-hotel': '\uea50',
        'roundies:airport-and-hotels-search-location': '\uea51',
        'roundies:airport-and-hotels-search-plane': '\uea52',
        'roundies:airport-and-hotels-search-wifi': '\uea53',
        'roundies:airport-and-hotels-security-check': '\uea54',
        'roundies:airport-and-hotels-service': '\uea55',
        'roundies:airport-and-hotels-shower': '\uea56',
        'roundies:airport-and-hotels-smoking': '\uea57',
        'roundies:airport-and-hotels-stairs-transport': '\uea58',
        'roundies:airport-and-hotels-storage': '\uea59',
        'roundies:airport-and-hotels-television': '\uea5a',
        'roundies:airport-and-hotels-waiting-room': '\uea5b',
        'roundies:airport-and-hotels-warehouse-storage': '\uea5c',
        'roundies:airport-and-hotels-weapon-case': '\uea5d',
        'roundies:airport-and-hotels-weapon': '\uea5e',
        'roundies:airport-and-hotels-weigh-luggage': '\uea5f',
        'roundies:airport-and-hotels-wheelchair': '\uea60',
        'roundies:airport-and-hotels-wifi': '\uea61',
        'roundies:airport-and-hotels-wireless-internet': '\uea62',
        'roundies:airport-and-hotels-woman-chef': '\uea63',
        'roundies:airport-and-hotels-woman': '\uea64',
        'roundies:animals-animal-care': '\uea65',
        'roundies:animals-animal-carton': '\uea66',
        'roundies:animals-animal-cat': '\uea67',
        'roundies:animals-animal-cat_1': '\uea68',
        'roundies:animals-animal-dog': '\uea69',
        'roundies:animals-animal-love': '\uea6a',
        'roundies:animals-animal-medal': '\uea6b',
        'roundies:animals-ant': '\uea6c',
        'roundies:animals-antalope': '\uea6d',
        'roundies:animals-bear': '\uea6e',
        'roundies:animals-bear_1': '\uea6f',
        'roundies:animals-bee': '\uea70',
        'roundies:animals-beetle': '\uea71',
        'roundies:animals-bird-egg': '\uea72',
        'roundies:animals-bird': '\uea73',
        'roundies:animals-bird_1': '\uea74',
        'roundies:animals-bone-badge': '\uea75',
        'roundies:animals-bone': '\uea76',
        'roundies:animals-bulldog': '\uea77',
        'roundies:animals-bulldog_1': '\uea78',
        'roundies:animals-butterfly': '\uea79',
        'roundies:animals-camel': '\uea7a',
        'roundies:animals-care-about-animals': '\uea7b',
        'roundies:animals-carrier': '\uea7c',
        'roundies:animals-cat': '\uea7d',
        'roundies:animals-cat_1': '\uea7e',
        'roundies:animals-chicken': '\uea7f',
        'roundies:animals-chicken_1': '\uea80',
        'roundies:animals-cow': '\uea81',
        'roundies:animals-cow_1': '\uea82',
        'roundies:animals-crab': '\uea83',
        'roundies:animals-deer': '\uea84',
        'roundies:animals-dog-house': '\uea85',
        'roundies:animals-dog': '\uea86',
        'roundies:animals-dog_1': '\uea87',
        'roundies:animals-dolphin': '\uea88',
        'roundies:animals-dove': '\uea89',
        'roundies:animals-dove_1': '\uea8a',
        'roundies:animals-dragonfly': '\uea8b',
        'roundies:animals-duck': '\uea8c',
        'roundies:animals-duck_1': '\uea8d',
        'roundies:animals-eagle': '\uea8e',
        'roundies:animals-eagle_1': '\uea8f',
        'roundies:animals-egg': '\uea90',
        'roundies:animals-elephant': '\uea91',
        'roundies:animals-elephant_1': '\uea92',
        'roundies:animals-female-lion': '\uea93',
        'roundies:animals-file': '\uea94',
        'roundies:animals-fish-egg': '\uea95',
        'roundies:animals-fish': '\uea96',
        'roundies:animals-fly': '\uea97',
        'roundies:animals-food-bowl': '\uea98',
        'roundies:animals-fox': '\uea99',
        'roundies:animals-fox_1': '\uea9a',
        'roundies:animals-frog': '\uea9b',
        'roundies:animals-goat': '\uea9c',
        'roundies:animals-gorilla': '\uea9d',
        'roundies:animals-gorilla_1': '\uea9e',
        'roundies:animals-hamster': '\uea9f',
        'roundies:animals-hatching': '\ueaa0',
        'roundies:animals-hippo': '\ueaa1',
        'roundies:animals-hippo_1': '\ueaa2',
        'roundies:animals-horse': '\ueaa3',
        'roundies:animals-horse_1': '\ueaa4',
        'roundies:animals-jellyfish': '\ueaa5',
        'roundies:animals-kitten': '\ueaa6',
        'roundies:animals-kitten_1': '\ueaa7',
        'roundies:animals-koala': '\ueaa8',
        'roundies:animals-ladybug': '\ueaa9',
        'roundies:animals-lion': '\ueaaa',
        'roundies:animals-male-lion': '\ueaab',
        'roundies:animals-monkey': '\ueaac',
        'roundies:animals-monkey_1': '\ueaad',
        'roundies:animals-mouse': '\ueaae',
        'roundies:animals-no-animals': '\ueaaf',
        'roundies:animals-octopus': '\ueab0',
        'roundies:animals-owl': '\ueab1',
        'roundies:animals-panda': '\ueab2',
        'roundies:animals-paw-print': '\ueab3',
        'roundies:animals-pig': '\ueab4',
        'roundies:animals-pig_1': '\ueab5',
        'roundies:animals-poop': '\ueab6',
        'roundies:animals-puppy': '\ueab7',
        'roundies:animals-rabbit': '\ueab8',
        'roundies:animals-rabbit_1': '\ueab9',
        'roundies:animals-rhino': '\ueaba',
        'roundies:animals-sea-horse': '\ueabb',
        'roundies:animals-sea-star': '\ueabc',
        'roundies:animals-sea-turtle': '\ueabd',
        'roundies:animals-seal': '\ueabe',
        'roundies:animals-serch': '\ueabf',
        'roundies:animals-shark': '\ueac0',
        'roundies:animals-snake-egg': '\ueac1',
        'roundies:animals-spider': '\ueac2',
        'roundies:animals-tiger': '\ueac3',
        'roundies:animals-unicorn': '\ueac4',
        'roundies:animals-whale': '\ueac5',
        'roundies:animals-wolf': '\ueac6',
        'roundies:animals-worm': '\ueac7',
        'roundies:architecture-alert': '\ueac8',
        'roundies:architecture-apartment-building': '\ueac9',
        'roundies:architecture-apartments-building': '\ueaca',
        'roundies:architecture-arabian-culture-building': '\ueacb',
        'roundies:architecture-artboard-101-copy-17': '\ueacc',
        'roundies:architecture-axe': '\ueacd',
        'roundies:architecture-barn': '\ueace',
        'roundies:architecture-big-hammer': '\ueacf',
        'roundies:architecture-blueprints-approved': '\uead0',
        'roundies:architecture-blueprints-plan': '\uead1',
        'roundies:architecture-blueprints': '\uead2',
        'roundies:architecture-bricks': '\uead3',
        'roundies:architecture-bridge': '\uead4',
        'roundies:architecture-brush': '\uead5',
        'roundies:architecture-bucket': '\uead6',
        'roundies:architecture-building': '\uead7',
        'roundies:architecture-buildings': '\uead8',
        'roundies:architecture-carry-crane-hook': '\uead9',
        'roundies:architecture-carry-crane': '\ueada',
        'roundies:architecture-castle': '\ueadb',
        'roundies:architecture-church': '\ueadc',
        'roundies:architecture-compass': '\ueadd',
        'roundies:architecture-confirm-worker-man': '\ueade',
        'roundies:architecture-confirm-worker-woman': '\ueadf',
        'roundies:architecture-crane-hook': '\ueae0',
        'roundies:architecture-crane': '\ueae1',
        'roundies:architecture-cutural-building': '\ueae2',
        'roundies:architecture-duplex': '\ueae3',
        'roundies:architecture-factory': '\ueae4',
        'roundies:architecture-family-house': '\ueae5',
        'roundies:architecture-farm-barn': '\ueae6',
        'roundies:architecture-fence-door': '\ueae7',
        'roundies:architecture-fence-round-door': '\ueae8',
        'roundies:architecture-fence': '\ueae9',
        'roundies:architecture-government-building': '\ueaea',
        'roundies:architecture-hammer': '\ueaeb',
        'roundies:architecture-high-voltage': '\ueaec',
        'roundies:architecture-home-': '\ueaed',
        'roundies:architecture-home-hammer': '\ueaee',
        'roundies:architecture-home-house': '\ueaef',
        'roundies:architecture-hook-crane': '\ueaf0',
        'roundies:architecture-hook': '\ueaf1',
        'roundies:architecture-house-home': '\ueaf2',
        'roundies:architecture-house': '\ueaf3',
        'roundies:architecture-housing': '\ueaf4',
        'roundies:architecture-igloo': '\ueaf5',
        'roundies:architecture-ladder': '\ueaf6',
        'roundies:architecture-large-apartment-building': '\ueaf7',
        'roundies:architecture-large-apartments-building': '\ueaf8',
        'roundies:architecture-lighthouse': '\ueaf9',
        'roundies:architecture-measure': '\ueafa',
        'roundies:architecture-measurement-tape': '\ueafb',
        'roundies:architecture-measurements': '\ueafc',
        'roundies:architecture-modern-home': '\ueafd',
        'roundies:architecture-monument': '\ueafe',
        'roundies:architecture-mosque': '\ueaff',
        'roundies:architecture-paint-brush': '\ueb00',
        'roundies:architecture-pick-axe': '\ueb01',
        'roundies:architecture-round-monument': '\ueb02',
        'roundies:architecture-rounded-window': '\ueb03',
        'roundies:architecture-ruler': '\ueb04',
        'roundies:architecture-screwdrivers': '\ueb05',
        'roundies:architecture-shop-store': '\ueb06',
        'roundies:architecture-shop': '\ueb07',
        'roundies:architecture-shovel': '\ueb08',
        'roundies:architecture-siren': '\ueb09',
        'roundies:architecture-small-building': '\ueb0a',
        'roundies:architecture-stairs': '\ueb0b',
        'roundies:architecture-store-shop': '\ueb0c',
        'roundies:architecture-store': '\ueb0d',
        'roundies:architecture-street-cone': '\ueb0e',
        'roundies:architecture-street-warning': '\ueb0f',
        'roundies:architecture-temple': '\ueb10',
        'roundies:architecture-tent': '\ueb11',
        'roundies:architecture-toolbox': '\ueb12',
        'roundies:architecture-tower-building': '\ueb13',
        'roundies:architecture-wall': '\ueb14',
        'roundies:architecture-wheelbarrow': '\ueb15',
        'roundies:architecture-window': '\ueb16',
        'roundies:architecture-worker-man': '\ueb17',
        'roundies:architecture-worker-woman': '\ueb18',
        'roundies:business-and-finance-abacus': '\ueb19',
        'roundies:business-and-finance-agreement': '\ueb1a',
        'roundies:business-and-finance-announcement': '\ueb1b',
        'roundies:business-and-finance-bank-and-laptop-transfer': '\ueb1c',
        'roundies:business-and-finance-bank-to-bank-transfer': '\ueb1d',
        'roundies:business-and-finance-bank-to-mobile-transfer': '\ueb1e',
        'roundies:business-and-finance-bank-to-person-transfer': '\ueb1f',
        'roundies:business-and-finance-bank-to-store-transfer': '\ueb20',
        'roundies:business-and-finance-bank': '\ueb21',
        'roundies:business-and-finance-bar-chart-rise': '\ueb22',
        'roundies:business-and-finance-bar-graph-presentation': '\ueb23',
        'roundies:business-and-finance-bar-graph': '\ueb24',
        'roundies:business-and-finance-bitcoin-coin': '\ueb25',
        'roundies:business-and-finance-bitcoin-selection': '\ueb26',
        'roundies:business-and-finance-bitcoin': '\ueb27',
        'roundies:business-and-finance-british-pound-coin': '\ueb28',
        'roundies:business-and-finance-british-pound-selection': '\ueb29',
        'roundies:business-and-finance-british-pound': '\ueb2a',
        'roundies:business-and-finance-calculate': '\ueb2b',
        'roundies:business-and-finance-calculator': '\ueb2c',
        'roundies:business-and-finance-car-growth': '\ueb2d',
        'roundies:business-and-finance-care-for-growth': '\ueb2e',
        'roundies:business-and-finance-cash-and-coins': '\ueb2f',
        'roundies:business-and-finance-cash-extract': '\ueb30',
        'roundies:business-and-finance-cash-payment-one': '\ueb31',
        'roundies:business-and-finance-cash-payment': '\ueb32',
        'roundies:business-and-finance-cash-register': '\ueb33',
        'roundies:business-and-finance-cash': '\ueb34',
        'roundies:business-and-finance-coin-exchange-target': '\ueb35',
        'roundies:business-and-finance-coin-exchange': '\ueb36',
        'roundies:business-and-finance-coin-purse': '\ueb37',
        'roundies:business-and-finance-coins': '\ueb38',
        'roundies:business-and-finance-credit-card-and-coins': '\ueb39',
        'roundies:business-and-finance-credit-card-back-payment': '\ueb3a',
        'roundies:business-and-finance-credit-card-back-wallet': '\ueb3b',
        'roundies:business-and-finance-credit-card-back': '\ueb3c',
        'roundies:business-and-finance-credit-card-back_1': '\ueb3d',
        'roundies:business-and-finance-credit-card-extract': '\ueb3e',
        'roundies:business-and-finance-credit-card-front-payment': '\ueb3f',
        'roundies:business-and-finance-credit-card-front-wallet': '\ueb40',
        'roundies:business-and-finance-credit-card-front': '\ueb41',
        'roundies:business-and-finance-credit-card-front_1': '\ueb42',
        'roundies:business-and-finance-credit-card-machine-back': '\ueb43',
        'roundies:business-and-finance-credit-card-machine-front': '\ueb44',
        'roundies:business-and-finance-credit-card-payment': '\ueb45',
        'roundies:business-and-finance-customer-service-man': '\ueb46',
        'roundies:business-and-finance-customer-service-woman': '\ueb47',
        'roundies:business-and-finance-cut-cash': '\ueb48',
        'roundies:business-and-finance-cut-credit-card': '\ueb49',
        'roundies:business-and-finance-cut-ticket': '\ueb4a',
        'roundies:business-and-finance-day-and-night': '\ueb4b',
        'roundies:business-and-finance-diamond': '\ueb4c',
        'roundies:business-and-finance-dollar-chart': '\ueb4d',
        'roundies:business-and-finance-dollar-cheque': '\ueb4e',
        'roundies:business-and-finance-dollar-coin': '\ueb4f',
        'roundies:business-and-finance-dollar-coupon': '\ueb50',
        'roundies:business-and-finance-dollar-file': '\ueb51',
        'roundies:business-and-finance-dollar-folder': '\ueb52',
        'roundies:business-and-finance-dollar-growth': '\ueb53',
        'roundies:business-and-finance-dollar-lightbulb': '\ueb54',
        'roundies:business-and-finance-dollar-lock': '\ueb55',
        'roundies:business-and-finance-dollar-pie-chart': '\ueb56',
        'roundies:business-and-finance-dollar-presentation': '\ueb57',
        'roundies:business-and-finance-dollar-scale': '\ueb58',
        'roundies:business-and-finance-dollar-security-web-browser': '\ueb59',
        'roundies:business-and-finance-dollar-security': '\ueb5a',
        'roundies:business-and-finance-dollar-selection': '\ueb5b',
        'roundies:business-and-finance-dollar-settings': '\ueb5c',
        'roundies:business-and-finance-dollar': '\ueb5d',
        'roundies:business-and-finance-electronic-safe': '\ueb5e',
        'roundies:business-and-finance-employee-man': '\ueb5f',
        'roundies:business-and-finance-employee-woman': '\ueb60',
        'roundies:business-and-finance-empty-wallet': '\ueb61',
        'roundies:business-and-finance-euro-chart': '\ueb62',
        'roundies:business-and-finance-euro-cheque': '\ueb63',
        'roundies:business-and-finance-euro-coin': '\ueb64',
        'roundies:business-and-finance-euro-growth': '\ueb65',
        'roundies:business-and-finance-euro-pie-chart': '\ueb66',
        'roundies:business-and-finance-euro-scale': '\ueb67',
        'roundies:business-and-finance-euro-security-web-browser': '\ueb68',
        'roundies:business-and-finance-euro-selection': '\ueb69',
        'roundies:business-and-finance-euro': '\ueb6a',
        'roundies:business-and-finance-exchange-cash-bills': '\ueb6b',
        'roundies:business-and-finance-exchange-coin-target': '\ueb6c',
        'roundies:business-and-finance-exchange-dollar': '\ueb6d',
        'roundies:business-and-finance-exchange-euro': '\ueb6e',
        'roundies:business-and-finance-exchange-money': '\ueb6f',
        'roundies:business-and-finance-exchange-target-coin': '\ueb70',
        'roundies:business-and-finance-exchange-target': '\ueb71',
        'roundies:business-and-finance-exchange-yen': '\ueb72',
        'roundies:business-and-finance-extract-money': '\ueb73',
        'roundies:business-and-finance-find-dollar': '\ueb74',
        'roundies:business-and-finance-find-euro': '\ueb75',
        'roundies:business-and-finance-find-percentage': '\ueb76',
        'roundies:business-and-finance-find-profile': '\ueb77',
        'roundies:business-and-finance-find-yen': '\ueb78',
        'roundies:business-and-finance-finished-timer': '\ueb79',
        'roundies:business-and-finance-full-wallet': '\ueb7a',
        'roundies:business-and-finance-give-credit-card': '\ueb7b',
        'roundies:business-and-finance-give-money': '\ueb7c',
        'roundies:business-and-finance-give-target': '\ueb7d',
        'roundies:business-and-finance-global-dollar-target': '\ueb7e',
        'roundies:business-and-finance-global-euro-target': '\ueb7f',
        'roundies:business-and-finance-global-yen-target': '\ueb80',
        'roundies:business-and-finance-gold': '\ueb81',
        'roundies:business-and-finance-graph-down': '\ueb82',
        'roundies:business-and-finance-graph-up': '\ueb83',
        'roundies:business-and-finance-graph-web-browser': '\ueb84',
        'roundies:business-and-finance-half-timer': '\ueb85',
        'roundies:business-and-finance-home-payment': '\ueb86',
        'roundies:business-and-finance-home': '\ueb87',
        'roundies:business-and-finance-id-tag': '\ueb88',
        'roundies:business-and-finance-input-money': '\ueb89',
        'roundies:business-and-finance-laptop-bank': '\ueb8a',
        'roundies:business-and-finance-laptop-store': '\ueb8b',
        'roundies:business-and-finance-man': '\ueb8c',
        'roundies:business-and-finance-mechanical-safe': '\ueb8d',
        'roundies:business-and-finance-mobile-online-bank': '\ueb8e',
        'roundies:business-and-finance-mobile-online-cash-payment': '\ueb8f',
        'roundies:business-and-finance-mobile-online-credit-card-payment': '\ueb90',
        'roundies:business-and-finance-mobile-online-store': '\ueb91',
        'roundies:business-and-finance-mobile-payment-security': '\ueb92',
        'roundies:business-and-finance-money-bag': '\ueb93',
        'roundies:business-and-finance-money-conversation': '\ueb94',
        'roundies:business-and-finance-monitor-arrow-up': '\ueb95',
        'roundies:business-and-finance-monitor-dollar-security': '\ueb96',
        'roundies:business-and-finance-monitor-euro-security': '\ueb97',
        'roundies:business-and-finance-monitor-graph': '\ueb98',
        'roundies:business-and-finance-monitor-pie-chart': '\ueb99',
        'roundies:business-and-finance-monitor-yen-security': '\ueb9a',
        'roundies:business-and-finance-mortgage-approval': '\ueb9b',
        'roundies:business-and-finance-multiple-cash': '\ueb9c',
        'roundies:business-and-finance-multiple-credit-card-back': '\ueb9d',
        'roundies:business-and-finance-multiple-credit-card-front': '\ueb9e',
        'roundies:business-and-finance-online-bank': '\ueb9f',
        'roundies:business-and-finance-online-payment-security': '\ueba0',
        'roundies:business-and-finance-online-payment': '\ueba1',
        'roundies:business-and-finance-online-store': '\ueba2',
        'roundies:business-and-finance-pay-with-cash-one': '\ueba3',
        'roundies:business-and-finance-pay-with-cash': '\ueba4',
        'roundies:business-and-finance-pay-with-credit-card-back': '\ueba5',
        'roundies:business-and-finance-pay-with-credit-card-front': '\ueba6',
        'roundies:business-and-finance-pay-with-credit-card': '\ueba7',
        'roundies:business-and-finance-percentage-fall': '\ueba8',
        'roundies:business-and-finance-percentage-rise': '\ueba9',
        'roundies:business-and-finance-person-to-person-transfer': '\uebaa',
        'roundies:business-and-finance-pie-chart-presentation': '\uebab',
        'roundies:business-and-finance-pie-chart-web-browser': '\uebac',
        'roundies:business-and-finance-pie-chart': '\uebad',
        'roundies:business-and-finance-piggy-bank': '\uebae',
        'roundies:business-and-finance-pin-machine': '\uebaf',
        'roundies:business-and-finance-presentation': '\uebb0',
        'roundies:business-and-finance-price-tag': '\uebb1',
        'roundies:business-and-finance-protect-dollar': '\uebb2',
        'roundies:business-and-finance-protect-euro': '\uebb3',
        'roundies:business-and-finance-protect-yen': '\uebb4',
        'roundies:business-and-finance-safe': '\uebb5',
        'roundies:business-and-finance-sale-coupon': '\uebb6',
        'roundies:business-and-finance-sale-store': '\uebb7',
        'roundies:business-and-finance-sale-tag': '\uebb8',
        'roundies:business-and-finance-security-complete': '\uebb9',
        'roundies:business-and-finance-shop-basket': '\uebba',
        'roundies:business-and-finance-shop-cart': '\uebbb',
        'roundies:business-and-finance-shop-store': '\uebbc',
        'roundies:business-and-finance-shop': '\uebbd',
        'roundies:business-and-finance-shopping-bag': '\uebbe',
        'roundies:business-and-finance-shopping-basket': '\uebbf',
        'roundies:business-and-finance-shopping-cart': '\uebc0',
        'roundies:business-and-finance-shopping-kart': '\uebc1',
        'roundies:business-and-finance-start-timer': '\uebc2',
        'roundies:business-and-finance-start-up': '\uebc3',
        'roundies:business-and-finance-statistics-fall': '\uebc4',
        'roundies:business-and-finance-statistics-rise': '\uebc5',
        'roundies:business-and-finance-store-cash-register-checkout': '\uebc6',
        'roundies:business-and-finance-suitcase': '\uebc7',
        'roundies:business-and-finance-tag': '\uebc8',
        'roundies:business-and-finance-target-coin': '\uebc9',
        'roundies:business-and-finance-target-coins': '\uebca',
        'roundies:business-and-finance-target-file': '\uebcb',
        'roundies:business-and-finance-target-folder': '\uebcc',
        'roundies:business-and-finance-target-growth': '\uebcd',
        'roundies:business-and-finance-target-one': '\uebce',
        'roundies:business-and-finance-target-security': '\uebcf',
        'roundies:business-and-finance-target-selection': '\uebd0',
        'roundies:business-and-finance-target': '\uebd1',
        'roundies:business-and-finance-team': '\uebd2',
        'roundies:business-and-finance-toolbox': '\uebd3',
        'roundies:business-and-finance-transfer-cash-bills': '\uebd4',
        'roundies:business-and-finance-upload-web-browser': '\uebd5',
        'roundies:business-and-finance-wallet': '\uebd6',
        'roundies:business-and-finance-woman': '\uebd7',
        'roundies:business-and-finance-yen-chart': '\uebd8',
        'roundies:business-and-finance-yen-cheque': '\uebd9',
        'roundies:business-and-finance-yen-coin': '\uebda',
        'roundies:business-and-finance-yen-growth': '\uebdb',
        'roundies:business-and-finance-yen-pie-chart': '\uebdc',
        'roundies:business-and-finance-yen-scale': '\uebdd',
        'roundies:business-and-finance-yen-security-web-browser': '\uebde',
        'roundies:business-and-finance-yen-selection': '\uebdf',
        'roundies:business-and-finance-yen': '\uebe0',
        'roundies:camera-and-photography-add-marker': '\uebe1',
        'roundies:camera-and-photography-add': '\uebe2',
        'roundies:camera-and-photography-automatic-brightness': '\uebe3',
        'roundies:camera-and-photography-automatic-camera': '\uebe4',
        'roundies:camera-and-photography-automatic-flash': '\uebe5',
        'roundies:camera-and-photography-automatic-video-camera': '\uebe6',
        'roundies:camera-and-photography-automatic': '\uebe7',
        'roundies:camera-and-photography-block': '\uebe8',
        'roundies:camera-and-photography-cam-camera': '\uebe9',
        'roundies:camera-and-photography-camera-app': '\uebea',
        'roundies:camera-and-photography-camera-cam': '\uebeb',
        'roundies:camera-and-photography-camera-lens': '\uebec',
        'roundies:camera-and-photography-camera-photography': '\uebed',
        'roundies:camera-and-photography-camera-settings': '\uebee',
        'roundies:camera-and-photography-camera-to-smartphone-transfer': '\uebef',
        'roundies:camera-and-photography-camera': '\uebf0',
        'roundies:camera-and-photography-cc': '\uebf1',
        'roundies:camera-and-photography-crop': '\uebf2',
        'roundies:camera-and-photography-day-and-night': '\uebf3',
        'roundies:camera-and-photography-dial': '\uebf4',
        'roundies:camera-and-photography-duplicate': '\uebf5',
        'roundies:camera-and-photography-e': '\uebf6',
        'roundies:camera-and-photography-elements': '\uebf7',
        'roundies:camera-and-photography-expand': '\uebf8',
        'roundies:camera-and-photography-exposure': '\uebf9',
        'roundies:camera-and-photography-eye-focus': '\uebfa',
        'roundies:camera-and-photography-fast-forward': '\uebfb',
        'roundies:camera-and-photography-film': '\uebfc',
        'roundies:camera-and-photography-flash': '\uebfd',
        'roundies:camera-and-photography-focus': '\uebfe',
        'roundies:camera-and-photography-four-k': '\uebff',
        'roundies:camera-and-photography-frame': '\uec00',
        'roundies:camera-and-photography-full-brightness': '\uec01',
        'roundies:camera-and-photography-gallery-images-selection': '\uec02',
        'roundies:camera-and-photography-gallery-images': '\uec03',
        'roundies:camera-and-photography-gallery-selection': '\uec04',
        'roundies:camera-and-photography-gallery': '\uec05',
        'roundies:camera-and-photography-grid': '\uec06',
        'roundies:camera-and-photography-group-picture': '\uec07',
        'roundies:camera-and-photography-half-brightness': '\uec08',
        'roundies:camera-and-photography-hd': '\uec09',
        'roundies:camera-and-photography-hdr': '\uec0a',
        'roundies:camera-and-photography-layer': '\uec0b',
        'roundies:camera-and-photography-macro': '\uec0c',
        'roundies:camera-and-photography-maintenance': '\uec0d',
        'roundies:camera-and-photography-manual-camera': '\uec0e',
        'roundies:camera-and-photography-manual-video-camera': '\uec0f',
        'roundies:camera-and-photography-manual': '\uec10',
        'roundies:camera-and-photography-menu-selection': '\uec11',
        'roundies:camera-and-photography-menu': '\uec12',
        'roundies:camera-and-photography-movie': '\uec13',
        'roundies:camera-and-photography-negative': '\uec14',
        'roundies:camera-and-photography-new': '\uec15',
        'roundies:camera-and-photography-next': '\uec16',
        'roundies:camera-and-photography-night-brightness': '\uec17',
        'roundies:camera-and-photography-night-to-day': '\uec18',
        'roundies:camera-and-photography-no-flash': '\uec19',
        'roundies:camera-and-photography-panorama-horizontal': '\uec1a',
        'roundies:camera-and-photography-panorama-vertical': '\uec1b',
        'roundies:camera-and-photography-pause': '\uec1c',
        'roundies:camera-and-photography-person-image': '\uec1d',
        'roundies:camera-and-photography-person-night-image': '\uec1e',
        'roundies:camera-and-photography-personal-image': '\uec1f',
        'roundies:camera-and-photography-photography-app': '\uec20',
        'roundies:camera-and-photography-photography': '\uec21',
        'roundies:camera-and-photography-play': '\uec22',
        'roundies:camera-and-photography-previous': '\uec23',
        'roundies:camera-and-photography-profile-picture-man': '\uec24',
        'roundies:camera-and-photography-profile-picture-woman': '\uec25',
        'roundies:camera-and-photography-projector': '\uec26',
        'roundies:camera-and-photography-rainbow': '\uec27',
        'roundies:camera-and-photography-record-video': '\uec28',
        'roundies:camera-and-photography-record': '\uec29',
        'roundies:camera-and-photography-reepat-none': '\uec2a',
        'roundies:camera-and-photography-refresh-liquid': '\uec2b',
        'roundies:camera-and-photography-repeat-ten': '\uec2c',
        'roundies:camera-and-photography-repeat-three': '\uec2d',
        'roundies:camera-and-photography-rewind': '\uec2e',
        'roundies:camera-and-photography-rotate-screen': '\uec2f',
        'roundies:camera-and-photography-scale-four-to-three': '\uec30',
        'roundies:camera-and-photography-scale-sixteen-to-nine': '\uec31',
        'roundies:camera-and-photography-screen-rotation': '\uec32',
        'roundies:camera-and-photography-sd-card': '\uec33',
        'roundies:camera-and-photography-select-picture': '\uec34',
        'roundies:camera-and-photography-shutter': '\uec35',
        'roundies:camera-and-photography-split': '\uec36',
        'roundies:camera-and-photography-stop': '\uec37',
        'roundies:camera-and-photography-switch-camera': '\uec38',
        'roundies:camera-and-photography-switch-video-camera': '\uec39',
        'roundies:camera-and-photography-temperature': '\uec3a',
        'roundies:camera-and-photography-three-d': '\uec3b',
        'roundies:camera-and-photography-time-camera': '\uec3c',
        'roundies:camera-and-photography-time-video-camera': '\uec3d',
        'roundies:camera-and-photography-timer': '\uec3e',
        'roundies:camera-and-photography-uhd': '\uec3f',
        'roundies:camera-and-photography-vid-camera': '\uec40',
        'roundies:camera-and-photography-video-camera-settings': '\uec41',
        'roundies:camera-and-photography-video-camera': '\uec42',
        'roundies:camera-and-photography-video-film': '\uec43',
        'roundies:camera-and-photography-white-and-black': '\uec44',
        'roundies:electronics-audio-microchip': '\uec45',
        'roundies:electronics-auto-usb-cable': '\uec46',
        'roundies:electronics-auto-usb-connect': '\uec47',
        'roundies:electronics-auto-usb-stick': '\uec48',
        'roundies:electronics-auto-usb': '\uec49',
        'roundies:electronics-bluetooth-microchip': '\uec4a',
        'roundies:electronics-bunny-ear-television': '\uec4b',
        'roundies:electronics-c--usb': '\uec4c',
        'roundies:electronics-c-usb-cable': '\uec4d',
        'roundies:electronics-c-usb-connect': '\uec4e',
        'roundies:electronics-c-usb-stick': '\uec4f',
        'roundies:electronics-call': '\uec50',
        'roundies:electronics-cam': '\uec51',
        'roundies:electronics-chip-one': '\uec52',
        'roundies:electronics-chip': '\uec53',
        'roundies:electronics-computer-drive': '\uec54',
        'roundies:electronics-computer-monitor': '\uec55',
        'roundies:electronics-computer-mouse': '\uec56',
        'roundies:electronics-computer-pc': '\uec57',
        'roundies:electronics-computer-screen': '\uec58',
        'roundies:electronics-cpu': '\uec59',
        'roundies:electronics-dial-phone': '\uec5a',
        'roundies:electronics-drive': '\uec5b',
        'roundies:electronics-electronic-mouse': '\uec5c',
        'roundies:electronics-fan': '\uec5d',
        'roundies:electronics-floppy-disk': '\uec5e',
        'roundies:electronics-gamepad': '\uec5f',
        'roundies:electronics-gpu': '\uec60',
        'roundies:electronics-green-microchip': '\uec61',
        'roundies:electronics-hd-television-screen': '\uec62',
        'roundies:electronics-hd-tv': '\uec63',
        'roundies:electronics-hdd-card': '\uec64',
        'roundies:electronics-headset': '\uec65',
        'roundies:electronics-ipod': '\uec66',
        'roundies:electronics-keyboard-phone': '\uec67',
        'roundies:electronics-keyboard': '\uec68',
        'roundies:electronics-laptop-computer': '\uec69',
        'roundies:electronics-laptop': '\uec6a',
        'roundies:electronics-micro-card': '\uec6b',
        'roundies:electronics-microchip-five': '\uec6c',
        'roundies:electronics-microchip-four': '\uec6d',
        'roundies:electronics-microchip-one': '\uec6e',
        'roundies:electronics-microchip-six': '\uec6f',
        'roundies:electronics-microchip-three': '\uec70',
        'roundies:electronics-microchip-two': '\uec71',
        'roundies:electronics-microphone': '\uec72',
        'roundies:electronics-mobile-phone': '\uec73',
        'roundies:electronics-modem': '\uec74',
        'roundies:electronics-monitor': '\uec75',
        'roundies:electronics-mouse': '\uec76',
        'roundies:electronics-mp3-player': '\uec77',
        'roundies:electronics-music-player': '\uec78',
        'roundies:electronics-pc': '\uec79',
        'roundies:electronics-phone': '\uec7a',
        'roundies:electronics-phonebooth': '\uec7b',
        'roundies:electronics-rack': '\uec7c',
        'roundies:electronics-remote-control': '\uec7d',
        'roundies:electronics-remote': '\uec7e',
        'roundies:electronics-retro-bunny-ear-television': '\uec7f',
        'roundies:electronics-retro-call': '\uec80',
        'roundies:electronics-retro-phone': '\uec81',
        'roundies:electronics-retro-television': '\uec82',
        'roundies:electronics-round-computer-screen': '\uec83',
        'roundies:electronics-rounded-shape-television': '\uec84',
        'roundies:electronics-rounded-television': '\uec85',
        'roundies:electronics-rounded-tv': '\uec86',
        'roundies:electronics-screen': '\uec87',
        'roundies:electronics-sd-card': '\uec88',
        'roundies:electronics-security-cam': '\uec89',
        'roundies:electronics-security-camera': '\uec8a',
        'roundies:electronics-security-webcam': '\uec8b',
        'roundies:electronics-settings-microchip': '\uec8c',
        'roundies:electronics-shape-remote-control': '\uec8d',
        'roundies:electronics-share-microchip': '\uec8e',
        'roundies:electronics-sim-card': '\uec8f',
        'roundies:electronics-smartphone': '\uec90',
        'roundies:electronics-ssd-card': '\uec91',
        'roundies:electronics-tablet': '\uec92',
        'roundies:electronics-television': '\uec93',
        'roundies:electronics-touch-screen-phone': '\uec94',
        'roundies:electronics-touch-screen-tablet': '\uec95',
        'roundies:electronics-turn-dial-phone': '\uec96',
        'roundies:electronics-tv': '\uec97',
        'roundies:electronics-usb-cable': '\uec98',
        'roundies:electronics-usb-connect': '\uec99',
        'roundies:electronics-usb-stick': '\uec9a',
        'roundies:electronics-usb': '\uec9b',
        'roundies:electronics-video-microchip': '\uec9c',
        'roundies:electronics-view-microchip': '\uec9d',
        'roundies:electronics-virus-microchip': '\uec9e',
        'roundies:electronics-web-camera': '\uec9f',
        'roundies:electronics-webcam': '\ueca0',
        'roundies:electronics-wireless-computer-mouse': '\ueca1',
        'roundies:electronics-wireless-electronic-mouse': '\ueca2',
        'roundies:electronics-wireless-gamepad': '\ueca3',
        'roundies:electronics-wireless-headset': '\ueca4',
        'roundies:electronics-wireless-keyboard': '\ueca5',
        'roundies:electronics-wireless-microchip': '\ueca6',
        'roundies:electronics-wireless-microphone': '\ueca7',
        'roundies:electronics-wireless-mouse': '\ueca8',
        'roundies:emoji-alien': '\ueca9',
        'roundies:emoji-angel': '\uecaa',
        'roundies:emoji-angry-cat': '\uecab',
        'roundies:emoji-angry-devil': '\uecac',
        'roundies:emoji-angry': '\uecad',
        'roundies:emoji-arrogant-cat': '\uecae',
        'roundies:emoji-arrogant': '\uecaf',
        'roundies:emoji-awkward-laugh': '\uecb0',
        'roundies:emoji-awkward-upset': '\uecb1',
        'roundies:emoji-big-eyes': '\uecb2',
        'roundies:emoji-bored': '\uecb3',
        'roundies:emoji-brain-explosion': '\uecb4',
        'roundies:emoji-calm': '\uecb5',
        'roundies:emoji-clown': '\uecb6',
        'roundies:emoji-cool': '\uecb7',
        'roundies:emoji-cry-cat': '\uecb8',
        'roundies:emoji-cry': '\uecb9',
        'roundies:emoji-crying': '\uecba',
        'roundies:emoji-dead': '\uecbb',
        'roundies:emoji-deadly': '\uecbc',
        'roundies:emoji-drool': '\uecbd',
        'roundies:emoji-duckface': '\uecbe',
        'roundies:emoji-eyes-closed-smile': '\uecbf',
        'roundies:emoji-furious': '\uecc0',
        'roundies:emoji-giggle': '\uecc1',
        'roundies:emoji-greedy': '\uecc2',
        'roundies:emoji-grin': '\uecc3',
        'roundies:emoji-grumpy': '\uecc4',
        'roundies:emoji-happy-cat': '\uecc5',
        'roundies:emoji-happy-devil': '\uecc6',
        'roundies:emoji-happy-emoticon': '\uecc7',
        'roundies:emoji-happy-grin': '\uecc8',
        'roundies:emoji-happy-laugh': '\uecc9',
        'roundies:emoji-happy-smiling': '\uecca',
        'roundies:emoji-happy': '\ueccb',
        'roundies:emoji-ill': '\ueccc',
        'roundies:emoji-in-love-cat': '\ueccd',
        'roundies:emoji-in-love': '\uecce',
        'roundies:emoji-injured': '\ueccf',
        'roundies:emoji-irritated': '\uecd0',
        'roundies:emoji-kiss-cat': '\uecd1',
        'roundies:emoji-kiss-eyes-closed': '\uecd2',
        'roundies:emoji-kiss-with-heart': '\uecd3',
        'roundies:emoji-kiss': '\uecd4',
        'roundies:emoji-laugh': '\uecd5',
        'roundies:emoji-laughing-cat': '\uecd6',
        'roundies:emoji-laughing': '\uecd7',
        'roundies:emoji-lethal': '\uecd8',
        'roundies:emoji-liar': '\uecd9',
        'roundies:emoji-nauseous': '\uecda',
        'roundies:emoji-nerd': '\uecdb',
        'roundies:emoji-no-speech': '\uecdc',
        'roundies:emoji-puppy-eyes': '\uecdd',
        'roundies:emoji-robot': '\uecde',
        'roundies:emoji-sad-cry': '\uecdf',
        'roundies:emoji-sad-emoticon': '\uece0',
        'roundies:emoji-sad-tear': '\uece1',
        'roundies:emoji-sad': '\uece2',
        'roundies:emoji-satisfied': '\uece3',
        'roundies:emoji-secret': '\uece4',
        'roundies:emoji-shock-cat': '\uece5',
        'roundies:emoji-shock-speechless': '\uece6',
        'roundies:emoji-shock': '\uece7',
        'roundies:emoji-shocked': '\uece8',
        'roundies:emoji-sick': '\uece9',
        'roundies:emoji-silly': '\uecea',
        'roundies:emoji-smile-tongue-out': '\ueceb',
        'roundies:emoji-smiling-cat': '\uecec',
        'roundies:emoji-smooch': '\ueced',
        'roundies:emoji-sneeze': '\uecee',
        'roundies:emoji-speech-bubble': '\uecef',
        'roundies:emoji-speechless-shock': '\uecf0',
        'roundies:emoji-speechless': '\uecf1',
        'roundies:emoji-stars-cat': '\uecf2',
        'roundies:emoji-stars': '\uecf3',
        'roundies:emoji-surprise-shock': '\uecf4',
        'roundies:emoji-surprised': '\uecf5',
        'roundies:emoji-swear-words': '\uecf6',
        'roundies:emoji-tear-sad': '\uecf7',
        'roundies:emoji-tear': '\uecf8',
        'roundies:emoji-thin-duckface': '\uecf9',
        'roundies:emoji-thinking': '\uecfa',
        'roundies:emoji-thought-bubble': '\uecfb',
        'roundies:emoji-throw-up': '\uecfc',
        'roundies:emoji-throwing-up': '\uecfd',
        'roundies:emoji-tired': '\uecfe',
        'roundies:emoji-tongue-out-eyes-closed': '\uecff',
        'roundies:emoji-tongue-out': '\ued00',
        'roundies:emoji-top-hat': '\ued01',
        'roundies:emoji-unhappy': '\ued02',
        'roundies:emoji-upset-angry': '\ued03',
        'roundies:emoji-upset-cry': '\ued04',
        'roundies:emoji-upset': '\ued05',
        'roundies:emoji-very-sad': '\ued06',
        'roundies:emoji-wauw': '\ued07',
        'roundies:emoji-wavong': '\ued08',
        'roundies:emoji-whatever': '\ued09',
        'roundies:emoji-wink-tongue-out': '\ued0a',
        'roundies:emoji-wink': '\ued0b',
        'roundies:emoji-wow': '\ued0c',
        'roundies:energy-battery-options': '\ued0d',
        'roundies:energy-battery-settings': '\ued0e',
        'roundies:energy-bone-science': '\ued0f',
        'roundies:energy-canister': '\ued10',
        'roundies:energy-car-battery': '\ued11',
        'roundies:energy-care-about-plants': '\ued12',
        'roundies:energy-care-about-recycle': '\ued13',
        'roundies:energy-care-about-water': '\ued14',
        'roundies:energy-care-for-planet': '\ued15',
        'roundies:energy-care-for-plant': '\ued16',
        'roundies:energy-care-for-recycle': '\ued17',
        'roundies:energy-care-for-water': '\ued18',
        'roundies:energy-charge-battery': '\ued19',
        'roundies:energy-charging-battery': '\ued1a',
        'roundies:energy-electric-car': '\ued1b',
        'roundies:energy-electric-water': '\ued1c',
        'roundies:energy-electrical-car': '\ued1d',
        'roundies:energy-electrical-science': '\ued1e',
        'roundies:energy-electrical-thought': '\ued1f',
        'roundies:energy-energy-efficient-lightbulb': '\ued20',
        'roundies:energy-energy-solar': '\ued21',
        'roundies:energy-factory-power-plant': '\ued22',
        'roundies:energy-factory': '\ued23',
        'roundies:energy-fire': '\ued24',
        'roundies:energy-gasoline': '\ued25',
        'roundies:energy-green-battery': '\ued26',
        'roundies:energy-green-car-battery': '\ued27',
        'roundies:energy-green-car': '\ued28',
        'roundies:energy-green-charge': '\ued29',
        'roundies:energy-green-electrical': '\ued2a',
        'roundies:energy-green-energy': '\ued2b',
        'roundies:energy-green-factory': '\ued2c',
        'roundies:energy-green-home': '\ued2d',
        'roundies:energy-green-lightbulb': '\ued2e',
        'roundies:energy-green-planet': '\ued2f',
        'roundies:energy-half-battery': '\ued30',
        'roundies:energy-heart-plant': '\ued31',
        'roundies:energy-leaves-and-plant': '\ued32',
        'roundies:energy-leaves': '\ued33',
        'roundies:energy-lethal-science': '\ued34',
        'roundies:energy-love-plants': '\ued35',
        'roundies:energy-low-battery': '\ued36',
        'roundies:energy-molecules': '\ued37',
        'roundies:energy-nuclear-canister': '\ued38',
        'roundies:energy-nuclear-factory': '\ued39',
        'roundies:energy-nuclear-power-plant': '\ued3a',
        'roundies:energy-nuclear-science': '\ued3b',
        'roundies:energy-nuclear-tag': '\ued3c',
        'roundies:energy-nuclear-thought': '\ued3d',
        'roundies:energy-oil-extraction': '\ued3e',
        'roundies:energy-personal-science': '\ued3f',
        'roundies:energy-planet-protection': '\ued40',
        'roundies:energy-plant-canister': '\ued41',
        'roundies:energy-plant-gasoline': '\ued42',
        'roundies:energy-plant-love': '\ued43',
        'roundies:energy-plant-protection': '\ued44',
        'roundies:energy-plant-science': '\ued45',
        'roundies:energy-plant-tag': '\ued46',
        'roundies:energy-plant-thought': '\ued47',
        'roundies:energy-plant': '\ued48',
        'roundies:energy-power-socket': '\ued49',
        'roundies:energy-protect-planet': '\ued4a',
        'roundies:energy-protect-plant': '\ued4b',
        'roundies:energy-recycle-canister': '\ued4c',
        'roundies:energy-recycle-gasoline': '\ued4d',
        'roundies:energy-recycle-lightbulb': '\ued4e',
        'roundies:energy-recycle-love': '\ued4f',
        'roundies:energy-recycle-power-plant': '\ued50',
        'roundies:energy-recycle-protection': '\ued51',
        'roundies:energy-recycle-science': '\ued52',
        'roundies:energy-recycle-tag': '\ued53',
        'roundies:energy-recycle-thought': '\ued54',
        'roundies:energy-recycle-trash': '\ued55',
        'roundies:energy-recycling-plant': '\ued56',
        'roundies:energy-science': '\ued57',
        'roundies:energy-socket': '\ued58',
        'roundies:energy-solar-charge': '\ued59',
        'roundies:energy-solar-energy': '\ued5a',
        'roundies:energy-solar-panel': '\ued5b',
        'roundies:energy-solar-panels': '\ued5c',
        'roundies:energy-solar-planet': '\ued5d',
        'roundies:energy-stream-science': '\ued5e',
        'roundies:energy-sun-science': '\ued5f',
        'roundies:energy-sun-solar-panels': '\ued60',
        'roundies:energy-trash-plant': '\ued61',
        'roundies:energy-trash': '\ued62',
        'roundies:energy-tree': '\ued63',
        'roundies:energy-turbine': '\ued64',
        'roundies:energy-water-canister': '\ued65',
        'roundies:energy-water-gasoline': '\ued66',
        'roundies:energy-water-lightbulb': '\ued67',
        'roundies:energy-water-love': '\ued68',
        'roundies:energy-water-protection': '\ued69',
        'roundies:energy-water-science': '\ued6a',
        'roundies:energy-water-thought': '\ued6b',
        'roundies:energy-wheelbarrow': '\ued6c',
        'roundies:energy-wind-direction': '\ued6d',
        'roundies:energy-windmill-power-plant': '\ued6e',
        'roundies:energy-windmill-science': '\ued6f',
        'roundies:energy-windmill': '\ued70',
        'roundies:filetypes-aac': '\ued71',
        'roundies:filetypes-add-file': '\ued72',
        'roundies:filetypes-ai': '\ued73',
        'roundies:filetypes-aiff': '\ued74',
        'roundies:filetypes-alert-file': '\ued75',
        'roundies:filetypes-apk': '\ued76',
        'roundies:filetypes-article-file': '\ued77',
        'roundies:filetypes-audio-file': '\ued78',
        'roundies:filetypes-audio-specific-file': '\ued79',
        'roundies:filetypes-avi': '\ued7a',
        'roundies:filetypes-bar-chart-file': '\ued7b',
        'roundies:filetypes-bmp': '\ued7c',
        'roundies:filetypes-bookmark-file': '\ued7d',
        'roundies:filetypes-broken-link-file': '\ued7e',
        'roundies:filetypes-bug-file': '\ued7f',
        'roundies:filetypes-camera-file': '\ued80',
        'roundies:filetypes-clip-file': '\ued81',
        'roundies:filetypes-cloud-file': '\ued82',
        'roundies:filetypes-code-file': '\ued83',
        'roundies:filetypes-coding-file': '\ued84',
        'roundies:filetypes-confirm-file': '\ued85',
        'roundies:filetypes-confirm-security-file': '\ued86',
        'roundies:filetypes-css': '\ued87',
        'roundies:filetypes-dat': '\ued88',
        'roundies:filetypes-delete-file': '\ued89',
        'roundies:filetypes-dmg': '\ued8a',
        'roundies:filetypes-doc': '\ued8b',
        'roundies:filetypes-dot': '\ued8c',
        'roundies:filetypes-download-file': '\ued8d',
        'roundies:filetypes-drive-file': '\ued8e',
        'roundies:filetypes-dxf': '\ued8f',
        'roundies:filetypes-elements-file': '\ued90',
        'roundies:filetypes-email-file': '\ued91',
        'roundies:filetypes-eps': '\ued92',
        'roundies:filetypes-exe': '\ued93',
        'roundies:filetypes-favourite-file': '\ued94',
        'roundies:filetypes-file': '\ued95',
        'roundies:filetypes-flac': '\ued96',
        'roundies:filetypes-flv': '\ued97',
        'roundies:filetypes-gif': '\ued98',
        'roundies:filetypes-graphic-file': '\ued99',
        'roundies:filetypes-hashtag-file': '\ued9a',
        'roundies:filetypes-image-file': '\ued9b',
        'roundies:filetypes-information-file': '\ued9c',
        'roundies:filetypes-internet-file': '\ued9d',
        'roundies:filetypes-jpg': '\ued9e',
        'roundies:filetypes-key': '\ued9f',
        'roundies:filetypes-keyhole-file': '\ueda0',
        'roundies:filetypes-leaf-file': '\ueda1',
        'roundies:filetypes-link-file': '\ueda2',
        'roundies:filetypes-list-file': '\ueda3',
        'roundies:filetypes-lock-file': '\ueda4',
        'roundies:filetypes-m4v': '\ueda5',
        'roundies:filetypes-message-file': '\ueda6',
        'roundies:filetypes-mov': '\ueda7',
        'roundies:filetypes-mp3': '\ueda8',
        'roundies:filetypes-mp4': '\ueda9',
        'roundies:filetypes-mpg': '\uedaa',
        'roundies:filetypes-music-file': '\uedab',
        'roundies:filetypes-music': '\uedac',
        'roundies:filetypes-ods': '\uedad',
        'roundies:filetypes-options-file': '\uedae',
        'roundies:filetypes-pdf': '\uedaf',
        'roundies:filetypes-personal-file': '\uedb0',
        'roundies:filetypes-php': '\uedb1',
        'roundies:filetypes-pie-chart-file': '\uedb2',
        'roundies:filetypes-play-file': '\uedb3',
        'roundies:filetypes-plug-in-file': '\uedb4',
        'roundies:filetypes-png': '\uedb5',
        'roundies:filetypes-pps': '\uedb6',
        'roundies:filetypes-ppt': '\uedb7',
        'roundies:filetypes-psd': '\uedb8',
        'roundies:filetypes-rar': '\uedb9',
        'roundies:filetypes-record-file': '\uedba',
        'roundies:filetypes-remove-file': '\uedbb',
        'roundies:filetypes-rtf': '\uedbc',
        'roundies:filetypes-search-file': '\uedbd',
        'roundies:filetypes-security-file': '\uedbe',
        'roundies:filetypes-settings-file': '\uedbf',
        'roundies:filetypes-shapes-file': '\uedc0',
        'roundies:filetypes-share-file': '\uedc1',
        'roundies:filetypes-specific-audio-file': '\uedc2',
        'roundies:filetypes-speed-file': '\uedc3',
        'roundies:filetypes-sql': '\uedc4',
        'roundies:filetypes-text-article-file': '\uedc5',
        'roundies:filetypes-text-file': '\uedc6',
        'roundies:filetypes-text': '\uedc7',
        'roundies:filetypes-tga': '\uedc8',
        'roundies:filetypes-tiff': '\uedc9',
        'roundies:filetypes-txt': '\uedca',
        'roundies:filetypes-unlock-file': '\uedcb',
        'roundies:filetypes-upload-file': '\uedcc',
        'roundies:filetypes-video-file': '\uedcd',
        'roundies:filetypes-view-file': '\uedce',
        'roundies:filetypes-virus-file': '\uedcf',
        'roundies:filetypes-wifi-file': '\uedd0',
        'roundies:filetypes-xls': '\uedd1',
        'roundies:filetypes-xml': '\uedd2',
        'roundies:filetypes-zip-file': '\uedd3',
        'roundies:filetypes-zip': '\uedd4',
        'roundies:folder-aac': '\uedd5',
        'roundies:folder-add-folder': '\uedd6',
        'roundies:folder-ai': '\uedd7',
        'roundies:folder-aiff': '\uedd8',
        'roundies:folder-alert-folder': '\uedd9',
        'roundies:folder-apk': '\uedda',
        'roundies:folder-article-folder': '\ueddb',
        'roundies:folder-audio-folder': '\ueddc',
        'roundies:folder-audio-specific-folder': '\ueddd',
        'roundies:folder-avi': '\uedde',
        'roundies:folder-bar-chart-folder': '\ueddf',
        'roundies:folder-bmp': '\uede0',
        'roundies:folder-bookmark-folder': '\uede1',
        'roundies:folder-broken-link-folder': '\uede2',
        'roundies:folder-bug-folder': '\uede3',
        'roundies:folder-camera-folder': '\uede4',
        'roundies:folder-clips-folder': '\uede5',
        'roundies:folder-cloud-folder': '\uede6',
        'roundies:folder-code-folder': '\uede7',
        'roundies:folder-coding-folder': '\uede8',
        'roundies:folder-confirm-folder': '\uede9',
        'roundies:folder-confirm-security-folder': '\uedea',
        'roundies:folder-css': '\uedeb',
        'roundies:folder-dat': '\uedec',
        'roundies:folder-delete-folder': '\ueded',
        'roundies:folder-design-folder': '\uedee',
        'roundies:folder-dmg': '\uedef',
        'roundies:folder-doc': '\uedf0',
        'roundies:folder-dot': '\uedf1',
        'roundies:folder-download-folder': '\uedf2',
        'roundies:folder-drive-folder': '\uedf3',
        'roundies:folder-dxf': '\uedf4',
        'roundies:folder-elements-folder': '\uedf5',
        'roundies:folder-email-folder': '\uedf6',
        'roundies:folder-eps': '\uedf7',
        'roundies:folder-exe': '\uedf8',
        'roundies:folder-favourite-folder': '\uedf9',
        'roundies:folder-flac': '\uedfa',
        'roundies:folder-flv': '\uedfb',
        'roundies:folder-folder': '\uedfc',
        'roundies:folder-gif': '\uedfd',
        'roundies:folder-hashtag-folder': '\uedfe',
        'roundies:folder-image-folder': '\uedff',
        'roundies:folder-information-folder': '\uee00',
        'roundies:folder-internet-folder': '\uee01',
        'roundies:folder-jpg': '\uee02',
        'roundies:folder-key': '\uee03',
        'roundies:folder-keyhole-folder': '\uee04',
        'roundies:folder-leaf-folder': '\uee05',
        'roundies:folder-link-folder': '\uee06',
        'roundies:folder-list-folder': '\uee07',
        'roundies:folder-lock-folder': '\uee08',
        'roundies:folder-m4v': '\uee09',
        'roundies:folder-message-folder': '\uee0a',
        'roundies:folder-mov': '\uee0b',
        'roundies:folder-mp3': '\uee0c',
        'roundies:folder-mp4': '\uee0d',
        'roundies:folder-mpg': '\uee0e',
        'roundies:folder-music-folder': '\uee0f',
        'roundies:folder-music': '\uee10',
        'roundies:folder-ods': '\uee11',
        'roundies:folder-options-folder': '\uee12',
        'roundies:folder-pdf': '\uee13',
        'roundies:folder-personal-folder': '\uee14',
        'roundies:folder-php': '\uee15',
        'roundies:folder-pie-chart-folder': '\uee16',
        'roundies:folder-play-folder': '\uee17',
        'roundies:folder-plug-in-folder': '\uee18',
        'roundies:folder-png': '\uee19',
        'roundies:folder-pps': '\uee1a',
        'roundies:folder-ppt': '\uee1b',
        'roundies:folder-psd': '\uee1c',
        'roundies:folder-rar': '\uee1d',
        'roundies:folder-record-folder': '\uee1e',
        'roundies:folder-remove-folder': '\uee1f',
        'roundies:folder-rtf': '\uee20',
        'roundies:folder-search-folder': '\uee21',
        'roundies:folder-security-folder': '\uee22',
        'roundies:folder-settings-folder': '\uee23',
        'roundies:folder-shapes-folder': '\uee24',
        'roundies:folder-share-folder': '\uee25',
        'roundies:folder-specific-audio-folder': '\uee26',
        'roundies:folder-speed-folder': '\uee27',
        'roundies:folder-sql': '\uee28',
        'roundies:folder-text-article-folder': '\uee29',
        'roundies:folder-text-folder': '\uee2a',
        'roundies:folder-text': '\uee2b',
        'roundies:folder-tga': '\uee2c',
        'roundies:folder-tiff': '\uee2d',
        'roundies:folder-txt': '\uee2e',
        'roundies:folder-unlock-folder': '\uee2f',
        'roundies:folder-upload-folder': '\uee30',
        'roundies:folder-video-folder': '\uee31',
        'roundies:folder-view-folder': '\uee32',
        'roundies:folder-virus-folder': '\uee33',
        'roundies:folder-wifi-folder': '\uee34',
        'roundies:folder-xls': '\uee35',
        'roundies:folder-xml': '\uee36',
        'roundies:folder-zip-folder': '\uee37',
        'roundies:folder-zip': '\uee38',
        'roundies:food-apple': '\uee39',
        'roundies:food-asparagus': '\uee3a',
        'roundies:food-avocado': '\uee3b',
        'roundies:food-bacon': '\uee3c',
        'roundies:food-baguette': '\uee3d',
        'roundies:food-banana': '\uee3e',
        'roundies:food-bean': '\uee3f',
        'roundies:food-beans': '\uee40',
        'roundies:food-beer': '\uee41',
        'roundies:food-birthday-cake': '\uee42',
        'roundies:food-blueberries': '\uee43',
        'roundies:food-boiled-egg': '\uee44',
        'roundies:food-bowl': '\uee45',
        'roundies:food-bread': '\uee46',
        'roundies:food-brocolli': '\uee47',
        'roundies:food-burger': '\uee48',
        'roundies:food-carrot-vegetable': '\uee49',
        'roundies:food-carrot': '\uee4a',
        'roundies:food-cauliflower': '\uee4b',
        'roundies:food-champagne': '\uee4c',
        'roundies:food-cheese-with-holes': '\uee4d',
        'roundies:food-cheese': '\uee4e',
        'roundies:food-cherries': '\uee4f',
        'roundies:food-cherry': '\uee50',
        'roundies:food-chicken': '\uee51',
        'roundies:food-chili': '\uee52',
        'roundies:food-chinese-rice': '\uee53',
        'roundies:food-cocktail': '\uee54',
        'roundies:food-coffee-beans': '\uee55',
        'roundies:food-coffee-mug': '\uee56',
        'roundies:food-coffee': '\uee57',
        'roundies:food-cookie': '\uee58',
        'roundies:food-cracked-egg': '\uee59',
        'roundies:food-cupcake': '\uee5a',
        'roundies:food-dessert': '\uee5b',
        'roundies:food-donut': '\uee5c',
        'roundies:food-double-burger': '\uee5d',
        'roundies:food-egg': '\uee5e',
        'roundies:food-exotic-fruit': '\uee5f',
        'roundies:food-fish': '\uee60',
        'roundies:food-french-fries': '\uee61',
        'roundies:food-fruit': '\uee62',
        'roundies:food-garlic': '\uee63',
        'roundies:food-glass': '\uee64',
        'roundies:food-grapes': '\uee65',
        'roundies:food-hard-egg': '\uee66',
        'roundies:food-ice-cream-bowl': '\uee67',
        'roundies:food-ice-cream-cone': '\uee68',
        'roundies:food-ice-cream-stick': '\uee69',
        'roundies:food-ice-cream': '\uee6a',
        'roundies:food-leg': '\uee6b',
        'roundies:food-lemon': '\uee6c',
        'roundies:food-lollipop': '\uee6d',
        'roundies:food-lollipops': '\uee6e',
        'roundies:food-martini': '\uee6f',
        'roundies:food-milkshake': '\uee70',
        'roundies:food-mug': '\uee71',
        'roundies:food-mushroom': '\uee72',
        'roundies:food-nacho': '\uee73',
        'roundies:food-noodles-from-box': '\uee74',
        'roundies:food-noodles': '\uee75',
        'roundies:food-orange-slice': '\uee76',
        'roundies:food-orange': '\uee77',
        'roundies:food-paprika': '\uee78',
        'roundies:food-peach': '\uee79',
        'roundies:food-pear': '\uee7a',
        'roundies:food-peas': '\uee7b',
        'roundies:food-pickles': '\uee7c',
        'roundies:food-pineapple': '\uee7d',
        'roundies:food-pizza-slice': '\uee7e',
        'roundies:food-pizza': '\uee7f',
        'roundies:food-popcorn': '\uee80',
        'roundies:food-potato': '\uee81',
        'roundies:food-pretzel': '\uee82',
        'roundies:food-sausage': '\uee83',
        'roundies:food-scotch-glass': '\uee84',
        'roundies:food-shot-glass': '\uee85',
        'roundies:food-soda-can': '\uee86',
        'roundies:food-soft-egg': '\uee87',
        'roundies:food-spaghetti-bowl': '\uee88',
        'roundies:food-spaghetti-from-box': '\uee89',
        'roundies:food-spaghetti-plate': '\uee8a',
        'roundies:food-sprout': '\uee8b',
        'roundies:food-star': '\uee8c',
        'roundies:food-steak': '\uee8d',
        'roundies:food-strawberry': '\uee8e',
        'roundies:food-sushi-rolls': '\uee8f',
        'roundies:food-sushi-triangle': '\uee90',
        'roundies:food-sushi': '\uee91',
        'roundies:food-taco': '\uee92',
        'roundies:food-tasty-burger': '\uee93',
        'roundies:food-toast': '\uee94',
        'roundies:food-tomato': '\uee95',
        'roundies:food-turnip': '\uee96',
        'roundies:food-vegetable': '\uee97',
        'roundies:food-watermelon': '\uee98',
        'roundies:food-wheat': '\uee99',
        'roundies:food-wine-glass': '\uee9a',
        'roundies:food-wing': '\uee9b',
        'roundies:food-wrap': '\uee9c',
        'roundies:games-and-sports-120': '\uee9d',
        'roundies:games-and-sports-30': '\uee9e',
        'roundies:games-and-sports-60': '\uee9f',
        'roundies:games-and-sports-badminton': '\ueea0',
        'roundies:games-and-sports-baseball-helmet': '\ueea1',
        'roundies:games-and-sports-baseball': '\ueea2',
        'roundies:games-and-sports-baseball_1': '\ueea3',
        'roundies:games-and-sports-basketball-net': '\ueea4',
        'roundies:games-and-sports-basketball': '\ueea5',
        'roundies:games-and-sports-billiard-table': '\ueea6',
        'roundies:games-and-sports-billiard-triangle': '\ueea7',
        'roundies:games-and-sports-bishop': '\ueea8',
        'roundies:games-and-sports-bow-and-arrow': '\ueea9',
        'roundies:games-and-sports-bowling': '\ueeaa',
        'roundies:games-and-sports-boxing-glove': '\ueeab',
        'roundies:games-and-sports-canoe': '\ueeac',
        'roundies:games-and-sports-chess-board': '\ueead',
        'roundies:games-and-sports-clubs': '\ueeae',
        'roundies:games-and-sports-diamonds': '\ueeaf',
        'roundies:games-and-sports-directions': '\ueeb0',
        'roundies:games-and-sports-domino': '\ueeb1',
        'roundies:games-and-sports-eight-ball': '\ueeb2',
        'roundies:games-and-sports-ez': '\ueeb3',
        'roundies:games-and-sports-first-place-medal': '\ueeb4',
        'roundies:games-and-sports-first-place': '\ueeb5',
        'roundies:games-and-sports-five-dice': '\ueeb6',
        'roundies:games-and-sports-five-weight': '\ueeb7',
        'roundies:games-and-sports-football-helmet': '\ueeb8',
        'roundies:games-and-sports-football': '\ueeb9',
        'roundies:games-and-sports-four-dice': '\ueeba',
        'roundies:games-and-sports-frisbee': '\ueebb',
        'roundies:games-and-sports-game-plan': '\ueebc',
        'roundies:games-and-sports-gamepad': '\ueebd',
        'roundies:games-and-sports-gg': '\ueebe',
        'roundies:games-and-sports-golf': '\ueebf',
        'roundies:games-and-sports-handheld-game': '\ueec0',
        'roundies:games-and-sports-hearts': '\ueec1',
        'roundies:games-and-sports-hockey-mask': '\ueec2',
        'roundies:games-and-sports-hockey': '\ueec3',
        'roundies:games-and-sports-horse': '\ueec4',
        'roundies:games-and-sports-ice-skate': '\ueec5',
        'roundies:games-and-sports-increase-lives': '\ueec6',
        'roundies:games-and-sports-increase-settings': '\ueec7',
        'roundies:games-and-sports-jersey': '\ueec8',
        'roundies:games-and-sports-joystick': '\ueec9',
        'roundies:games-and-sports-jumping-rope': '\ueeca',
        'roundies:games-and-sports-king': '\ueecb',
        'roundies:games-and-sports-motorcycle-helmet': '\ueecc',
        'roundies:games-and-sports-noob': '\ueecd',
        'roundies:games-and-sports-olympic-flame': '\ueece',
        'roundies:games-and-sports-one-arrow-up': '\ueecf',
        'roundies:games-and-sports-one-dice': '\ueed0',
        'roundies:games-and-sports-one-star-trophy': '\ueed1',
        'roundies:games-and-sports-pacman': '\ueed2',
        'roundies:games-and-sports-pawn': '\ueed3',
        'roundies:games-and-sports-potions': '\ueed4',
        'roundies:games-and-sports-queen': '\ueed5',
        'roundies:games-and-sports-race-flag': '\ueed6',
        'roundies:games-and-sports-racket': '\ueed7',
        'roundies:games-and-sports-retro-game': '\ueed8',
        'roundies:games-and-sports-retro-handheld-game': '\ueed9',
        'roundies:games-and-sports-roller-skate': '\ueeda',
        'roundies:games-and-sports-round-gamepad': '\ueedb',
        'roundies:games-and-sports-sailing': '\ueedc',
        'roundies:games-and-sports-score-board': '\ueedd',
        'roundies:games-and-sports-second-place-medal': '\ueede',
        'roundies:games-and-sports-second-place': '\ueedf',
        'roundies:games-and-sports-shield': '\ueee0',
        'roundies:games-and-sports-six-dice': '\ueee1',
        'roundies:games-and-sports-skateboard': '\ueee2',
        'roundies:games-and-sports-soccer-ball': '\ueee3',
        'roundies:games-and-sports-soccer-field': '\ueee4',
        'roundies:games-and-sports-soccer-goal': '\ueee5',
        'roundies:games-and-sports-solid-ball': '\ueee6',
        'roundies:games-and-sports-spades': '\ueee7',
        'roundies:games-and-sports-sports': '\ueee8',
        'roundies:games-and-sports-steering-wheel': '\ueee9',
        'roundies:games-and-sports-stripes-ball': '\ueeea',
        'roundies:games-and-sports-surfboard': '\ueeeb',
        'roundies:games-and-sports-swimming': '\ueeec',
        'roundies:games-and-sports-sword': '\ueeed',
        'roundies:games-and-sports-table-tennis': '\ueeee',
        'roundies:games-and-sports-target': '\ueeef',
        'roundies:games-and-sports-third-place-medal': '\ueef0',
        'roundies:games-and-sports-third-place': '\ueef1',
        'roundies:games-and-sports-thirteen': '\ueef2',
        'roundies:games-and-sports-three-arrow-up': '\ueef3',
        'roundies:games-and-sports-three-dice': '\ueef4',
        'roundies:games-and-sports-three-star-trophy': '\ueef5',
        'roundies:games-and-sports-throwing-star': '\ueef6',
        'roundies:games-and-sports-tower': '\ueef7',
        'roundies:games-and-sports-two-arrow-up': '\ueef8',
        'roundies:games-and-sports-two-dice': '\ueef9',
        'roundies:games-and-sports-two-star-trophy': '\ueefa',
        'roundies:games-and-sports-weights': '\ueefb',
        'roundies:games-and-sports-whistle': '\ueefc',
        'roundies:games-and-sports-winner': '\ueefd',
        'roundies:games-and-sports-winning-places': '\ueefe',
        'roundies:games-and-sports-wizard-hat': '\ueeff',
        'roundies:games-and-sports-x-o': '\uef00',
        'roundies:holidays-angel': '\uef01',
        'roundies:holidays-broken-heart': '\uef02',
        'roundies:holidays-champagne-bottle': '\uef03',
        'roundies:holidays-christmas-balloon': '\uef04',
        'roundies:holidays-christmas-bookmark': '\uef05',
        'roundies:holidays-christmas-calendar': '\uef06',
        'roundies:holidays-christmas-email': '\uef07',
        'roundies:holidays-christmas-fireworks': '\uef08',
        'roundies:holidays-christmas-gift': '\uef09',
        'roundies:holidays-christmas-message': '\uef0a',
        'roundies:holidays-christmas-snowglobe': '\uef0b',
        'roundies:holidays-christmas-stocking': '\uef0c',
        'roundies:holidays-christmas-tree-ornament': '\uef0d',
        'roundies:holidays-christmas-tree': '\uef0e',
        'roundies:holidays-christmas-tree_1': '\uef0f',
        'roundies:holidays-cocktail': '\uef10',
        'roundies:holidays-coffee': '\uef11',
        'roundies:holidays-couple': '\uef12',
        'roundies:holidays-date-calendar': '\uef13',
        'roundies:holidays-date-search': '\uef14',
        'roundies:holidays-dating-app': '\uef15',
        'roundies:holidays-gingerbread-man': '\uef16',
        'roundies:holidays-guitar': '\uef17',
        'roundies:holidays-heart-care': '\uef18',
        'roundies:holidays-heart-lock': '\uef19',
        'roundies:holidays-home-snowglobe': '\uef1a',
        'roundies:holidays-love-key': '\uef1b',
        'roundies:holidays-love-protection': '\uef1c',
        'roundies:holidays-love-thought': '\uef1d',
        'roundies:holidays-love-tickets': '\uef1e',
        'roundies:holidays-mistletoe': '\uef1f',
        'roundies:holidays-online-dating': '\uef20',
        'roundies:holidays-shooting-heart': '\uef21',
        'roundies:holidays-shopping-bag': '\uef22',
        'roundies:holidays-snow-': '\uef23',
        'roundies:holidays-snowflake': '\uef24',
        'roundies:holidays-snowman-snowglobe': '\uef25',
        'roundies:holidays-star-card': '\uef26',
        'roundies:holidays-valentine-alert': '\uef27',
        'roundies:holidays-valentine-balloon': '\uef28',
        'roundies:holidays-valentine-calendar': '\uef29',
        'roundies:holidays-valentine-card': '\uef2a',
        'roundies:holidays-valentine-email': '\uef2b',
        'roundies:holidays-valentine-fireworks': '\uef2c',
        'roundies:holidays-valentine-gift': '\uef2d',
        'roundies:holidays-valentine-location': '\uef2e',
        'roundies:holidays-valentine-message': '\uef2f',
        'roundies:holidays-valentine-thought': '\uef30',
        'roundies:holidays-valentine-view': '\uef31',
        'roundies:holidays-valentines-day': '\uef32',
        'roundies:home-equipment-air-conditioner': '\uef33',
        'roundies:home-equipment-alarm-clock': '\uef34',
        'roundies:home-equipment-automizer': '\uef35',
        'roundies:home-equipment-bathtub': '\uef36',
        'roundies:home-equipment-blender': '\uef37',
        'roundies:home-equipment-blending-mixer': '\uef38',
        'roundies:home-equipment-bluetooth': '\uef39',
        'roundies:home-equipment-bottle-opener': '\uef3a',
        'roundies:home-equipment-bowl': '\uef3b',
        'roundies:home-equipment-butcher-knife': '\uef3c',
        'roundies:home-equipment-cactus': '\uef3d',
        'roundies:home-equipment-chef-hat': '\uef3e',
        'roundies:home-equipment-chopping-board': '\uef3f',
        'roundies:home-equipment-chopsticks': '\uef40',
        'roundies:home-equipment-cloche': '\uef41',
        'roundies:home-equipment-clock': '\uef42',
        'roundies:home-equipment-coffee-machine': '\uef43',
        'roundies:home-equipment-coffee-maker': '\uef44',
        'roundies:home-equipment-cooking-tool': '\uef45',
        'roundies:home-equipment-cutlery-spoon': '\uef46',
        'roundies:home-equipment-desk-lamp': '\uef47',
        'roundies:home-equipment-dish-washer': '\uef48',
        'roundies:home-equipment-dishwasher': '\uef49',
        'roundies:home-equipment-door': '\uef4a',
        'roundies:home-equipment-egg-in-pan': '\uef4b',
        'roundies:home-equipment-equipment': '\uef4c',
        'roundies:home-equipment-espresso-machine': '\uef4d',
        'roundies:home-equipment-fan': '\uef4e',
        'roundies:home-equipment-flower': '\uef4f',
        'roundies:home-equipment-fork-and-knife': '\uef50',
        'roundies:home-equipment-fork-and-spoon': '\uef51',
        'roundies:home-equipment-freezer': '\uef52',
        'roundies:home-equipment-fridge': '\uef53',
        'roundies:home-equipment-grate': '\uef54',
        'roundies:home-equipment-hair-dryer': '\uef55',
        'roundies:home-equipment-heater': '\uef56',
        'roundies:home-equipment-home-equipment': '\uef57',
        'roundies:home-equipment-hot-pan': '\uef58',
        'roundies:home-equipment-iron': '\uef59',
        'roundies:home-equipment-juicer': '\uef5a',
        'roundies:home-equipment-knife-and-spoon': '\uef5b',
        'roundies:home-equipment-ladel': '\uef5c',
        'roundies:home-equipment-lamp': '\uef5d',
        'roundies:home-equipment-lava-lamp': '\uef5e',
        'roundies:home-equipment-lightbulb': '\uef5f',
        'roundies:home-equipment-measuring-cup': '\uef60',
        'roundies:home-equipment-microwave': '\uef61',
        'roundies:home-equipment-mini-fridge': '\uef62',
        'roundies:home-equipment-mixer': '\uef63',
        'roundies:home-equipment-modem': '\uef64',
        'roundies:home-equipment-monitor': '\uef65',
        'roundies:home-equipment-oven-mitt': '\uef66',
        'roundies:home-equipment-oven': '\uef67',
        'roundies:home-equipment-plant-five': '\uef68',
        'roundies:home-equipment-plant-four': '\uef69',
        'roundies:home-equipment-plant-one': '\uef6a',
        'roundies:home-equipment-plant-seven': '\uef6b',
        'roundies:home-equipment-plant-six': '\uef6c',
        'roundies:home-equipment-plant-three': '\uef6d',
        'roundies:home-equipment-plant-two': '\uef6e',
        'roundies:home-equipment-plate': '\uef6f',
        'roundies:home-equipment-plates': '\uef70',
        'roundies:home-equipment-pot-one': '\uef71',
        'roundies:home-equipment-pot-three': '\uef72',
        'roundies:home-equipment-pot-two': '\uef73',
        'roundies:home-equipment-radio-one': '\uef74',
        'roundies:home-equipment-radio': '\uef75',
        'roundies:home-equipment-remote': '\uef76',
        'roundies:home-equipment-rolling-pin': '\uef77',
        'roundies:home-equipment-round-system': '\uef78',
        'roundies:home-equipment-rounded-monitor': '\uef79',
        'roundies:home-equipment-rounded-tv': '\uef7a',
        'roundies:home-equipment-salt-and-pepper': '\uef7b',
        'roundies:home-equipment-scale': '\uef7c',
        'roundies:home-equipment-shower': '\uef7d',
        'roundies:home-equipment-sink': '\uef7e',
        'roundies:home-equipment-socket': '\uef7f',
        'roundies:home-equipment-spatchula': '\uef80',
        'roundies:home-equipment-speaker': '\uef81',
        'roundies:home-equipment-standing-fan': '\uef82',
        'roundies:home-equipment-steam-shower': '\uef83',
        'roundies:home-equipment-strainer': '\uef84',
        'roundies:home-equipment-table-lamp': '\uef85',
        'roundies:home-equipment-television': '\uef86',
        'roundies:home-equipment-toaster': '\uef87',
        'roundies:home-equipment-toilet-paper': '\uef88',
        'roundies:home-equipment-toilet': '\uef89',
        'roundies:home-equipment-tv-and-sound-system': '\uef8a',
        'roundies:home-equipment-tv': '\uef8b',
        'roundies:home-equipment-urinal': '\uef8c',
        'roundies:home-equipment-vacuum-cleaner': '\uef8d',
        'roundies:home-equipment-vacuum': '\uef8e',
        'roundies:home-equipment-vent': '\uef8f',
        'roundies:home-equipment-washing-machine': '\uef90',
        'roundies:home-equipment-water-boiler': '\uef91',
        'roundies:home-equipment-water-cooler': '\uef92',
        'roundies:home-equipment-water-kettle': '\uef93',
        'roundies:home-equipment-whisk': '\uef94',
        'roundies:home-equipment-wine-bottle-opener': '\uef95',
        'roundies:home-interior-armchair': '\uef96',
        'roundies:home-interior-bar': '\uef97',
        'roundies:home-interior-bed-side-lamp-one': '\uef98',
        'roundies:home-interior-bed-side-lamp-three': '\uef99',
        'roundies:home-interior-bed-side-lamp-two': '\uef9a',
        'roundies:home-interior-bed': '\uef9b',
        'roundies:home-interior-book-shelves': '\uef9c',
        'roundies:home-interior-box': '\uef9d',
        'roundies:home-interior-bunk-beds': '\uef9e',
        'roundies:home-interior-ceiling-lamp': '\uef9f',
        'roundies:home-interior-ceiling-lighting': '\uefa0',
        'roundies:home-interior-ceiling-round-lamp': '\uefa1',
        'roundies:home-interior-ceiling-square-lamp': '\uefa2',
        'roundies:home-interior-chair-five': '\uefa3',
        'roundies:home-interior-chair-four': '\uefa4',
        'roundies:home-interior-chair-one': '\uefa5',
        'roundies:home-interior-chair-six': '\uefa6',
        'roundies:home-interior-chair-three': '\uefa7',
        'roundies:home-interior-chair-two': '\uefa8',
        'roundies:home-interior-closet-with-shelves': '\uefa9',
        'roundies:home-interior-closet': '\uefaa',
        'roundies:home-interior-clothing-hanger': '\uefab',
        'roundies:home-interior-coat-hanger-four': '\uefac',
        'roundies:home-interior-coat-hanger-one': '\uefad',
        'roundies:home-interior-coat-hanger-three': '\uefae',
        'roundies:home-interior-coat-hanger-two': '\uefaf',
        'roundies:home-interior-coat-hanger': '\uefb0',
        'roundies:home-interior-crib': '\uefb1',
        'roundies:home-interior-desk': '\uefb2',
        'roundies:home-interior-dining-chair': '\uefb3',
        'roundies:home-interior-dining-room': '\uefb4',
        'roundies:home-interior-dining-table-five': '\uefb5',
        'roundies:home-interior-dining-table-four': '\uefb6',
        'roundies:home-interior-dining-table-one': '\uefb7',
        'roundies:home-interior-dining-table-three': '\uefb8',
        'roundies:home-interior-dining-table-two': '\uefb9',
        'roundies:home-interior-double-square-end-table': '\uefba',
        'roundies:home-interior-downstairs': '\uefbb',
        'roundies:home-interior-four-panel-closet': '\uefbc',
        'roundies:home-interior-grandfather-clock': '\uefbd',
        'roundies:home-interior-high-stool': '\uefbe',
        'roundies:home-interior-ipod-dock': '\uefbf',
        'roundies:home-interior-ladder': '\uefc0',
        'roundies:home-interior-living-room-table': '\uefc1',
        'roundies:home-interior-modern-chair': '\uefc2',
        'roundies:home-interior-office-chair-four': '\uefc3',
        'roundies:home-interior-office-chair-one': '\uefc4',
        'roundies:home-interior-office-chair-three': '\uefc5',
        'roundies:home-interior-office-chair-two': '\uefc6',
        'roundies:home-interior-open-dining-chair': '\uefc7',
        'roundies:home-interior-oval-chair': '\uefc8',
        'roundies:home-interior-plant-five': '\uefc9',
        'roundies:home-interior-plant-four': '\uefca',
        'roundies:home-interior-plant-one': '\uefcb',
        'roundies:home-interior-plant-three': '\uefcc',
        'roundies:home-interior-plant-two': '\uefcd',
        'roundies:home-interior-plug': '\uefce',
        'roundies:home-interior-rocking-crib': '\uefcf',
        'roundies:home-interior-round-door-window': '\uefd0',
        'roundies:home-interior-round-door-windows': '\uefd1',
        'roundies:home-interior-round-door': '\uefd2',
        'roundies:home-interior-round-end-table': '\uefd3',
        'roundies:home-interior-round-mirror': '\uefd4',
        'roundies:home-interior-round-security-camera': '\uefd5',
        'roundies:home-interior-round-table': '\uefd6',
        'roundies:home-interior-round-window': '\uefd7',
        'roundies:home-interior-satellite': '\uefd8',
        'roundies:home-interior-security-camera': '\uefd9',
        'roundies:home-interior-shelf': '\uefda',
        'roundies:home-interior-shelves': '\uefdb',
        'roundies:home-interior-shelving': '\uefdc',
        'roundies:home-interior-socket': '\uefdd',
        'roundies:home-interior-sound-system': '\uefde',
        'roundies:home-interior-speaker': '\uefdf',
        'roundies:home-interior-square-door-window': '\uefe0',
        'roundies:home-interior-square-door-windows': '\uefe1',
        'roundies:home-interior-square-door': '\uefe2',
        'roundies:home-interior-square-end-table': '\uefe3',
        'roundies:home-interior-square-mirror': '\uefe4',
        'roundies:home-interior-stool': '\uefe5',
        'roundies:home-interior-sweep': '\uefe6',
        'roundies:home-interior-three-couch': '\uefe7',
        'roundies:home-interior-three-door-closet': '\uefe8',
        'roundies:home-interior-three-drawers': '\uefe9',
        'roundies:home-interior-three-panel-drawers': '\uefea',
        'roundies:home-interior-two-couch': '\uefeb',
        'roundies:home-interior-two-door-closet': '\uefec',
        'roundies:home-interior-two-drawers': '\uefed',
        'roundies:home-interior-upstairs': '\uefee',
        'roundies:home-interior-window': '\uefef',
        'roundies:internet-security-account-focus': '\ueff0',
        'roundies:internet-security-account-security': '\ueff1',
        'roundies:internet-security-account-settings': '\ueff2',
        'roundies:internet-security-broken-security': '\ueff3',
        'roundies:internet-security-browser-code': '\ueff4',
        'roundies:internet-security-browser-lock': '\ueff5',
        'roundies:internet-security-browser-security-confirm': '\ueff6',
        'roundies:internet-security-browser-unlock': '\ueff7',
        'roundies:internet-security-cancel-view': '\ueff8',
        'roundies:internet-security-care-about-security': '\ueff9',
        'roundies:internet-security-care-about-wifi': '\ueffa',
        'roundies:internet-security-cloud-lock': '\ueffb',
        'roundies:internet-security-cloud-security-confirm': '\ueffc',
        'roundies:internet-security-computer-virus': '\ueffd',
        'roundies:internet-security-confirm-fingerprint': '\ueffe',
        'roundies:internet-security-confirm-view': '\uefff',
        'roundies:internet-security-conversation-security-confirm': '\uf000',
        'roundies:internet-security-credit-card-security-confirm': '\uf001',
        'roundies:internet-security-danger': '\uf002',
        'roundies:internet-security-detect-bug': '\uf003',
        'roundies:internet-security-fingerprint': '\uf004',
        'roundies:internet-security-firewall-security-confirm': '\uf005',
        'roundies:internet-security-firewall': '\uf006',
        'roundies:internet-security-focus-cancelled': '\uf007',
        'roundies:internet-security-focus-confirmation': '\uf008',
        'roundies:internet-security-focus-fingerprint-cancelled': '\uf009',
        'roundies:internet-security-focus-fingerprint-confirmed': '\uf00a',
        'roundies:internet-security-focus-fingerprint-target': '\uf00b',
        'roundies:internet-security-focus-fingerprint': '\uf00c',
        'roundies:internet-security-focus-lock-visibility': '\uf00d',
        'roundies:internet-security-focus-lock': '\uf00e',
        'roundies:internet-security-focus-protection': '\uf00f',
        'roundies:internet-security-focus': '\uf010',
        'roundies:internet-security-folder-lock': '\uf011',
        'roundies:internet-security-folder-locked': '\uf012',
        'roundies:internet-security-folder-security-confirm': '\uf013',
        'roundies:internet-security-folder-security-confirm_1': '\uf014',
        'roundies:internet-security-folder-unlock': '\uf015',
        'roundies:internet-security-hacker-lock': '\uf016',
        'roundies:internet-security-hacker-security-confirm': '\uf017',
        'roundies:internet-security-hacker-virus': '\uf018',
        'roundies:internet-security-hacker': '\uf019',
        'roundies:internet-security-internet-focus': '\uf01a',
        'roundies:internet-security-internet-secured': '\uf01b',
        'roundies:internet-security-internet-security-confirm': '\uf01c',
        'roundies:internet-security-key': '\uf01d',
        'roundies:internet-security-laptop-bug': '\uf01e',
        'roundies:internet-security-laptop-lock': '\uf01f',
        'roundies:internet-security-laptop-password': '\uf020',
        'roundies:internet-security-laptop-security-confirm': '\uf021',
        'roundies:internet-security-laptop-ssl': '\uf022',
        'roundies:internet-security-laptop-unlock': '\uf023',
        'roundies:internet-security-laptop-virus': '\uf024',
        'roundies:internet-security-lock-visibility': '\uf025',
        'roundies:internet-security-lock': '\uf026',
        'roundies:internet-security-maintenance': '\uf027',
        'roundies:internet-security-money-security-confirm': '\uf028',
        'roundies:internet-security-monitor-bug': '\uf029',
        'roundies:internet-security-monitor-lock': '\uf02a',
        'roundies:internet-security-monitor-password': '\uf02b',
        'roundies:internet-security-monitor-security-confirm': '\uf02c',
        'roundies:internet-security-monitor-ssl': '\uf02d',
        'roundies:internet-security-monitor-unlock': '\uf02e',
        'roundies:internet-security-no-fingerprint': '\uf02f',
        'roundies:internet-security-passcode-input': '\uf030',
        'roundies:internet-security-password-security-confirm': '\uf031',
        'roundies:internet-security-pattern-lock': '\uf032',
        'roundies:internet-security-police': '\uf033',
        'roundies:internet-security-search-bug': '\uf034',
        'roundies:internet-security-search': '\uf035',
        'roundies:internet-security-secret': '\uf036',
        'roundies:internet-security-secure-bug': '\uf037',
        'roundies:internet-security-secure-virus': '\uf038',
        'roundies:internet-security-secured-account-man': '\uf039',
        'roundies:internet-security-secured-account-woman': '\uf03a',
        'roundies:internet-security-secured-hacker': '\uf03b',
        'roundies:internet-security-secured-settings': '\uf03c',
        'roundies:internet-security-security-care': '\uf03d',
        'roundies:internet-security-security-focus': '\uf03e',
        'roundies:internet-security-security-password': '\uf03f',
        'roundies:internet-security-security': '\uf040',
        'roundies:internet-security-server-security-confirm': '\uf041',
        'roundies:internet-security-server': '\uf042',
        'roundies:internet-security-siren': '\uf043',
        'roundies:internet-security-ssl-security': '\uf044',
        'roundies:internet-security-tablet-bug': '\uf045',
        'roundies:internet-security-tablet-lock': '\uf046',
        'roundies:internet-security-tablet-security': '\uf047',
        'roundies:internet-security-tablet-virus': '\uf048',
        'roundies:internet-security-target-fingerprint': '\uf049',
        'roundies:internet-security-unlock': '\uf04a',
        'roundies:internet-security-warning': '\uf04b',
        'roundies:internet-security-web-browser-code': '\uf04c',
        'roundies:internet-security-web-browser-lock': '\uf04d',
        'roundies:internet-security-web-browser-security-confirm': '\uf04e',
        'roundies:internet-security-web-browser-ssl': '\uf04f',
        'roundies:internet-security-web-browser-unlock': '\uf050',
        'roundies:internet-security-wifi-care': '\uf051',
        'roundies:internet-security-wifi-secured': '\uf052',
        'roundies:internet-security-wifi-security-confirmed': '\uf053',
        'roundies:maternity-alphabet-building-blocks': '\uf054',
        'roundies:maternity-apple': '\uf055',
        'roundies:maternity-baby-bath': '\uf056',
        'roundies:maternity-baby-bottle': '\uf057',
        'roundies:maternity-baby-one-sie': '\uf058',
        'roundies:maternity-baby-sleeping-position': '\uf059',
        'roundies:maternity-baby-weight': '\uf05a',
        'roundies:maternity-ball': '\uf05b',
        'roundies:maternity-balloons': '\uf05c',
        'roundies:maternity-bib': '\uf05d',
        'roundies:maternity-bicycle': '\uf05e',
        'roundies:maternity-bottle': '\uf05f',
        'roundies:maternity-care-child': '\uf060',
        'roundies:maternity-carridge': '\uf061',
        'roundies:maternity-changing-table': '\uf062',
        'roundies:maternity-child-care': '\uf063',
        'roundies:maternity-crib-decoration': '\uf064',
        'roundies:maternity-crib': '\uf065',
        'roundies:maternity-crying-boy': '\uf066',
        'roundies:maternity-crying-girl': '\uf067',
        'roundies:maternity-diaper': '\uf068',
        'roundies:maternity-elephant': '\uf069',
        'roundies:maternity-family-baby': '\uf06a',
        'roundies:maternity-family-love': '\uf06b',
        'roundies:maternity-family-one-child': '\uf06c',
        'roundies:maternity-family-pregnancy': '\uf06d',
        'roundies:maternity-family-two-children': '\uf06e',
        'roundies:maternity-family': '\uf06f',
        'roundies:maternity-fetus-pregnancy': '\uf070',
        'roundies:maternity-fruit': '\uf071',
        'roundies:maternity-giggle-boy': '\uf072',
        'roundies:maternity-giggle-girl': '\uf073',
        'roundies:maternity-growing-pregnancy': '\uf074',
        'roundies:maternity-happy-boy': '\uf075',
        'roundies:maternity-happy-girl': '\uf076',
        'roundies:maternity-happy-newborn': '\uf077',
        'roundies:maternity-heart': '\uf078',
        'roundies:maternity-infant': '\uf079',
        'roundies:maternity-interactive-toy': '\uf07a',
        'roundies:maternity-kitten': '\uf07b',
        'roundies:maternity-labor': '\uf07c',
        'roundies:maternity-laugh-boy': '\uf07d',
        'roundies:maternity-laugh-girl': '\uf07e',
        'roundies:maternity-moon-and-stars': '\uf07f',
        'roundies:maternity-negative-pregnancy-test': '\uf080',
        'roundies:maternity-newborn-sleeping-position': '\uf081',
        'roundies:maternity-notebook': '\uf082',
        'roundies:maternity-one-year-birthday-cake': '\uf083',
        'roundies:maternity-pacifier': '\uf084',
        'roundies:maternity-paper-boat': '\uf085',
        'roundies:maternity-positive-pregnancy-test': '\uf086',
        'roundies:maternity-pregnancy-love': '\uf087',
        'roundies:maternity-pregnancy': '\uf088',
        'roundies:maternity-pregnant-mother': '\uf089',
        'roundies:maternity-puppy': '\uf08a',
        'roundies:maternity-quesy-boy': '\uf08b',
        'roundies:maternity-quesy-girl': '\uf08c',
        'roundies:maternity-rattle': '\uf08d',
        'roundies:maternity-ribbon': '\uf08e',
        'roundies:maternity-robot-toy': '\uf08f',
        'roundies:maternity-robot': '\uf090',
        'roundies:maternity-rocking-horse': '\uf091',
        'roundies:maternity-rubber-duck': '\uf092',
        'roundies:maternity-sad-boy': '\uf093',
        'roundies:maternity-sad-girl': '\uf094',
        'roundies:maternity-sad-newborn': '\uf095',
        'roundies:maternity-safety-pin': '\uf096',
        'roundies:maternity-sandcastle': '\uf097',
        'roundies:maternity-shapes-building-blocks': '\uf098',
        'roundies:maternity-shock-boy': '\uf099',
        'roundies:maternity-shock-girl': '\uf09a',
        'roundies:maternity-shovel-bucket': '\uf09b',
        'roundies:maternity-silent-boy': '\uf09c',
        'roundies:maternity-silent-girl': '\uf09d',
        'roundies:maternity-sitting-girl': '\uf09e',
        'roundies:maternity-sleeping-boy': '\uf09f',
        'roundies:maternity-sleeping-girl': '\uf0a0',
        'roundies:maternity-sleeping-position-baby': '\uf0a1',
        'roundies:maternity-smile-boy': '\uf0a2',
        'roundies:maternity-smile-girl': '\uf0a3',
        'roundies:maternity-socks': '\uf0a4',
        'roundies:maternity-sonigram-monitor': '\uf0a5',
        'roundies:maternity-sonigram': '\uf0a6',
        'roundies:maternity-spoon-fork': '\uf0a7',
        'roundies:maternity-sprout': '\uf0a8',
        'roundies:maternity-star': '\uf0a9',
        'roundies:maternity-stork': '\uf0aa',
        'roundies:maternity-sun': '\uf0ab',
        'roundies:maternity-syringe': '\uf0ac',
        'roundies:maternity-tablet-baby': '\uf0ad',
        'roundies:maternity-tablet-love': '\uf0ae',
        'roundies:maternity-teddy-bear': '\uf0af',
        'roundies:maternity-thermometer': '\uf0b0',
        'roundies:maternity-three-year-birthday-cake': '\uf0b1',
        'roundies:maternity-tooth': '\uf0b2',
        'roundies:maternity-two-year-birthday-cake': '\uf0b3',
        'roundies:maternity-walkie-talkie': '\uf0b4',
        'roundies:maternity-water-drop': '\uf0b5',
        'roundies:maternity-wind-up-car': '\uf0b6',
        'roundies:maternity-wind-up-train': '\uf0b7',
        'roundies:party-events-balloon': '\uf0b8',
        'roundies:party-events-beer-storage': '\uf0b9',
        'roundies:party-events-beers': '\uf0ba',
        'roundies:party-events-calendar': '\uf0bb',
        'roundies:party-events-champagne': '\uf0bc',
        'roundies:party-events-clown': '\uf0bd',
        'roundies:party-events-cocktail': '\uf0be',
        'roundies:party-events-decoration': '\uf0bf',
        'roundies:party-events-disco': '\uf0c0',
        'roundies:party-events-dj': '\uf0c1',
        'roundies:party-events-email': '\uf0c2',
        'roundies:party-events-fire-crackers': '\uf0c3',
        'roundies:party-events-fireworks': '\uf0c4',
        'roundies:party-events-glasses-mask': '\uf0c5',
        'roundies:party-events-guitar': '\uf0c6',
        'roundies:party-events-hi-message': '\uf0c7',
        'roundies:party-events-location': '\uf0c8',
        'roundies:party-events-martini': '\uf0c9',
        'roundies:party-events-mask': '\uf0ca',
        'roundies:party-events-message': '\uf0cb',
        'roundies:party-events-microphone': '\uf0cc',
        'roundies:party-events-moustache-ask': '\uf0cd',
        'roundies:party-events-party-decoration': '\uf0ce',
        'roundies:party-events-piano': '\uf0cf',
        'roundies:party-events-popping-champagne': '\uf0d0',
        'roundies:party-events-speaker': '\uf0d1',
        'roundies:party-events-ticket': '\uf0d2',
        'roundies:party-events-toast': '\uf0d3',
        'roundies:party-events-wine-cooler': '\uf0d4',
        'roundies:roundies-freebie-add-alarm': '\uf0d5',
        'roundies:roundies-freebie-alphabet-blocks': '\uf0d6',
        'roundies:roundies-freebie-alphabet': '\uf0d7',
        'roundies:roundies-freebie-announcement': '\uf0d8',
        'roundies:roundies-freebie-apartment-building': '\uf0d9',
        'roundies:roundies-freebie-aroma-therapy': '\uf0da',
        'roundies:roundies-freebie-automatic-flash': '\uf0db',
        'roundies:roundies-freebie-bank-transfer': '\uf0dc',
        'roundies:roundies-freebie-big-ben': '\uf0dd',
        'roundies:roundies-freebie-bookcase': '\uf0de',
        'roundies:roundies-freebie-brazil': '\uf0df',
        'roundies:roundies-freebie-browser-settings': '\uf0e0',
        'roundies:roundies-freebie-bucket': '\uf0e1',
        'roundies:roundies-freebie-bunk-beds': '\uf0e2',
        'roundies:roundies-freebie-burger': '\uf0e3',
        'roundies:roundies-freebie-calendar': '\uf0e4',
        'roundies:roundies-freebie-cancel': '\uf0e5',
        'roundies:roundies-freebie-care-for-pets': '\uf0e6',
        'roundies:roundies-freebie-care-for-recycling': '\uf0e7',
        'roundies:roundies-freebie-care-for-security': '\uf0e8',
        'roundies:roundies-freebie-cassette': '\uf0e9',
        'roundies:roundies-freebie-castle': '\uf0ea',
        'roundies:roundies-freebie-ceiling-cam': '\uf0eb',
        'roundies:roundies-freebie-ceiling-lamp': '\uf0ec',
        'roundies:roundies-freebie-charging-battery': '\uf0ed',
        'roundies:roundies-freebie-cheese': '\uf0ee',
        'roundies:roundies-freebie-child': '\uf0ef',
        'roundies:roundies-freebie-cocktail': '\uf0f0',
        'roundies:roundies-freebie-communication': '\uf0f1',
        'roundies:roundies-freebie-confirm-internet': '\uf0f2',
        'roundies:roundies-freebie-confirm-notification': '\uf0f3',
        'roundies:roundies-freebie-confirm-security': '\uf0f4',
        'roundies:roundies-freebie-contact': '\uf0f5',
        'roundies:roundies-freebie-cookie': '\uf0f6',
        'roundies:roundies-freebie-crane': '\uf0f7',
        'roundies:roundies-freebie-credit-card': '\uf0f8',
        'roundies:roundies-freebie-crib-decor': '\uf0f9',
        'roundies:roundies-freebie-crib': '\uf0fa',
        'roundies:roundies-freebie-customer-service': '\uf0fb',
        'roundies:roundies-freebie-delete-user': '\uf0fc',
        'roundies:roundies-freebie-desk-chair': '\uf0fd',
        'roundies:roundies-freebie-director': '\uf0fe',
        'roundies:roundies-freebie-dollar-scale': '\uf0ff',
        'roundies:roundies-freebie-eagle': '\uf100',
        'roundies:roundies-freebie-elepant': '\uf101',
        'roundies:roundies-freebie-favourite-message': '\uf102',
        'roundies:roundies-freebie-gorilla': '\uf103',
        'roundies:roundies-freebie-grandfather-clock': '\uf104',
        'roundies:roundies-freebie-hairdryer': '\uf105',
        'roundies:roundies-freebie-hanshake': '\uf106',
        'roundies:roundies-freebie-hiking': '\uf107',
        'roundies:roundies-freebie-home': '\uf108',
        'roundies:roundies-freebie-hourglass': '\uf109',
        'roundies:roundies-freebie-house-plant': '\uf10a',
        'roundies:roundies-freebie-image': '\uf10b',
        'roundies:roundies-freebie-industry': '\uf10c',
        'roundies:roundies-freebie-lady-liberty': '\uf10d',
        'roundies:roundies-freebie-laptop-bug': '\uf10e',
        'roundies:roundies-freebie-lion': '\uf10f',
        'roundies:roundies-freebie-london-eye': '\uf110',
        'roundies:roundies-freebie-macro': '\uf111',
        'roundies:roundies-freebie-mirror': '\uf112',
        'roundies:roundies-freebie-mixer': '\uf113',
        'roundies:roundies-freebie-moon': '\uf114',
        'roundies:roundies-freebie-mosque': '\uf115',
        'roundies:roundies-freebie-mount-fiji': '\uf116',
        'roundies:roundies-freebie-nuclear-container': '\uf117',
        'roundies:roundies-freebie-open-book': '\uf118',
        'roundies:roundies-freebie-plant': '\uf119',
        'roundies:roundies-freebie-popcorn': '\uf11a',
        'roundies:roundies-freebie-price-tag': '\uf11b',
        'roundies:roundies-freebie-rabbit': '\uf11c',
        'roundies:roundies-freebie-remove-camera': '\uf11d',
        'roundies:roundies-freebie-robot': '\uf11e',
        'roundies:roundies-freebie-rocket': '\uf11f',
        'roundies:roundies-freebie-sandwich': '\uf120',
        'roundies:roundies-freebie-science': '\uf121',
        'roundies:roundies-freebie-screwdriver': '\uf122',
        'roundies:roundies-freebie-search-euro': '\uf123',
        'roundies:roundies-freebie-shop': '\uf124',
        'roundies:roundies-freebie-solar-panels': '\uf125',
        'roundies:roundies-freebie-spy': '\uf126',
        'roundies:roundies-freebie-ssl-screen': '\uf127',
        'roundies:roundies-freebie-suitcase': '\uf128',
        'roundies:roundies-freebie-taco': '\uf129',
        'roundies:roundies-freebie-target': '\uf12a',
        'roundies:roundies-freebie-telephone': '\uf12b',
        'roundies:roundies-freebie-turbine-factory': '\uf12c',
        'roundies:roundies-freebie-umbrella': '\uf12d',
        'roundies:roundies-freebie-unlock': '\uf12e',
        'roundies:roundies-freebie-user-mobile': '\uf12f',
        'roundies:roundies-freebie-vacuum-cleaner': '\uf130',
        'roundies:roundies-freebie-video-camera-settings': '\uf131',
        'roundies:roundies-freebie-water-kettle': '\uf132',
        'roundies:roundies-freebie-whale': '\uf133',
        'roundies:roundies-freebie-wheelbarrow': '\uf134',
        'roundies:roundies-freebie-woman': '\uf135',
        'roundies:roundies-freebie-world-monument': '\uf136',
        'roundies:roundies-freebie-wrench': '\uf137',
        'roundies:roundies-freebie-yen-currency-exchange': '\uf138',
        'roundies:social-media-and-payment-9gag': '\uf139',
        'roundies:social-media-and-payment-amazon': '\uf13a',
        'roundies:social-media-and-payment-android': '\uf13b',
        'roundies:social-media-and-payment-apple': '\uf13c',
        'roundies:social-media-and-payment-b-social-media': '\uf13d',
        'roundies:social-media-and-payment-b': '\uf13e',
        'roundies:social-media-and-payment-behance': '\uf13f',
        'roundies:social-media-and-payment-bitcoin': '\uf140',
        'roundies:social-media-and-payment-blogger': '\uf141',
        'roundies:social-media-and-payment-chrome': '\uf142',
        'roundies:social-media-and-payment-creative-market': '\uf143',
        'roundies:social-media-and-payment-d': '\uf144',
        'roundies:social-media-and-payment-design': '\uf145',
        'roundies:social-media-and-payment-digg': '\uf146',
        'roundies:social-media-and-payment-dribbblr': '\uf147',
        'roundies:social-media-and-payment-drive': '\uf148',
        'roundies:social-media-and-payment-dropbox': '\uf149',
        'roundies:social-media-and-payment-emoji': '\uf14a',
        'roundies:social-media-and-payment-evernote': '\uf14b',
        'roundies:social-media-and-payment-explorer': '\uf14c',
        'roundies:social-media-and-payment-f': '\uf14d',
        'roundies:social-media-and-payment-facebook-messenger': '\uf14e',
        'roundies:social-media-and-payment-facebook': '\uf14f',
        'roundies:social-media-and-payment-flickr': '\uf150',
        'roundies:social-media-and-payment-fm': '\uf151',
        'roundies:social-media-and-payment-google-plus': '\uf152',
        'roundies:social-media-and-payment-google': '\uf153',
        'roundies:social-media-and-payment-grooveshark': '\uf154',
        'roundies:social-media-and-payment-hashtag-social': '\uf155',
        'roundies:social-media-and-payment-hashtag': '\uf156',
        'roundies:social-media-and-payment-in': '\uf157',
        'roundies:social-media-and-payment-instagram': '\uf158',
        'roundies:social-media-and-payment-it': '\uf159',
        'roundies:social-media-and-payment-jcb': '\uf15a',
        'roundies:social-media-and-payment-k': '\uf15b',
        'roundies:social-media-and-payment-line': '\uf15c',
        'roundies:social-media-and-payment-linked-in': '\uf15d',
        'roundies:social-media-and-payment-location': '\uf15e',
        'roundies:social-media-and-payment-logo-eight': '\uf15f',
        'roundies:social-media-and-payment-logo-eleven': '\uf160',
        'roundies:social-media-and-payment-logo-five': '\uf161',
        'roundies:social-media-and-payment-logo-four': '\uf162',
        'roundies:social-media-and-payment-logo-nine': '\uf163',
        'roundies:social-media-and-payment-logo-one': '\uf164',
        'roundies:social-media-and-payment-logo-seven': '\uf165',
        'roundies:social-media-and-payment-logo-six': '\uf166',
        'roundies:social-media-and-payment-logo-ten': '\uf167',
        'roundies:social-media-and-payment-logo-three': '\uf168',
        'roundies:social-media-and-payment-logo-two': '\uf169',
        'roundies:social-media-and-payment-mastercard': '\uf16a',
        'roundies:social-media-and-payment-messaging': '\uf16b',
        'roundies:social-media-and-payment-music': '\uf16c',
        'roundies:social-media-and-payment-online-bank-one': '\uf16d',
        'roundies:social-media-and-payment-online-bank': '\uf16e',
        'roundies:social-media-and-payment-opera': '\uf16f',
        'roundies:social-media-and-payment-p': '\uf170',
        'roundies:social-media-and-payment-paper-airplane': '\uf171',
        'roundies:social-media-and-payment-path': '\uf172',
        'roundies:social-media-and-payment-paypal-payment': '\uf173',
        'roundies:social-media-and-payment-paypal': '\uf174',
        'roundies:social-media-and-payment-pinterest': '\uf175',
        'roundies:social-media-and-payment-pocket': '\uf176',
        'roundies:social-media-and-payment-quote': '\uf177',
        'roundies:social-media-and-payment-radio': '\uf178',
        'roundies:social-media-and-payment-reddit': '\uf179',
        'roundies:social-media-and-payment-rss': '\uf17a',
        'roundies:social-media-and-payment-safari': '\uf17b',
        'roundies:social-media-and-payment-skrill': '\uf17c',
        'roundies:social-media-and-payment-skype': '\uf17d',
        'roundies:social-media-and-payment-snapchat': '\uf17e',
        'roundies:social-media-and-payment-social-media-eight': '\uf17f',
        'roundies:social-media-and-payment-social-media-five': '\uf180',
        'roundies:social-media-and-payment-social-media-four': '\uf181',
        'roundies:social-media-and-payment-social-media-one': '\uf182',
        'roundies:social-media-and-payment-social-media-seven': '\uf183',
        'roundies:social-media-and-payment-social-media-six': '\uf184',
        'roundies:social-media-and-payment-social-media-three': '\uf185',
        'roundies:social-media-and-payment-social-media-two': '\uf186',
        'roundies:social-media-and-payment-social-media': '\uf187',
        'roundies:social-media-and-payment-social-network-one': '\uf188',
        'roundies:social-media-and-payment-social-network-two': '\uf189',
        'roundies:social-media-and-payment-social-network': '\uf18a',
        'roundies:social-media-and-payment-soundcloud': '\uf18b',
        'roundies:social-media-and-payment-steel': '\uf18c',
        'roundies:social-media-and-payment-stumble-upon': '\uf18d',
        'roundies:social-media-and-payment-tinger': '\uf18e',
        'roundies:social-media-and-payment-tumblr': '\uf18f',
        'roundies:social-media-and-payment-twitter': '\uf190',
        'roundies:social-media-and-payment-viber': '\uf191',
        'roundies:social-media-and-payment-vine-one': '\uf192',
        'roundies:social-media-and-payment-vine': '\uf193',
        'roundies:social-media-and-payment-visa-logo': '\uf194',
        'roundies:social-media-and-payment-visa': '\uf195',
        'roundies:social-media-and-payment-vk': '\uf196',
        'roundies:social-media-and-payment-w': '\uf197',
        'roundies:social-media-and-payment-whatsapp': '\uf198',
        'roundies:social-media-and-payment-windows': '\uf199',
        'roundies:social-media-and-payment-wordpress': '\uf19a',
        'roundies:social-media-and-payment-yahoo': '\uf19b',
        'roundies:social-media-and-payment-youtube': '\uf19c',
        'roundies:transportation-101': '\uf19d',
        'roundies:transportation-129': '\uf19e',
        'roundies:transportation-22': '\uf19f',
        'roundies:transportation-5': '\uf1a0',
        'roundies:transportation-50': '\uf1a1',
        'roundies:transportation-6': '\uf1a2',
        'roundies:transportation-93': '\uf1a3',
        'roundies:transportation-above-water-submarine': '\uf1a4',
        'roundies:transportation-airplane': '\uf1a5',
        'roundies:transportation-alert': '\uf1a6',
        'roundies:transportation-ambulance': '\uf1a7',
        'roundies:transportation-arrows-road-sign': '\uf1a8',
        'roundies:transportation-automatic': '\uf1a9',
        'roundies:transportation-bicycle': '\uf1aa',
        'roundies:transportation-boat': '\uf1ab',
        'roundies:transportation-bus-public-transportation': '\uf1ac',
        'roundies:transportation-bus-tunnel': '\uf1ad',
        'roundies:transportation-bus': '\uf1ae',
        'roundies:transportation-car-battery': '\uf1af',
        'roundies:transportation-car-front': '\uf1b0',
        'roundies:transportation-car-security': '\uf1b1',
        'roundies:transportation-car-service': '\uf1b2',
        'roundies:transportation-car-transport': '\uf1b3',
        'roundies:transportation-car-vehicle': '\uf1b4',
        'roundies:transportation-car-wash': '\uf1b5',
        'roundies:transportation-car': '\uf1b6',
        'roundies:transportation-cement-transport': '\uf1b7',
        'roundies:transportation-crane': '\uf1b8',
        'roundies:transportation-crossroads': '\uf1b9',
        'roundies:transportation-curvy-road': '\uf1ba',
        'roundies:transportation-downward-arrows': '\uf1bb',
        'roundies:transportation-forward-right': '\uf1bc',
        'roundies:transportation-fuel': '\uf1bd',
        'roundies:transportation-garage': '\uf1be',
        'roundies:transportation-garbage-truck': '\uf1bf',
        'roundies:transportation-gas-tank': '\uf1c0',
        'roundies:transportation-gear-shift': '\uf1c1',
        'roundies:transportation-headlights': '\uf1c2',
        'roundies:transportation-highlights': '\uf1c3',
        'roundies:transportation-hot-air-balloon': '\uf1c4',
        'roundies:transportation-key': '\uf1c5',
        'roundies:transportation-lane-decrease': '\uf1c6',
        'roundies:transportation-left-right-roads': '\uf1c7',
        'roundies:transportation-left-right': '\uf1c8',
        'roundies:transportation-left': '\uf1c9',
        'roundies:transportation-low-lights': '\uf1ca',
        'roundies:transportation-manual': '\uf1cb',
        'roundies:transportation-material-transport': '\uf1cc',
        'roundies:transportation-motorbike': '\uf1cd',
        'roundies:transportation-move-chair-forward-backward': '\uf1ce',
        'roundies:transportation-move-chair-rest-forward-backward': '\uf1cf',
        'roundies:transportation-open-roof-car': '\uf1d0',
        'roundies:transportation-parking': '\uf1d1',
        'roundies:transportation-peel-off-road': '\uf1d2',
        'roundies:transportation-pick-up': '\uf1d3',
        'roundies:transportation-plane': '\uf1d4',
        'roundies:transportation-police-car': '\uf1d5',
        'roundies:transportation-right': '\uf1d6',
        'roundies:transportation-road-sign': '\uf1d7',
        'roundies:transportation-rocket': '\uf1d8',
        'roundies:transportation-round-car': '\uf1d9',
        'roundies:transportation-round-turn': '\uf1da',
        'roundies:transportation-route': '\uf1db',
        'roundies:transportation-sail-boat': '\uf1dc',
        'roundies:transportation-scooter-bike': '\uf1dd',
        'roundies:transportation-scooter': '\uf1de',
        'roundies:transportation-screwdriver': '\uf1df',
        'roundies:transportation-seat-belt': '\uf1e0',
        'roundies:transportation-settings': '\uf1e1',
        'roundies:transportation-ship-transportation': '\uf1e2',
        'roundies:transportation-ship': '\uf1e3',
        'roundies:transportation-ski-lift': '\uf1e4',
        'roundies:transportation-slippery-road': '\uf1e5',
        'roundies:transportation-small-hood-pick-up': '\uf1e6',
        'roundies:transportation-small-road': '\uf1e7',
        'roundies:transportation-speed-bump': '\uf1e8',
        'roundies:transportation-speed-bumps': '\uf1e9',
        'roundies:transportation-speedometer': '\uf1ea',
        'roundies:transportation-split-road': '\uf1eb',
        'roundies:transportation-steering-wheel': '\uf1ec',
        'roundies:transportation-submarine': '\uf1ed',
        'roundies:transportation-tractor': '\uf1ee',
        'roundies:transportation-traffic-lights': '\uf1ef',
        'roundies:transportation-train-tracks': '\uf1f0',
        'roundies:transportation-train-transportation': '\uf1f1',
        'roundies:transportation-train': '\uf1f2',
        'roundies:transportation-transport-ship': '\uf1f3',
        'roundies:transportation-transportation-tools': '\uf1f4',
        'roundies:transportation-truck': '\uf1f5',
        'roundies:transportation-turn-left': '\uf1f6',
        'roundies:transportation-turn-right': '\uf1f7',
        'roundies:transportation-u-turn': '\uf1f8',
        'roundies:transportation-ufo': '\uf1f9',
        'roundies:transportation-van': '\uf1fa',
        'roundies:transportation-vehicle-car': '\uf1fb',
        'roundies:transportation-water-transport': '\uf1fc',
        'roundies:transportation-windshield-wipers': '\uf1fd',
        'roundies:transportation-wrench': '\uf1fe',
        'roundies:transportation-wrong-direction': '\uf1ff',
        'roundies:utility-1-account': '\uf200',
        'roundies:utility-1-add-account': '\uf201',
        'roundies:utility-1-add-document': '\uf202',
        'roundies:utility-1-add-notification': '\uf203',
        'roundies:utility-1-add': '\uf204',
        'roundies:utility-1-add_1': '\uf205',
        'roundies:utility-1-article': '\uf206',
        'roundies:utility-1-block': '\uf207',
        'roundies:utility-1-bold': '\uf208',
        'roundies:utility-1-bookmark': '\uf209',
        'roundies:utility-1-bookmark_1': '\uf20a',
        'roundies:utility-1-bullet-points': '\uf20b',
        'roundies:utility-1-bullets': '\uf20c',
        'roundies:utility-1-calendar-one': '\uf20d',
        'roundies:utility-1-calendar-seven': '\uf20e',
        'roundies:utility-1-calendar-thirty-one': '\uf20f',
        'roundies:utility-1-calendar': '\uf210',
        'roundies:utility-1-cancel-account': '\uf211',
        'roundies:utility-1-cancel-notification': '\uf212',
        'roundies:utility-1-cancel': '\uf213',
        'roundies:utility-1-click': '\uf214',
        'roundies:utility-1-clipboard': '\uf215',
        'roundies:utility-1-clock': '\uf216',
        'roundies:utility-1-confirm-account': '\uf217',
        'roundies:utility-1-confirm-notification': '\uf218',
        'roundies:utility-1-confirm': '\uf219',
        'roundies:utility-1-cut': '\uf21a',
        'roundies:utility-1-document': '\uf21b',
        'roundies:utility-1-down-pointer': '\uf21c',
        'roundies:utility-1-down': '\uf21d',
        'roundies:utility-1-download': '\uf21e',
        'roundies:utility-1-filter': '\uf21f',
        'roundies:utility-1-folder': '\uf220',
        'roundies:utility-1-full-orientation': '\uf221',
        'roundies:utility-1-group': '\uf222',
        'roundies:utility-1-home': '\uf223',
        'roundies:utility-1-images': '\uf224',
        'roundies:utility-1-in-zoom': '\uf225',
        'roundies:utility-1-information': '\uf226',
        'roundies:utility-1-italic': '\uf227',
        'roundies:utility-1-layers': '\uf228',
        'roundies:utility-1-left-orientation': '\uf229',
        'roundies:utility-1-left-pointer': '\uf22a',
        'roundies:utility-1-left': '\uf22b',
        'roundies:utility-1-list': '\uf22c',
        'roundies:utility-1-lists-two': '\uf22d',
        'roundies:utility-1-lists': '\uf22e',
        'roundies:utility-1-lock': '\uf22f',
        'roundies:utility-1-maintenance': '\uf230',
        'roundies:utility-1-menu': '\uf231',
        'roundies:utility-1-message': '\uf232',
        'roundies:utility-1-messages': '\uf233',
        'roundies:utility-1-middle-orientation': '\uf234',
        'roundies:utility-1-move-down': '\uf235',
        'roundies:utility-1-move-left': '\uf236',
        'roundies:utility-1-move-right': '\uf237',
        'roundies:utility-1-move-up': '\uf238',
        'roundies:utility-1-move': '\uf239',
        'roundies:utility-1-mute': '\uf23a',
        'roundies:utility-1-notification-options': '\uf23b',
        'roundies:utility-1-notification': '\uf23c',
        'roundies:utility-1-numbers': '\uf23d',
        'roundies:utility-1-open-folder': '\uf23e',
        'roundies:utility-1-options': '\uf23f',
        'roundies:utility-1-out-zoom': '\uf240',
        'roundies:utility-1-person': '\uf241',
        'roundies:utility-1-plug-in': '\uf242',
        'roundies:utility-1-pointer-down': '\uf243',
        'roundies:utility-1-pointer-left': '\uf244',
        'roundies:utility-1-pointer-right': '\uf245',
        'roundies:utility-1-pointer-up': '\uf246',
        'roundies:utility-1-read-message': '\uf247',
        'roundies:utility-1-remove-account': '\uf248',
        'roundies:utility-1-remove-notification': '\uf249',
        'roundies:utility-1-remove': '\uf24a',
        'roundies:utility-1-remove_1': '\uf24b',
        'roundies:utility-1-right-orientation': '\uf24c',
        'roundies:utility-1-right-pointer': '\uf24d',
        'roundies:utility-1-right': '\uf24e',
        'roundies:utility-1-screen-orientation': '\uf24f',
        'roundies:utility-1-screen-rotation': '\uf250',
        'roundies:utility-1-settings': '\uf251',
        'roundies:utility-1-share': '\uf252',
        'roundies:utility-1-shift': '\uf253',
        'roundies:utility-1-sms': '\uf254',
        'roundies:utility-1-text-and-image': '\uf255',
        'roundies:utility-1-text-cancel': '\uf256',
        'roundies:utility-1-text-color': '\uf257',
        'roundies:utility-1-title': '\uf258',
        'roundies:utility-1-transfer': '\uf259',
        'roundies:utility-1-underline-color': '\uf25a',
        'roundies:utility-1-underline': '\uf25b',
        'roundies:utility-1-unlock': '\uf25c',
        'roundies:utility-1-unread-message': '\uf25d',
        'roundies:utility-1-up-pointer': '\uf25e',
        'roundies:utility-1-up': '\uf25f',
        'roundies:utility-1-upload': '\uf260',
        'roundies:utility-1-wifi': '\uf261',
        'roundies:utility-1-zom-in': '\uf262',
        'roundies:utility-1-zoom-out': '\uf263',
        'roundies:utility-2-add-browser': '\uf264',
        'roundies:utility-2-add': '\uf265',
        'roundies:utility-2-alignment-four': '\uf266',
        'roundies:utility-2-alignment-one': '\uf267',
        'roundies:utility-2-alignment-three': '\uf268',
        'roundies:utility-2-alignment-two': '\uf269',
        'roundies:utility-2-alignment': '\uf26a',
        'roundies:utility-2-backspace': '\uf26b',
        'roundies:utility-2-blank-window': '\uf26c',
        'roundies:utility-2-browser-coding': '\uf26d',
        'roundies:utility-2-browser-elements': '\uf26e',
        'roundies:utility-2-browser-four-elements': '\uf26f',
        'roundies:utility-2-browser-options': '\uf270',
        'roundies:utility-2-browser-settings': '\uf271',
        'roundies:utility-2-browser': '\uf272',
        'roundies:utility-2-call': '\uf273',
        'roundies:utility-2-charging-battery': '\uf274',
        'roundies:utility-2-code-window': '\uf275',
        'roundies:utility-2-coding-window': '\uf276',
        'roundies:utility-2-coding': '\uf277',
        'roundies:utility-2-colour-palette': '\uf278',
        'roundies:utility-2-confirm-browser': '\uf279',
        'roundies:utility-2-confirm-window': '\uf27a',
        'roundies:utility-2-contact': '\uf27b',
        'roundies:utility-2-delete-browser': '\uf27c',
        'roundies:utility-2-delete-window': '\uf27d',
        'roundies:utility-2-directions': '\uf27e',
        'roundies:utility-2-dislike': '\uf27f',
        'roundies:utility-2-document': '\uf280',
        'roundies:utility-2-dots': '\uf281',
        'roundies:utility-2-elements': '\uf282',
        'roundies:utility-2-exchange': '\uf283',
        'roundies:utility-2-expand': '\uf284',
        'roundies:utility-2-export': '\uf285',
        'roundies:utility-2-favourite-message': '\uf286',
        'roundies:utility-2-favourite-text-message': '\uf287',
        'roundies:utility-2-favourite': '\uf288',
        'roundies:utility-2-flag': '\uf289',
        'roundies:utility-2-full-battery': '\uf28a',
        'roundies:utility-2-group': '\uf28b',
        'roundies:utility-2-half-battery': '\uf28c',
        'roundies:utility-2-heart-message': '\uf28d',
        'roundies:utility-2-hiking': '\uf28e',
        'roundies:utility-2-image-file': '\uf28f',
        'roundies:utility-2-image': '\uf290',
        'roundies:utility-2-images': '\uf291',
        'roundies:utility-2-import': '\uf292',
        'roundies:utility-2-inard': '\uf293',
        'roundies:utility-2-insert': '\uf294',
        'roundies:utility-2-invisibile': '\uf295',
        'roundies:utility-2-left-alignment': '\uf296',
        'roundies:utility-2-like': '\uf297',
        'roundies:utility-2-list': '\uf298',
        'roundies:utility-2-low-battery': '\uf299',
        'roundies:utility-2-magic-wand': '\uf29a',
        'roundies:utility-2-message': '\uf29b',
        'roundies:utility-2-middle-alignment': '\uf29c',
        'roundies:utility-2-multiple-list': '\uf29d',
        'roundies:utility-2-newspaper': '\uf29e',
        'roundies:utility-2-off': '\uf29f',
        'roundies:utility-2-on': '\uf2a0',
        'roundies:utility-2-one-person': '\uf2a1',
        'roundies:utility-2-options-window': '\uf2a2',
        'roundies:utility-2-outward': '\uf2a3',
        'roundies:utility-2-paint-brush': '\uf2a4',
        'roundies:utility-2-paint-bucket': '\uf2a5',
        'roundies:utility-2-paper-airplane': '\uf2a6',
        'roundies:utility-2-pencil': '\uf2a7',
        'roundies:utility-2-pie-chart': '\uf2a8',
        'roundies:utility-2-play-window': '\uf2a9',
        'roundies:utility-2-power-battery': '\uf2aa',
        'roundies:utility-2-power': '\uf2ab',
        'roundies:utility-2-program-window': '\uf2ac',
        'roundies:utility-2-record': '\uf2ad',
        'roundies:utility-2-remove-browser': '\uf2ae',
        'roundies:utility-2-repeat-one': '\uf2af',
        'roundies:utility-2-repeat-options-two': '\uf2b0',
        'roundies:utility-2-repeat-options': '\uf2b1',
        'roundies:utility-2-repeat-two': '\uf2b2',
        'roundies:utility-2-right-alignment': '\uf2b3',
        'roundies:utility-2-rocket': '\uf2b4',
        'roundies:utility-2-rotate-one': '\uf2b5',
        'roundies:utility-2-rotate-three': '\uf2b6',
        'roundies:utility-2-rotate-trash': '\uf2b7',
        'roundies:utility-2-rotate-two': '\uf2b8',
        'roundies:utility-2-search': '\uf2b9',
        'roundies:utility-2-settings-window': '\uf2ba',
        'roundies:utility-2-settings': '\uf2bb',
        'roundies:utility-2-text-document': '\uf2bc',
        'roundies:utility-2-text-message': '\uf2bd',
        'roundies:utility-2-text-window': '\uf2be',
        'roundies:utility-2-three-people': '\uf2bf',
        'roundies:utility-2-trash': '\uf2c0',
        'roundies:utility-2-triangle-flag': '\uf2c1',
        'roundies:utility-2-two-people': '\uf2c2',
        'roundies:utility-2-video-file': '\uf2c3',
        'roundies:utility-2-view-one': '\uf2c4',
        'roundies:utility-2-view-two': '\uf2c5',
        'roundies:utility-2-windo-up': '\uf2c6',
        'roundies:utility-2-window-down': '\uf2c7',
        'roundies:utility-3-add-alarm': '\uf2c8',
        'roundies:utility-3-add-calendar': '\uf2c9',
        'roundies:utility-3-add-camera': '\uf2ca',
        'roundies:utility-3-add-cloud': '\uf2cb',
        'roundies:utility-3-add-folder': '\uf2cc',
        'roundies:utility-3-add-message': '\uf2cd',
        'roundies:utility-3-add-video-camera': '\uf2ce',
        'roundies:utility-3-add-woman': '\uf2cf',
        'roundies:utility-3-add': '\uf2d0',
        'roundies:utility-3-alarm-clock': '\uf2d1',
        'roundies:utility-3-audio-settings': '\uf2d2',
        'roundies:utility-3-bar-chart': '\uf2d3',
        'roundies:utility-3-book': '\uf2d4',
        'roundies:utility-3-brightness': '\uf2d5',
        'roundies:utility-3-broken-link': '\uf2d6',
        'roundies:utility-3-camera': '\uf2d7',
        'roundies:utility-3-cancel-alarm': '\uf2d8',
        'roundies:utility-3-cancel-calendar': '\uf2d9',
        'roundies:utility-3-cancel-video-camera': '\uf2da',
        'roundies:utility-3-cassette-tape': '\uf2db',
        'roundies:utility-3-cd': '\uf2dc',
        'roundies:utility-3-cloud': '\uf2dd',
        'roundies:utility-3-code': '\uf2de',
        'roundies:utility-3-coding': '\uf2df',
        'roundies:utility-3-confirm-alarm': '\uf2e0',
        'roundies:utility-3-confirm-calendar': '\uf2e1',
        'roundies:utility-3-confirm-video-camera': '\uf2e2',
        'roundies:utility-3-contacts': '\uf2e3',
        'roundies:utility-3-copy': '\uf2e4',
        'roundies:utility-3-document-add': '\uf2e5',
        'roundies:utility-3-document-favourite': '\uf2e6',
        'roundies:utility-3-document-remove': '\uf2e7',
        'roundies:utility-3-document-settings': '\uf2e8',
        'roundies:utility-3-down': '\uf2e9',
        'roundies:utility-3-download-cloud': '\uf2ea',
        'roundies:utility-3-dvd': '\uf2eb',
        'roundies:utility-3-empty-heart': '\uf2ec',
        'roundies:utility-3-fast-forward': '\uf2ed',
        'roundies:utility-3-favourite-contact': '\uf2ee',
        'roundies:utility-3-favourite-folder': '\uf2ef',
        'roundies:utility-3-favourite-woman': '\uf2f0',
        'roundies:utility-3-favourite': '\uf2f1',
        'roundies:utility-3-flag-one': '\uf2f2',
        'roundies:utility-3-flag-two': '\uf2f3',
        'roundies:utility-3-full-heart': '\uf2f4',
        'roundies:utility-3-full-hourglass': '\uf2f5',
        'roundies:utility-3-half-heart': '\uf2f6',
        'roundies:utility-3-half-hourglass': '\uf2f7',
        'roundies:utility-3-halfway-hourglass': '\uf2f8',
        'roundies:utility-3-high-brightness': '\uf2f9',
        'roundies:utility-3-high-volume': '\uf2fa',
        'roundies:utility-3-hourglass': '\uf2fb',
        'roundies:utility-3-increase-brightness': '\uf2fc',
        'roundies:utility-3-link-four': '\uf2fd',
        'roundies:utility-3-link-one': '\uf2fe',
        'roundies:utility-3-link-three': '\uf2ff',
        'roundies:utility-3-link-two': '\uf300',
        'roundies:utility-3-low-volume': '\uf301',
        'roundies:utility-3-man-one': '\uf302',
        'roundies:utility-3-man-two': '\uf303',
        'roundies:utility-3-man': '\uf304',
        'roundies:utility-3-microphone': '\uf305',
        'roundies:utility-3-music-audio': '\uf306',
        'roundies:utility-3-music': '\uf307',
        'roundies:utility-3-mute': '\uf308',
        'roundies:utility-3-next': '\uf309',
        'roundies:utility-3-no-wifi': '\uf30a',
        'roundies:utility-3-pause': '\uf30b',
        'roundies:utility-3-play': '\uf30c',
        'roundies:utility-3-previous': '\uf30d',
        'roundies:utility-3-profile-man': '\uf30e',
        'roundies:utility-3-profile-woman': '\uf30f',
        'roundies:utility-3-record': '\uf310',
        'roundies:utility-3-remove-alarm': '\uf311',
        'roundies:utility-3-remove-camera': '\uf312',
        'roundies:utility-3-remove-cloud': '\uf313',
        'roundies:utility-3-remove-folder': '\uf314',
        'roundies:utility-3-remove-message': '\uf315',
        'roundies:utility-3-remove-woman': '\uf316',
        'roundies:utility-3-remove': '\uf317',
        'roundies:utility-3-rewind': '\uf318',
        'roundies:utility-3-settings-alarm': '\uf319',
        'roundies:utility-3-settings-calendar': '\uf31a',
        'roundies:utility-3-settings-camera': '\uf31b',
        'roundies:utility-3-settings-folder': '\uf31c',
        'roundies:utility-3-settings-message': '\uf31d',
        'roundies:utility-3-settings-video-camera': '\uf31e',
        'roundies:utility-3-settings-woman': '\uf31f',
        'roundies:utility-3-settings': '\uf320',
        'roundies:utility-3-shuffle': '\uf321',
        'roundies:utility-3-stop': '\uf322',
        'roundies:utility-3-timer-camera': '\uf323',
        'roundies:utility-3-timer': '\uf324',
        'roundies:utility-3-up': '\uf325',
        'roundies:utility-3-upload-cloud': '\uf326',
        'roundies:utility-3-video-camera': '\uf327',
        'roundies:utility-3-wifi': '\uf328',
        'roundies:utility-3-woman-one': '\uf329',
        'roundies:utility-3-woman-two': '\uf32a',
        'roundies:utility-3-woman': '\uf32b',
        'roundies:world-monuments-acropolis-of-athens-greece': '\uf32c',
        'roundies:world-monuments-american-cemetery-in-normandy': '\uf32d',
        'roundies:world-monuments-artboard-12': '\uf32e',
        'roundies:world-monuments-artboard-27': '\uf32f',
        'roundies:world-monuments-artboard-28': '\uf330',
        'roundies:world-monuments-artboard-30': '\uf331',
        'roundies:world-monuments-asia-world-monument': '\uf332',
        'roundies:world-monuments-atomium': '\uf333',
        'roundies:world-monuments-bali-world-monument': '\uf334',
        'roundies:world-monuments-big-ben': '\uf335',
        'roundies:world-monuments-blue-domed-church-in-santorini-greece': '\uf336',
        'roundies:world-monuments-bradenburg-gate': '\uf337',
        'roundies:world-monuments-burj-al-arab': '\uf338',
        'roundies:world-monuments-capital-hill-washington': '\uf339',
        'roundies:world-monuments-chichen-itza': '\uf33a',
        'roundies:world-monuments-cn-tower-in-canada': '\uf33b',
        'roundies:world-monuments-easter-island': '\uf33c',
        'roundies:world-monuments-eiffel-tower': '\uf33d',
        'roundies:world-monuments-empire-state-building': '\uf33e',
        'roundies:world-monuments-fiji-mountain': '\uf33f',
        'roundies:world-monuments-gate-torii': '\uf340',
        'roundies:world-monuments-golden-gate-bridge': '\uf341',
        'roundies:world-monuments-great-wall': '\uf342',
        'roundies:world-monuments-holleywood-sign': '\uf343',
        'roundies:world-monuments-inukshuk-canada': '\uf344',
        'roundies:world-monuments-jesus-christ': '\uf345',
        'roundies:world-monuments-lady-liberty': '\uf346',
        'roundies:world-monuments-landmark': '\uf347',
        'roundies:world-monuments-lascaux-in-france': '\uf348',
        'roundies:world-monuments-lochness': '\uf349',
        'roundies:world-monuments-london-eye': '\uf34a',
        'roundies:world-monuments-middle-of-the-earth-in-ecuador': '\uf34b',
        'roundies:world-monuments-millau-bridge-in-france': '\uf34c',
        'roundies:world-monuments-north-cape-norway': '\uf34d',
        'roundies:world-monuments-petra-jordan': '\uf34e',
        'roundies:world-monuments-pyramids': '\uf34f',
        'roundies:world-monuments-sagrada-familia': '\uf350',
        'roundies:world-monuments-skellig-michael-near-the-coast-of-ireland': '\uf351',
        'roundies:world-monuments-sphinx': '\uf352',
        'roundies:world-monuments-st-basil-church': '\uf353',
        'roundies:world-monuments-stonehenge': '\uf354',
        'roundies:world-monuments-sydney-opera-house': '\uf355',
        'roundies:world-monuments-table-mountain': '\uf356',
        'roundies:world-monuments-taj-mahal': '\uf357',
        'roundies:world-monuments-temple-of-besakih-in-bali': '\uf358',
        'roundies:world-monuments-the-colosseum-italy': '\uf359',
        'roundies:world-monuments-the-great-buddha': '\uf35a',
        'roundies:world-monuments-the-little-mermaid-in-copenhagen-denmark': '\uf35b',
        'roundies:world-monuments-the-louvre': '\uf35c',
        'roundies:world-monuments-tower-bridge': '\uf35d',
        'roundies:world-monuments-tower-landmark': '\uf35e',
        'roundies:world-monuments-tower-of-pisa': '\uf35f',
        'roundies:world-monuments-tower': '\uf360',
        'roundies:world-monuments-uluru': '\uf361',
        'roundies:world-monuments-washington-monument': '\uf362',
        'roundies:world-monuments-windmill': '\uf363',
        'roundies:world-monuments-world-landmark-building': '\uf364',
        'roundies:world-monuments-world-landmarks': '\uf365',
        'roundies:world-monuments-world-monument-building': '\uf366',
        'roundies:world-monuments-world-monument': '\uf367',
        'material:_10k': '\ue951',
        'material:_10mp': '\ue952',
        'material:_11mp': '\ue953',
        'material:_123': '\ueb8d',
        'material:_12mp': '\ue954',
        'material:_13mp': '\ue955',
        'material:_14mp': '\ue956',
        'material:_15mp': '\ue957',
        'material:_16mp': '\ue958',
        'material:_17mp': '\ue959',
        'material:_18_up_rating': '\uf8fd',
        'material:_18mp': '\ue95a',
        'material:_19mp': '\ue95b',
        'material:_1k': '\ue95c',
        'material:_1k_plus': '\ue95d',
        'material:_1x_mobiledata': '\uefcd',
        'material:_1x_mobiledata_badge': '\uf7f1',
        'material:_20mp': '\ue95e',
        'material:_21mp': '\ue95f',
        'material:_22mp': '\ue960',
        'material:_23mp': '\ue961',
        'material:_24fps_select': '\uf3f2',
        'material:_24mp': '\ue962',
        'material:_2d': '\uef37',
        'material:_2k': '\ue963',
        'material:_2k_plus': '\ue964',
        'material:_2mp': '\ue965',
        'material:_30fps': '\uefce',
        'material:_30fps_select': '\uefcf',
        'material:_360': '\ue577',
        'material:_3d': '\ued38',
        'material:_3d_rotation': '\ue84d',
        'material:_3g_mobiledata': '\uefd0',
        'material:_3g_mobiledata_badge': '\uf7f0',
        'material:_3k': '\ue966',
        'material:_3k_plus': '\ue967',
        'material:_3mp': '\ue968',
        'material:_3p': '\uefd1',
        'material:_4g_mobiledata': '\uefd2',
        'material:_4g_mobiledata_badge': '\uf7ef',
        'material:_4g_plus_mobiledata': '\uefd3',
        'material:_4k': '\ue072',
        'material:_4k_plus': '\ue969',
        'material:_4mp': '\ue96a',
        'material:_50mp': '\uf6f3',
        'material:_5g': '\uef38',
        'material:_5g_mobiledata_badge': '\uf7ee',
        'material:_5k': '\ue96b',
        'material:_5k_plus': '\ue96c',
        'material:_5mp': '\ue96d',
        'material:_6_ft_apart': '\uf21e',
        'material:_60fps': '\uefd4',
        'material:_60fps_select': '\uefd5',
        'material:_6k': '\ue96e',
        'material:_6k_plus': '\ue96f',
        'material:_6mp': '\ue970',
        'material:_7k': '\ue971',
        'material:_7k_plus': '\ue972',
        'material:_7mp': '\ue973',
        'material:_8k': '\ue974',
        'material:_8k_plus': '\ue975',
        'material:_8mp': '\ue976',
        'material:_9k': '\ue977',
        'material:_9k_plus': '\ue978',
        'material:_9mp': '\ue979',
        'material:abc': '\ueb94',
        'material:ac_unit': '\ueb3b',
        'material:accessibility': '\ue84e',
        'material:accessibility_new': '\ue92c',
        'material:accessible': '\ue914',
        'material:accessible_forward': '\ue934',
        'material:accessible_menu': '\uf34e',
        'material:account_balance': '\ue84f',
        'material:account_balance_wallet': '\ue850',
        'material:account_box': '\ue416',
        'material:account_child': '\ue852',
        'material:account_child_invert': '\ue659',
        'material:account_circle': '\ue853',
        'material:account_circle_off': '\uf7b3',
        'material:account_tree': '\ue97a',
        'material:action_key': '\uf502',
        'material:activity_zone': '\ue1e6',
        'material:acupuncture': '\uf2c4',
        'material:ad': '\ue65a',
        'material:ad_group': '\ue65b',
        'material:ad_group_off': '\ueae5',
        'material:ad_off': '\uf7b2',
        'material:adaptive_audio_mic': '\uf4cc',
        'material:adaptive_audio_mic_off': '\uf4cb',
        'material:adb': '\ue60e',
        'material:add': '\ue145',
        'material:add_2': '\uf3dd',
        'material:add_a_photo': '\ue439',
        'material:add_ad': '\ue72a',
        'material:add_alert': '\ue003',
        'material:add_box': '\ue146',
        'material:add_business': '\ue729',
        'material:add_call': '\ue0e8',
        'material:add_card': '\ueb86',
        'material:add_chart': '\ue97b',
        'material:add_circle': '\ue147',
        'material:add_column_left': '\uf425',
        'material:add_column_right': '\uf424',
        'material:add_comment': '\ue266',
        'material:add_diamond': '\uf49c',
        'material:add_home': '\uf8eb',
        'material:add_home_work': '\uf8ed',
        'material:add_link': '\ue178',
        'material:add_location': '\ue567',
        'material:add_location_alt': '\uef3a',
        'material:add_moderator': '\ue97d',
        'material:add_notes': '\ue091',
        'material:add_photo_alternate': '\ue43e',
        'material:add_reaction': '\ue1d3',
        'material:add_road': '\uef3b',
        'material:add_row_above': '\uf423',
        'material:add_row_below': '\uf422',
        'material:add_shopping_cart': '\ue854',
        'material:add_task': '\uf23a',
        'material:add_to_drive': '\ue65c',
        'material:add_to_photos': '\ue39d',
        'material:add_to_queue': '\ue05c',
        'material:add_triangle': '\uf48e',
        'material:adf_scanner': '\ueada',
        'material:adjust': '\ue39e',
        'material:admin_meds': '\ue48d',
        'material:admin_panel_settings': '\uef3d',
        'material:ads_click': '\ue762',
        'material:agender': '\uf888',
        'material:agriculture': '\uea79',
        'material:air': '\uefd8',
        'material:air_freshener': '\ue2ca',
        'material:air_purifier': '\ue97e',
        'material:air_purifier_gen': '\ue829',
        'material:airline_seat_flat': '\ue630',
        'material:airline_seat_flat_angled': '\ue631',
        'material:airline_seat_individual_suite': '\ue632',
        'material:airline_seat_legroom_extra': '\ue633',
        'material:airline_seat_legroom_normal': '\ue634',
        'material:airline_seat_legroom_reduced': '\ue635',
        'material:airline_seat_recline_extra': '\ue636',
        'material:airline_seat_recline_normal': '\ue637',
        'material:airline_stops': '\ue7d0',
        'material:airlines': '\ue7ca',
        'material:airplane_ticket': '\uefd9',
        'material:airplanemode_active': '\ue195',
        'material:airplanemode_inactive': '\ue194',
        'material:airplay': '\ue055',
        'material:airport_shuttle': '\ueb3c',
        'material:airwave': '\ue29c',
        'material:alarm': '\ue190',
        'material:alarm_add': '\ue193',
        'material:alarm_off': '\ue857',
        'material:alarm_on': '\ue858',
        'material:alarm_pause': '\uf35b',
        'material:alarm_smart_wake': '\uf6b0',
        'material:album': '\ue019',
        'material:align_center': '\ue356',
        'material:align_end': '\uf797',
        'material:align_flex_center': '\uf796',
        'material:align_flex_end': '\uf795',
        'material:align_flex_start': '\uf794',
        'material:align_horizontal_center': '\ue00f',
        'material:align_horizontal_left': '\ue00d',
        'material:align_horizontal_right': '\ue010',
        'material:align_items_stretch': '\uf793',
        'material:align_justify_center': '\uf792',
        'material:align_justify_flex_end': '\uf791',
        'material:align_justify_flex_start': '\uf790',
        'material:align_justify_space_around': '\uf78f',
        'material:align_justify_space_between': '\uf78e',
        'material:align_justify_space_even': '\uf78d',
        'material:align_justify_stretch': '\uf78c',
        'material:align_self_stretch': '\uf78b',
        'material:align_space_around': '\uf78a',
        'material:align_space_between': '\uf789',
        'material:align_space_even': '\uf788',
        'material:align_start': '\uf787',
        'material:align_stretch': '\uf786',
        'material:align_vertical_bottom': '\ue015',
        'material:align_vertical_center': '\ue011',
        'material:align_vertical_top': '\ue00c',
        'material:all_inbox': '\ue97f',
        'material:all_inclusive': '\ueb3d',
        'material:all_match': '\ue093',
        'material:all_out': '\ue90b',
        'material:allergies': '\ue094',
        'material:allergy': '\ue64e',
        'material:alt_route': '\uf184',
        'material:alternate_email': '\ue0e6',
        'material:altitude': '\uf873',
        'material:ambient_screen': '\uf6c4',
        'material:ambulance': '\uf803',
        'material:amend': '\uf802',
        'material:amp_stories': '\uea13',
        'material:analytics': '\uef3e',
        'material:anchor': '\uf1cd',
        'material:android': '\ue859',
        'material:android_cell_4_bar': '\uef06',
        'material:android_cell_4_bar_alert': '\uef09',
        'material:android_cell_4_bar_off': '\uef08',
        'material:android_cell_4_bar_plus': '\uef07',
        'material:android_cell_5_bar': '\uef02',
        'material:android_cell_5_bar_alert': '\uef05',
        'material:android_cell_5_bar_off': '\uef04',
        'material:android_cell_5_bar_plus': '\uef03',
        'material:android_cell_dual_4_bar': '\uef0d',
        'material:android_cell_dual_4_bar_alert': '\uef0f',
        'material:android_cell_dual_4_bar_plus': '\uef0e',
        'material:android_cell_dual_5_bar': '\uef0a',
        'material:android_cell_dual_5_bar_alert': '\uef0c',
        'material:android_cell_dual_5_bar_plus': '\uef0b',
        'material:android_wifi_3_bar': '\uef16',
        'material:android_wifi_3_bar_alert': '\uef1b',
        'material:android_wifi_3_bar_lock': '\uef1a',
        'material:android_wifi_3_bar_off': '\uef19',
        'material:android_wifi_3_bar_plus': '\uef18',
        'material:android_wifi_3_bar_question': '\uef17',
        'material:android_wifi_4_bar': '\uef10',
        'material:android_wifi_4_bar_alert': '\uef15',
        'material:android_wifi_4_bar_lock': '\uef14',
        'material:android_wifi_4_bar_off': '\uef13',
        'material:android_wifi_4_bar_plus': '\uef12',
        'material:android_wifi_4_bar_question': '\uef11',
        'material:animated_images': '\uf49a',
        'material:animation': '\ue71c',
        'material:aod_tablet': '\uf89f',
        'material:aod_watch': '\uf6ac',
        'material:apartment': '\uea40',
        'material:api': '\uf1b7',
        'material:apk_document': '\uf88e',
        'material:apk_install': '\uf88f',
        'material:app_badging': '\uf72f',
        'material:app_registration': '\uef40',
        'material:apparel': '\uef7b',
        'material:approval': '\ue982',
        'material:approval_delegation': '\uf84a',
        'material:approval_delegation_off': '\uf2c5',
        'material:apps': '\ue5c3',
        'material:apps_outage': '\ue7cc',
        'material:aq': '\uf55a',
        'material:aq_indoor': '\uf55b',
        'material:ar_on_you': '\uef7c',
        'material:ar_stickers': '\ue983',
        'material:architecture': '\uea3b',
        'material:archive': '\ue149',
        'material:area_chart': '\ue770',
        'material:arming_countdown': '\ue78a',
        'material:arrow_and_edge': '\uf5d7',
        'material:arrow_back': '\ue5c4',
        'material:arrow_back_2': '\uf43a',
        'material:arrow_back_ios': '\ue5e0',
        'material:arrow_back_ios_new': '\ue2ea',
        'material:arrow_circle_down': '\uf181',
        'material:arrow_circle_left': '\ueaa7',
        'material:arrow_circle_right': '\ueaaa',
        'material:arrow_circle_up': '\uf182',
        'material:arrow_cool_down': '\uf4b6',
        'material:arrow_downward': '\ue5db',
        'material:arrow_downward_alt': '\ue984',
        'material:arrow_drop_down': '\ue5c5',
        'material:arrow_drop_down_circle': '\ue5c6',
        'material:arrow_drop_up': '\ue5c7',
        'material:arrow_forward': '\ue5c8',
        'material:arrow_forward_ios': '\ue5e1',
        'material:arrow_insert': '\uf837',
        'material:arrow_left': '\ue5de',
        'material:arrow_left_alt': '\uef7d',
        'material:arrow_menu_close': '\uf3d3',
        'material:arrow_menu_open': '\uf3d2',
        'material:arrow_or_edge': '\uf5d6',
        'material:arrow_outward': '\uf8ce',
        'material:arrow_range': '\uf69b',
        'material:arrow_right': '\ue5df',
        'material:arrow_right_alt': '\ue941',
        'material:arrow_selector_tool': '\uf82f',
        'material:arrow_shape_up': '\ueef6',
        'material:arrow_shape_up_stack': '\ueef7',
        'material:arrow_shape_up_stack_2': '\ueef8',
        'material:arrow_split': '\ue985',
        'material:arrow_top_left': '\uf72e',
        'material:arrow_top_right': '\uf72d',
        'material:arrow_upload_progress': '\uf3f4',
        'material:arrow_upload_ready': '\uf3f5',
        'material:arrow_upward': '\ue5d8',
        'material:arrow_upward_alt': '\ue986',
        'material:arrow_warm_up': '\uf4b5',
        'material:arrows_input': '\uf394',
        'material:arrows_more_down': '\uf8ab',
        'material:arrows_more_up': '\uf8ac',
        'material:arrows_output': '\uf393',
        'material:arrows_outward': '\uf72c',
        'material:art_track': '\ue060',
        'material:article': '\uef42',
        'material:article_person': '\uf368',
        'material:article_shortcut': '\uf587',
        'material:artist': '\ue01a',
        'material:aspect_ratio': '\ue85b',
        'material:assignment': '\ue85d',
        'material:assignment_add': '\uf848',
        'material:assignment_globe': '\ueeec',
        'material:assignment_ind': '\ue85e',
        'material:assignment_late': '\ue85f',
        'material:assignment_return': '\ue860',
        'material:assignment_returned': '\ue861',
        'material:assignment_turned_in': '\ue862',
        'material:assist_walker': '\uf8d5',
        'material:assistant': '\ue39f',
        'material:assistant_device': '\ue987',
        'material:assistant_direction': '\ue988',
        'material:assistant_navigation': '\ue989',
        'material:assistant_on_hub': '\uf6c1',
        'material:assured_workload': '\ueb6f',
        'material:astrophotography_auto': '\uf1d9',
        'material:astrophotography_off': '\uf1da',
        'material:atm': '\ue573',
        'material:atr': '\uebc7',
        'material:attach_email': '\uea5e',
        'material:attach_file': '\ue226',
        'material:attach_file_add': '\uf841',
        'material:attach_file_off': '\uf4d9',
        'material:attach_money': '\ue227',
        'material:attachment': '\ue2bc',
        'material:attractions': '\uea52',
        'material:attribution': '\uefdb',
        'material:audio_description': '\uf58c',
        'material:audio_file': '\ueb82',
        'material:audio_video_receiver': '\uf5d3',
        'material:auto_activity_zone': '\uf8ad',
        'material:auto_awesome': '\ue65f',
        'material:auto_awesome_mosaic': '\ue660',
        'material:auto_awesome_motion': '\ue661',
        'material:auto_delete': '\uea4c',
        'material:auto_detect_voice': '\uf83e',
        'material:auto_draw_solid': '\ue98a',
        'material:auto_fix': '\ue662',
        'material:auto_fix_normal': '\ue664',
        'material:auto_fix_off': '\ue665',
        'material:auto_graph': '\ue4fb',
        'material:auto_label': '\uf6be',
        'material:auto_meeting_room': '\uf6bf',
        'material:auto_mode': '\uec20',
        'material:auto_read_pause': '\uf219',
        'material:auto_read_play': '\uf216',
        'material:auto_schedule': '\ue214',
        'material:auto_stories': '\ue666',
        'material:auto_stories_off': '\uf267',
        'material:auto_timer': '\uef7f',
        'material:auto_towing': '\ue71e',
        'material:auto_transmission': '\uf53f',
        'material:auto_videocam': '\uf6c0',
        'material:autofps_select': '\uefdc',
        'material:automation': '\uf421',
        'material:autopause': '\uf6b6',
        'material:autopay': '\uf84b',
        'material:autoplay': '\uf6b5',
        'material:autorenew': '\ue028',
        'material:autostop': '\uf682',
        'material:av_timer': '\ue01b',
        'material:av1': '\uf4b0',
        'material:avc': '\uf4af',
        'material:avg_pace': '\uf6bb',
        'material:avg_time': '\uf813',
        'material:award_meal': '\uf241',
        'material:award_star': '\uf612',
        'material:azm': '\uf6ec',
        'material:baby_changing_station': '\uf19b',
        'material:back_hand': '\ue764',
        'material:back_to_tab': '\uf72b',
        'material:background_dot_large': '\uf79e',
        'material:background_dot_small': '\uf514',
        'material:background_grid_small': '\uf79d',
        'material:background_replace': '\uf20a',
        'material:backlight_high': '\uf7ed',
        'material:backlight_high_off': '\uf4ef',
        'material:backlight_low': '\uf7ec',
        'material:backpack': '\uf19c',
        'material:backspace': '\ue14a',
        'material:backup': '\ue864',
        'material:backup_table': '\uef43',
        'material:badge': '\uea67',
        'material:badminton': '\uf2a8',
        'material:bakery_dining': '\uea53',
        'material:balance': '\ueaf6',
        'material:balcony': '\ue58f',
        'material:ballot': '\ue172',
        'material:bar_chart': '\ue26b',
        'material:bar_chart_4_bars': '\uf681',
        'material:bar_chart_off': '\uf411',
        'material:barcode': '\ue70b',
        'material:barcode_reader': '\uf85c',
        'material:barcode_scanner': '\ue70c',
        'material:barefoot': '\uf871',
        'material:batch_prediction': '\uf0f5',
        'material:bath_bedrock': '\uf286',
        'material:bath_outdoor': '\uf6fb',
        'material:bath_private': '\uf6fa',
        'material:bath_public_large': '\uf6f9',
        'material:bath_soak': '\uf2a0',
        'material:bathroom': '\uefdd',
        'material:bathtub': '\uea41',
        'material:battery_0_bar': '\uebdc',
        'material:battery_1_bar': '\uebd9',
        'material:battery_2_bar': '\uebe0',
        'material:battery_3_bar': '\uebdd',
        'material:battery_4_bar': '\uebe2',
        'material:battery_5_bar': '\uebd4',
        'material:battery_6_bar': '\uebd2',
        'material:battery_alert': '\ue19c',
        'material:battery_android_0': '\uf30d',
        'material:battery_android_1': '\uf30c',
        'material:battery_android_2': '\uf30b',
        'material:battery_android_3': '\uf30a',
        'material:battery_android_4': '\uf309',
        'material:battery_android_5': '\uf308',
        'material:battery_android_6': '\uf307',
        'material:battery_android_alert': '\uf306',
        'material:battery_android_bolt': '\uf305',
        'material:battery_android_frame_1': '\uf257',
        'material:battery_android_frame_2': '\uf256',
        'material:battery_android_frame_3': '\uf255',
        'material:battery_android_frame_4': '\uf254',
        'material:battery_android_frame_5': '\uf253',
        'material:battery_android_frame_6': '\uf252',
        'material:battery_android_frame_alert': '\uf251',
        'material:battery_android_frame_bolt': '\uf250',
        'material:battery_android_frame_full': '\uf24f',
        'material:battery_android_frame_plus': '\uf24e',
        'material:battery_android_frame_question': '\uf24d',
        'material:battery_android_frame_share': '\uf24c',
        'material:battery_android_frame_shield': '\uf24b',
        'material:battery_android_full': '\uf304',
        'material:battery_android_plus': '\uf303',
        'material:battery_android_question': '\uf302',
        'material:battery_android_share': '\uf301',
        'material:battery_android_shield': '\uf300',
        'material:battery_change': '\uf7eb',
        'material:battery_charging_20': '\uf0a2',
        'material:battery_charging_30': '\uf0a3',
        'material:battery_charging_50': '\uf0a4',
        'material:battery_charging_60': '\uf0a5',
        'material:battery_charging_80': '\uf0a6',
        'material:battery_charging_90': '\uf0a7',
        'material:battery_charging_full': '\ue1a3',
        'material:battery_error': '\uf7ea',
        'material:battery_full': '\ue1a4',
        'material:battery_full_alt': '\uf13b',
        'material:battery_horiz_000': '\uf8ae',
        'material:battery_horiz_050': '\uf8af',
        'material:battery_horiz_075': '\uf8b0',
        'material:battery_low': '\uf155',
        'material:battery_plus': '\uf7e9',
        'material:battery_profile': '\ue206',
        'material:battery_saver': '\uefde',
        'material:battery_share': '\uf67e',
        'material:battery_status_good': '\uf67d',
        'material:battery_unknown': '\ue1a6',
        'material:battery_vert_005': '\uf8b1',
        'material:battery_vert_020': '\uf8b2',
        'material:battery_vert_050': '\uf8b3',
        'material:battery_very_low': '\uf147',
        'material:beach_access': '\ueb3e',
        'material:bed': '\uefdf',
        'material:bedroom_baby': '\uefe0',
        'material:bedroom_child': '\uefe1',
        'material:bedroom_parent': '\uefe2',
        'material:bedtime': '\ue1f9',
        'material:bedtime_off': '\ue291',
        'material:beenhere': '\ue52d',
        'material:beer_meal': '\uf285',
        'material:bento': '\uf1f4',
        'material:bia': '\uf6eb',
        'material:bid_landscape': '\ue667',
        'material:bid_landscape_disabled': '\uef81',
        'material:bigtop_updates': '\ue669',
        'material:bike_dock': '\uf47b',
        'material:bike_lane': '\uf47a',
        'material:bike_scooter': '\uef45',
        'material:biotech': '\uea3a',
        'material:blanket': '\ue828',
        'material:blender': '\uefe3',
        'material:blind': '\uf8d6',
        'material:blinds': '\ue286',
        'material:blinds_closed': '\uec1f',
        'material:block': '\ue033',
        'material:blood_pressure': '\ue097',
        'material:bloodtype': '\uefe4',
        'material:bluetooth': '\ue1a7',
        'material:bluetooth_connected': '\ue1a8',
        'material:bluetooth_disabled': '\ue1a9',
        'material:bluetooth_drive': '\uefe5',
        'material:bluetooth_searching': '\ue1aa',
        'material:blur_circular': '\ue3a2',
        'material:blur_linear': '\ue3a3',
        'material:blur_medium': '\ue84c',
        'material:blur_off': '\ue3a4',
        'material:blur_on': '\ue3a5',
        'material:blur_short': '\ue8cf',
        'material:boat_bus': '\uf36d',
        'material:boat_railway': '\uf36c',
        'material:body_fat': '\ue098',
        'material:body_system': '\ue099',
        'material:bolt': '\uea0b',
        'material:bomb': '\uf568',
        'material:book': '\ue865',
        'material:book_2': '\uf53e',
        'material:book_3': '\uf53d',
        'material:book_4': '\uf53c',
        'material:book_5': '\uf53b',
        'material:book_6': '\uf3df',
        'material:book_ribbon': '\uf3e7',
        'material:bookmark': '\ue866',
        'material:bookmark_add': '\ue598',
        'material:bookmark_added': '\ue599',
        'material:bookmark_bag': '\uf410',
        'material:bookmark_check': '\uf457',
        'material:bookmark_flag': '\uf456',
        'material:bookmark_heart': '\uf455',
        'material:bookmark_manager': '\uf7b1',
        'material:bookmark_remove': '\ue59a',
        'material:bookmark_star': '\uf454',
        'material:bookmarks': '\ue98b',
        'material:books_movies_and_music': '\uef82',
        'material:border_all': '\ue228',
        'material:border_bottom': '\ue229',
        'material:border_clear': '\ue22a',
        'material:border_color': '\ue22b',
        'material:border_horizontal': '\ue22c',
        'material:border_inner': '\ue22d',
        'material:border_left': '\ue22e',
        'material:border_outer': '\ue22f',
        'material:border_right': '\ue230',
        'material:border_style': '\ue231',
        'material:border_top': '\ue232',
        'material:border_vertical': '\ue233',
        'material:borg': '\uf40d',
        'material:bottom_app_bar': '\ue730',
        'material:bottom_drawer': '\ue72d',
        'material:bottom_navigation': '\ue98c',
        'material:bottom_panel_close': '\uf72a',
        'material:bottom_panel_open': '\uf729',
        'material:bottom_right_click': '\uf684',
        'material:bottom_sheets': '\ue98d',
        'material:box': '\uf5a4',
        'material:box_add': '\uf5a5',
        'material:box_edit': '\uf5a6',
        'material:boy': '\ueb67',
        'material:brand_awareness': '\ue98e',
        'material:brand_family': '\uf4f1',
        'material:branding_watermark': '\ue06b',
        'material:breakfast_dining': '\uea54',
        'material:breaking_news': '\uea08',
        'material:breaking_news_alt_1': '\uf0ba',
        'material:breastfeeding': '\uf856',
        'material:brick': '\uf388',
        'material:briefcase_meal': '\uf246',
        'material:brightness_1': '\ue3a6',
        'material:brightness_2': '\ue3a7',
        'material:brightness_3': '\ue3a8',
        'material:brightness_4': '\ue3a9',
        'material:brightness_5': '\ue3aa',
        'material:brightness_6': '\ue3ab',
        'material:brightness_7': '\ue3ac',
        'material:brightness_alert': '\uf5cf',
        'material:brightness_auto': '\ue1ab',
        'material:brightness_empty': '\uf7e8',
        'material:brightness_high': '\ue1ac',
        'material:brightness_low': '\ue1ad',
        'material:brightness_medium': '\ue1ae',
        'material:bring_your_own_ip': '\ue016',
        'material:broadcast_on_home': '\uf8f8',
        'material:broadcast_on_personal': '\uf8f9',
        'material:broken_image': '\ue3ad',
        'material:browse': '\ueb13',
        'material:browse_activity': '\uf8a5',
        'material:browse_gallery': '\uebd1',
        'material:browser_updated': '\ue7cf',
        'material:brunch_dining': '\uea73',
        'material:brush': '\ue3ae',
        'material:bubble': '\uef83',
        'material:bubble_chart': '\ue6dd',
        'material:bubbles': '\uf64e',
        'material:bucket_check': '\uef2a',
        'material:bug_report': '\ue868',
        'material:build': '\ue869',
        'material:build_circle': '\uef48',
        'material:bungalow': '\ue591',
        'material:burst_mode': '\ue43c',
        'material:bus_alert': '\ue98f',
        'material:bus_railway': '\uf36b',
        'material:business_center': '\ueb3f',
        'material:business_chip': '\uf84c',
        'material:business_messages': '\uef84',
        'material:buttons_alt': '\ue72f',
        'material:cabin': '\ue589',
        'material:cable': '\uefe6',
        'material:cable_car': '\uf479',
        'material:cached': '\ue86a',
        'material:cadence': '\uf4b4',
        'material:cake': '\ue7e9',
        'material:cake_add': '\uf85b',
        'material:calculate': '\uea5f',
        'material:calendar_add_on': '\uef85',
        'material:calendar_apps_script': '\uf0bb',
        'material:calendar_check': '\uf243',
        'material:calendar_clock': '\uf540',
        'material:calendar_lock': '\uf242',
        'material:calendar_meal': '\uf296',
        'material:calendar_meal_2': '\uf240',
        'material:calendar_month': '\uebcc',
        'material:calendar_today': '\ue935',
        'material:calendar_view_day': '\ue936',
        'material:calendar_view_month': '\uefe7',
        'material:calendar_view_week': '\uefe8',
        'material:call': '\ue0b0',
        'material:call_end': '\ue0b1',
        'material:call_log': '\ue08e',
        'material:call_made': '\ue0b2',
        'material:call_merge': '\ue0b3',
        'material:call_missed': '\ue0b4',
        'material:call_missed_outgoing': '\ue0e4',
        'material:call_quality': '\uf652',
        'material:call_received': '\ue0b5',
        'material:call_split': '\ue0b6',
        'material:call_to_action': '\ue06c',
        'material:camera': '\ue3af',
        'material:camera_enhance': '\ue8fc',
        'material:camera_indoor': '\uefe9',
        'material:camera_outdoor': '\uefea',
        'material:camera_roll': '\ue3b3',
        'material:camera_video': '\uf7a6',
        'material:cameraswitch': '\uefeb',
        'material:campaign': '\uef49',
        'material:camping': '\uf8a2',
        'material:cancel': '\ue5c9',
        'material:cancel_presentation': '\ue0e9',
        'material:cancel_schedule_send': '\uea39',
        'material:candle': '\uf588',
        'material:candlestick_chart': '\uead4',
        'material:cannabis': '\uf2f3',
        'material:captive_portal': '\uf728',
        'material:capture': '\uf727',
        'material:car_crash': '\uebf2',
        'material:car_defrost_left': '\uf344',
        'material:car_defrost_low_left': '\uf343',
        'material:car_defrost_low_right': '\uf342',
        'material:car_defrost_mid_left': '\uf278',
        'material:car_defrost_mid_low_left': '\uf341',
        'material:car_defrost_mid_low_right': '\uf277',
        'material:car_defrost_mid_right': '\uf340',
        'material:car_defrost_right': '\uf33f',
        'material:car_fan_low_left': '\uf33e',
        'material:car_fan_low_mid_left': '\uf33d',
        'material:car_fan_low_right': '\uf33c',
        'material:car_fan_mid_left': '\uf33b',
        'material:car_fan_mid_low_right': '\uf33a',
        'material:car_fan_mid_right': '\uf339',
        'material:car_fan_recirculate': '\uf338',
        'material:car_gear': '\uf337',
        'material:car_lock': '\uf336',
        'material:car_mirror_heat': '\uf335',
        'material:car_rental': '\uea55',
        'material:car_repair': '\uea56',
        'material:car_tag': '\uf4e3',
        'material:card_membership': '\ue8f7',
        'material:card_travel': '\ue8f8',
        'material:cardio_load': '\uf4b9',
        'material:cardiology': '\ue09c',
        'material:cards': '\ue991',
        'material:cards_star': '\uf375',
        'material:carpenter': '\uf1f8',
        'material:carry_on_bag': '\ueb08',
        'material:carry_on_bag_checked': '\ueb0b',
        'material:carry_on_bag_inactive': '\ueb0a',
        'material:carry_on_bag_question': '\ueb09',
        'material:cases': '\ue992',
        'material:casino': '\ueb40',
        'material:cast': '\ue307',
        'material:cast_connected': '\ue308',
        'material:cast_for_education': '\uefec',
        'material:cast_pause': '\uf5f0',
        'material:cast_warning': '\uf5ef',
        'material:castle': '\ueab1',
        'material:category': '\ue574',
        'material:category_search': '\uf437',
        'material:celebration': '\uea65',
        'material:cell_merge': '\uf82e',
        'material:cell_tower': '\uebba',
        'material:cell_wifi': '\ue0ec',
        'material:center_focus_strong': '\ue3b4',
        'material:center_focus_weak': '\ue3b5',
        'material:chair': '\uefed',
        'material:chair_alt': '\uefee',
        'material:chair_counter': '\uf29f',
        'material:chair_fireplace': '\uf29e',
        'material:chair_umbrella': '\uf29d',
        'material:chalet': '\ue585',
        'material:change_circle': '\ue2e7',
        'material:change_history': '\ue86b',
        'material:charger': '\ue2ae',
        'material:chart_data': '\ue473',
        'material:chat': '\ue0b7',
        'material:chat_add_on': '\uf0f3',
        'material:chat_apps_script': '\uf0bd',
        'material:chat_bubble': '\ue0ca',
        'material:chat_dashed': '\ueeed',
        'material:chat_error': '\uf7ac',
        'material:chat_info': '\uf52b',
        'material:chat_paste_go': '\uf6bd',
        'material:chat_paste_go_2': '\uf3cb',
        'material:check': '\ue5ca',
        'material:check_box': '\ue834',
        'material:check_box_outline_blank': '\ue835',
        'material:check_circle': '\ue86c',
        'material:check_circle_unread': '\uf27e',
        'material:check_in_out': '\uf6f6',
        'material:check_indeterminate_small': '\uf88a',
        'material:check_small': '\uf88b',
        'material:checkbook': '\ue70d',
        'material:checked_bag': '\ueb0c',
        'material:checked_bag_question': '\ueb0d',
        'material:checklist': '\ue6b1',
        'material:checklist_rtl': '\ue6b3',
        'material:checkroom': '\uf19e',
        'material:cheer': '\uf6a8',
        'material:chef_hat': '\uf357',
        'material:chess': '\uf5e7',
        'material:chess_bishop': '\uf261',
        'material:chess_bishop_2': '\uf262',
        'material:chess_king': '\uf25f',
        'material:chess_king_2': '\uf260',
        'material:chess_knight': '\uf25e',
        'material:chess_pawn': '\uf3b6',
        'material:chess_pawn_2': '\uf25d',
        'material:chess_queen': '\uf25c',
        'material:chess_rook': '\uf25b',
        'material:chevron_backward': '\uf46b',
        'material:chevron_forward': '\uf46a',
        'material:chevron_left': '\ue408',
        'material:chevron_right': '\ue409',
        'material:child_care': '\ueb41',
        'material:child_friendly': '\ueb42',
        'material:child_hat': '\uef30',
        'material:chip_extraction': '\uf821',
        'material:chips': '\ue993',
        'material:chrome_reader_mode': '\ue86d',
        'material:chromecast_2': '\uf17b',
        'material:chromecast_device': '\ue83c',
        'material:chronic': '\uebb2',
        'material:church': '\ueaae',
        'material:cinematic_blur': '\uf853',
        'material:circle': '\uef4a',
        'material:circle_notifications': '\ue994',
        'material:circles': '\ue7ea',
        'material:circles_ext': '\ue7ec',
        'material:clarify': '\uf0bf',
        'material:clean_hands': '\uf21f',
        'material:cleaning': '\ue995',
        'material:cleaning_bucket': '\uf8b4',
        'material:cleaning_services': '\uf0ff',
        'material:clear_all': '\ue0b8',
        'material:clear_day': '\uf157',
        'material:climate_mini_split': '\uf8b5',
        'material:clinical_notes': '\ue09e',
        'material:clock_arrow_down': '\uf382',
        'material:clock_arrow_up': '\uf381',
        'material:clock_loader_10': '\uf726',
        'material:clock_loader_20': '\uf725',
        'material:clock_loader_40': '\uf724',
        'material:clock_loader_60': '\uf723',
        'material:clock_loader_80': '\uf722',
        'material:clock_loader_90': '\uf721',
        'material:close': '\ue14c',
        'material:close_fullscreen': '\uf1cf',
        'material:close_small': '\uf508',
        'material:closed_caption': '\ue01c',
        'material:closed_caption_add': '\uf4ae',
        'material:closed_caption_disabled': '\uf1dc',
        'material:cloud': '\ue2bd',
        'material:cloud_alert': '\uf3cc',
        'material:cloud_circle': '\ue2be',
        'material:cloud_done': '\ue2bf',
        'material:cloud_download': '\ue2c0',
        'material:cloud_lock': '\uf386',
        'material:cloud_off': '\ue2c1',
        'material:cloud_sync': '\ueb5a',
        'material:cloud_upload': '\ue2c3',
        'material:cloudy_snowing': '\ue810',
        'material:co_present': '\ueaf0',
        'material:co2': '\ue7b0',
        'material:code': '\ue86f',
        'material:code_blocks': '\uf84d',
        'material:code_off': '\ue4f3',
        'material:coffee': '\uefef',
        'material:coffee_maker': '\ueff0',
        'material:cognition': '\ue09f',
        'material:cognition_2': '\uf3b5',
        'material:collapse_all': '\ue944',
        'material:collapse_content': '\uf507',
        'material:collections_bookmark': '\ue431',
        'material:colorize': '\ue3b8',
        'material:colors': '\ue997',
        'material:combine_columns': '\uf420',
        'material:comedy_mask': '\uf4d6',
        'material:comic_bubble': '\uf5dd',
        'material:comment': '\ue0b9',
        'material:comment_bank': '\uea4e',
        'material:comments_disabled': '\ue7a2',
        'material:commit': '\ueaf5',
        'material:communication': '\ue27c',
        'material:communities': '\ue7ed',
        'material:commute': '\ue940',
        'material:compare': '\ue3b9',
        'material:compare_arrows': '\ue915',
        'material:compass_calibration': '\ue57c',
        'material:component_exchange': '\uf1e7',
        'material:compost': '\ue761',
        'material:compress': '\ue94d',
        'material:computer': '\ue30a',
        'material:computer_arrow_up': '\uf2f7',
        'material:computer_cancel': '\uf2f6',
        'material:concierge': '\uf561',
        'material:conditions': '\ue0a0',
        'material:confirmation_number': '\ue638',
        'material:congenital': '\ue0a1',
        'material:connect_without_contact': '\uf223',
        'material:connected_tv': '\ue998',
        'material:connecting_airports': '\ue7c9',
        'material:construction': '\uea3c',
        'material:contact_emergency': '\uf8d1',
        'material:contact_mail': '\ue0d0',
        'material:contact_page': '\uf22e',
        'material:contact_phone': '\ue0cf',
        'material:contact_support': '\ue94c',
        'material:contactless': '\uea71',
        'material:contactless_off': '\uf858',
        'material:contacts': '\ue0ba',
        'material:contacts_product': '\ue999',
        'material:content_copy': '\ue14d',
        'material:content_cut': '\ue14e',
        'material:content_paste': '\ue14f',
        'material:content_paste_go': '\uea8e',
        'material:content_paste_off': '\ue4f8',
        'material:content_paste_search': '\uea9b',
        'material:contextual_token': '\uf486',
        'material:contextual_token_add': '\uf485',
        'material:contract': '\uf5a0',
        'material:contract_delete': '\uf5a2',
        'material:contract_edit': '\uf5a1',
        'material:contrast': '\ueb37',
        'material:contrast_circle': '\ue6a2',
        'material:contrast_rtl_off': '\uec72',
        'material:contrast_square': '\uf4a0',
        'material:control_camera': '\ue074',
        'material:control_point_duplicate': '\ue3bb',
        'material:controller_gen': '\ue83d',
        'material:conversation': '\uef2f',
        'material:conversion_path': '\uf0c1',
        'material:conversion_path_off': '\uf7b4',
        'material:convert_to_text': '\uf41f',
        'material:conveyor_belt': '\uf867',
        'material:cookie': '\ueaac',
        'material:cookie_off': '\uf79a',
        'material:cooking': '\ue2b6',
        'material:cool_to_dry': '\ue276',
        'material:copy_all': '\ue2ec',
        'material:coronavirus': '\uf221',
        'material:corporate_fare': '\uf1d0',
        'material:cottage': '\ue587',
        'material:counter_0': '\uf785',
        'material:counter_1': '\uf784',
        'material:counter_2': '\uf783',
        'material:counter_3': '\uf782',
        'material:counter_4': '\uf781',
        'material:counter_5': '\uf780',
        'material:counter_6': '\uf77f',
        'material:counter_7': '\uf77e',
        'material:counter_8': '\uf77d',
        'material:counter_9': '\uf77c',
        'material:countertops': '\uf1f7',
        'material:CR': '\u000d',
        'material:create_new_folder': '\ue2cc',
        'material:credit_card': '\ue870',
        'material:credit_card_clock': '\uf438',
        'material:credit_card_gear': '\uf52d',
        'material:credit_card_heart': '\uf52c',
        'material:credit_card_off': '\ue4f4',
        'material:credit_score': '\ueff1',
        'material:crib': '\ue588',
        'material:crisis_alert': '\uebe9',
        'material:crop': '\ue3be',
        'material:crop_16_9': '\ue3bc',
        'material:crop_3_2': '\ue3bd',
        'material:crop_5_4': '\ue3bf',
        'material:crop_7_5': '\ue3c0',
        'material:crop_9_16': '\uf549',
        'material:crop_free': '\ue3c2',
        'material:crop_landscape': '\ue3c3',
        'material:crop_portrait': '\ue3c5',
        'material:crop_rotate': '\ue437',
        'material:crop_square': '\ue3c1',
        'material:crossword': '\uf5e5',
        'material:crowdsource': '\ueb18',
        'material:crown': '\uecb3',
        'material:cruelty_free': '\ue799',
        'material:css': '\ueb93',
        'material:csv': '\ue6cf',
        'material:currency_bitcoin': '\uebc5',
        'material:currency_exchange': '\ueb70',
        'material:currency_franc': '\ueafa',
        'material:currency_lira': '\ueaef',
        'material:currency_pound': '\ueaf1',
        'material:currency_ruble': '\ueaec',
        'material:currency_rupee': '\ueaf7',
        'material:currency_rupee_circle': '\uf460',
        'material:currency_yen': '\ueafb',
        'material:currency_yuan': '\ueaf9',
        'material:curtains': '\uec1e',
        'material:curtains_closed': '\uec1d',
        'material:custom_typography': '\ue732',
        'material:cut': '\uf08b',
        'material:cycle': '\uf854',
        'material:cyclone': '\uebd5',
        'material:dangerous': '\ue99a',
        'material:dark_mode': '\ue51c',
        'material:dashboard': '\ue871',
        'material:dashboard_2': '\uf3ea',
        'material:dashboard_customize': '\ue99b',
        'material:data_alert': '\uf7f6',
        'material:data_array': '\uead1',
        'material:data_check': '\uf7f2',
        'material:data_exploration': '\ue76f',
        'material:data_info_alert': '\uf7f5',
        'material:data_loss_prevention': '\ue2dc',
        'material:data_object': '\uead3',
        'material:data_saver_on': '\ueff3',
        'material:data_table': '\ue99c',
        'material:data_thresholding': '\ueb9f',
        'material:data_usage': '\ue1af',
        'material:database': '\uf20e',
        'material:database_off': '\uf414',
        'material:database_search': '\uf38e',
        'material:database_upload': '\uf3dc',
        'material:dataset': '\uf8ee',
        'material:dataset_linked': '\uf8ef',
        'material:date_range': '\ue916',
        'material:deblur': '\ueb77',
        'material:deceased': '\ue0a5',
        'material:decimal_decrease': '\uf82d',
        'material:decimal_increase': '\uf82c',
        'material:deck': '\uea42',
        'material:dehaze': '\ue3c7',
        'material:delete': '\ue872',
        'material:delete_forever': '\ue92b',
        'material:delete_history': '\uf518',
        'material:delete_sweep': '\ue16c',
        'material:delivery_truck_bolt': '\uf3a2',
        'material:delivery_truck_speed': '\uf3a1',
        'material:demography': '\ue489',
        'material:density_large': '\ueba9',
        'material:density_medium': '\ueb9e',
        'material:density_small': '\ueba8',
        'material:dentistry': '\ue0a6',
        'material:departure_board': '\ue576',
        'material:deployed_code': '\uf720',
        'material:deployed_code_account': '\uf51b',
        'material:deployed_code_alert': '\uf5f2',
        'material:deployed_code_history': '\uf5f3',
        'material:deployed_code_update': '\uf5f4',
        'material:dermatology': '\ue0a7',
        'material:description': '\ue873',
        'material:deselect': '\uebb6',
        'material:design_services': '\uf10a',
        'material:desk': '\uf8f4',
        'material:deskphone': '\uf7fa',
        'material:desktop_access_disabled': '\ue99d',
        'material:desktop_cloud': '\uf3db',
        'material:desktop_cloud_stack': '\uf3be',
        'material:desktop_landscape': '\uf45e',
        'material:desktop_landscape_add': '\uf439',
        'material:desktop_mac': '\ue30b',
        'material:desktop_portrait': '\uf45d',
        'material:desktop_windows': '\ue30c',
        'material:destruction': '\uf585',
        'material:details': '\ue3c8',
        'material:detection_and_zone': '\ue29f',
        'material:detector': '\ue282',
        'material:detector_alarm': '\ue1f7',
        'material:detector_battery': '\ue204',
        'material:detector_co': '\ue2af',
        'material:detector_offline': '\ue223',
        'material:detector_smoke': '\ue285',
        'material:detector_status': '\ue1e8',
        'material:developer_board': '\ue30d',
        'material:developer_board_off': '\ue4ff',
        'material:developer_guide': '\ue99e',
        'material:developer_mode_tv': '\ue874',
        'material:device_band': '\uf2f5',
        'material:device_hub': '\ue335',
        'material:device_thermostat': '\ue1ff',
        'material:devices': '\ue1b1',
        'material:devices_fold': '\uebde',
        'material:devices_fold_2': '\uf406',
        'material:devices_off': '\ue327',
        'material:devices_other': '\ue337',
        'material:devices_wearables': '\uf6ab',
        'material:dew_point': '\uf879',
        'material:diagnosis': '\ue0a8',
        'material:diagonal_line': '\uf41e',
        'material:dialer_sip': '\ue0bb',
        'material:dialogs': '\ue99f',
        'material:dialpad': '\ue0bc',
        'material:diamond': '\uead5',
        'material:diamond_shine': '\uf2b2',
        'material:dictionary': '\uf539',
        'material:difference': '\ueb7d',
        'material:digit_eight': '\u0038',
        'material:digit_five': '\u0035',
        'material:digit_four': '\u0034',
        'material:digit_nine': '\u0039',
        'material:digit_one': '\u0031',
        'material:digit_seven': '\u0037',
        'material:digit_six': '\u0036',
        'material:digit_three': '\u0033',
        'material:digit_two': '\u0032',
        'material:digit_zero': '\u0030',
        'material:digital_out_of_home': '\uf1de',
        'material:digital_wellbeing': '\uef86',
        'material:dine_heart': '\uf29c',
        'material:dine_in': '\uf295',
        'material:dine_lamp': '\uf29b',
        'material:dining': '\ueff4',
        'material:dinner_dining': '\uea57',
        'material:directions': '\ue52e',
        'material:directions_alt': '\uf880',
        'material:directions_alt_off': '\uf881',
        'material:directions_bike': '\ue52f',
        'material:directions_boat': '\ue532',
        'material:directions_bus': '\ue530',
        'material:directions_car': '\ue531',
        'material:directions_off': '\uf10f',
        'material:directions_railway': '\ue534',
        'material:directions_railway_2': '\uf462',
        'material:directions_run': '\ue566',
        'material:directions_subway': '\ue533',
        'material:directions_walk': '\ue536',
        'material:directory_sync': '\ue394',
        'material:dirty_lens': '\uef4b',
        'material:disabled_by_default': '\uf230',
        'material:disabled_visible': '\ue76e',
        'material:disc_full': '\ue610',
        'material:discover_tune': '\ue018',
        'material:dishwasher': '\ue9a0',
        'material:dishwasher_gen': '\ue832',
        'material:display_external_input': '\uf7e7',
        'material:display_settings': '\ueb97',
        'material:distance': '\uf6ea',
        'material:diversity_1': '\uf8d7',
        'material:diversity_2': '\uf8d8',
        'material:diversity_3': '\uf8d9',
        'material:diversity_4': '\uf857',
        'material:dns': '\ue875',
        'material:do_not_disturb': '\ue612',
        'material:do_not_disturb_off': '\ue643',
        'material:do_not_disturb_on': '\ue15c',
        'material:do_not_disturb_on_total_silence': '\ueffb',
        'material:do_not_step': '\uf19f',
        'material:do_not_touch': '\uf1b0',
        'material:dock': '\ue30e',
        'material:dock_to_bottom': '\uf7e6',
        'material:dock_to_left': '\uf7e5',
        'material:dock_to_right': '\uf7e4',
        'material:docs': '\uea7d',
        'material:docs_add_on': '\uf0c2',
        'material:docs_apps_script': '\uf0c3',
        'material:document_scanner': '\ue5fa',
        'material:document_search': '\uf385',
        'material:domain': '\ue0af',
        'material:domain_add': '\ueb62',
        'material:domain_disabled': '\ue0ef',
        'material:domain_verification': '\uef4c',
        'material:domain_verification_off': '\uf7b0',
        'material:domino_mask': '\uf5e4',
        'material:done': '\ue876',
        'material:done_all': '\ue877',
        'material:done_outline': '\ue92f',
        'material:donut_large': '\ue917',
        'material:donut_small': '\ue918',
        'material:door_back': '\ueffc',
        'material:door_front': '\ueffd',
        'material:door_open': '\ue77c',
        'material:door_sensor': '\ue28a',
        'material:door_sliding': '\ueffe',
        'material:doorbell': '\uefff',
        'material:doorbell_3p': '\ue1e7',
        'material:doorbell_chime': '\ue1f3',
        'material:double_arrow': '\uea50',
        'material:downhill_skiing': '\ue509',
        'material:download': '\ue171',
        'material:download_2': '\uf523',
        'material:download_done': '\ue9aa',
        'material:download_for_offline': '\uf000',
        'material:downloading': '\uf001',
        'material:draft_orders': '\ue7b3',
        'material:drafts': '\ue151',
        'material:drag_click': '\uf71f',
        'material:drag_handle': '\ue25d',
        'material:drag_indicator': '\ue945',
        'material:drag_pan': '\uf71e',
        'material:draw': '\ue746',
        'material:draw_abstract': '\uf7f8',
        'material:draw_collage': '\uf7f7',
        'material:drawing_recognition': '\ueb00',
        'material:dresser': '\ue210',
        'material:drive_export': '\uf41d',
        'material:drive_file_move': '\ue675',
        'material:drive_file_rename_outline': '\ue9a2',
        'material:drive_folder_upload': '\ue9a3',
        'material:drone': '\uf25a',
        'material:drone_2': '\uf259',
        'material:dropdown': '\ue9a4',
        'material:dropper_eye': '\uf351',
        'material:dry': '\uf1b3',
        'material:dry_cleaning': '\uea58',
        'material:dual_screen': '\uf6cf',
        'material:duo': '\ue9a5',
        'material:dvr': '\ue1b2',
        'material:dynamic_feed': '\uea14',
        'material:dynamic_form': '\uf1bf',
        'material:e_mobiledata': '\uf002',
        'material:e_mobiledata_badge': '\uf7e3',
        'material:e911_avatar': '\uf11a',
        'material:e911_emergency': '\uf119',
        'material:ear_sound': '\uf356',
        'material:earbud_case': '\uf327',
        'material:earbud_left': '\uf326',
        'material:earbud_right': '\uf325',
        'material:earbuds': '\uf003',
        'material:earbuds_2': '\uf324',
        'material:earbuds_battery': '\uf004',
        'material:early_on': '\ue2ba',
        'material:earthquake': '\uf64f',
        'material:east': '\uf1df',
        'material:ecg': '\uf80f',
        'material:ecg_heart': '\uf6e9',
        'material:eco': '\uea35',
        'material:eda': '\uf6e8',
        'material:edit': '\ue150',
        'material:edit_arrow_down': '\uf380',
        'material:edit_arrow_up': '\uf37f',
        'material:edit_attributes': '\ue578',
        'material:edit_audio': '\uf42d',
        'material:edit_calendar': '\ue742',
        'material:edit_document': '\uf88c',
        'material:edit_location': '\ue568',
        'material:edit_location_alt': '\ue1c5',
        'material:edit_note': '\ue745',
        'material:edit_notifications': '\ue525',
        'material:edit_off': '\ue950',
        'material:edit_road': '\uef4d',
        'material:edit_square': '\uf88d',
        'material:editor_choice': '\uf528',
        'material:egg': '\ueacc',
        'material:egg_alt': '\ueac8',
        'material:eject': '\ue8fb',
        'material:elderly': '\uf21a',
        'material:elderly_woman': '\ueb69',
        'material:electric_bike': '\ueb1b',
        'material:electric_bolt': '\uec1c',
        'material:electric_car': '\ueb1c',
        'material:electric_meter': '\uec1b',
        'material:electric_moped': '\ueb1d',
        'material:electric_rickshaw': '\ueb1e',
        'material:electric_scooter': '\ueb1f',
        'material:electrical_services': '\uf102',
        'material:elevation': '\uf6e7',
        'material:elevator': '\uf1a0',
        'material:emergency': '\ue1eb',
        'material:emergency_heat': '\uf15d',
        'material:emergency_heat_2': '\uf4e5',
        'material:emergency_home': '\ue82a',
        'material:emergency_recording': '\uebf4',
        'material:emergency_share': '\uebf6',
        'material:emergency_share_off': '\uf59e',
        'material:emoji_food_beverage': '\uea1b',
        'material:emoji_language': '\uf4cd',
        'material:emoji_nature': '\uea1c',
        'material:emoji_objects': '\uea24',
        'material:emoji_people': '\uea1d',
        'material:emoji_symbols': '\uea1e',
        'material:emoji_transportation': '\uea1f',
        'material:emoticon': '\ue5f3',
        'material:empty_dashboard': '\uf844',
        'material:enable': '\uf188',
        'material:encrypted': '\ue593',
        'material:encrypted_add': '\uf429',
        'material:encrypted_add_circle': '\uf42a',
        'material:encrypted_minus_circle': '\uf428',
        'material:encrypted_off': '\uf427',
        'material:endocrinology': '\ue0a9',
        'material:energy': '\ue9a6',
        'material:energy_program_saving': '\uf15f',
        'material:energy_program_time_used': '\uf161',
        'material:energy_savings_leaf': '\uec1a',
        'material:engineering': '\uea3d',
        'material:enhanced_encryption': '\ue63f',
        'material:ent': '\ue0aa',
        'material:enterprise': '\ue70e',
        'material:enterprise_off': '\ueb4d',
        'material:equalizer': '\ue01d',
        'material:eraser_size_1': '\uf3fc',
        'material:eraser_size_2': '\uf3fb',
        'material:eraser_size_3': '\uf3fa',
        'material:eraser_size_4': '\uf3f9',
        'material:eraser_size_5': '\uf3f8',
        'material:error': '\ue000',
        'material:error_med': '\ue49b',
        'material:escalator': '\uf1a1',
        'material:escalator_warning': '\uf1ac',
        'material:euro': '\uea15',
        'material:euro_symbol': '\ue926',
        'material:ev_mobiledata_badge': '\uf7e2',
        'material:ev_shadow': '\uef8f',
        'material:ev_shadow_add': '\uf580',
        'material:ev_shadow_minus': '\uf57f',
        'material:ev_station': '\ue209',
        'material:event': '\ue24f',
        'material:event_available': '\ue614',
        'material:event_busy': '\ue615',
        'material:event_list': '\uf683',
        'material:event_note': '\ue616',
        'material:event_repeat': '\ueb7b',
        'material:event_seat': '\ue903',
        'material:event_upcoming': '\uf238',
        'material:exclamation': '\uf22f',
        'material:exercise': '\uf6e6',
        'material:exit_to_app': '\ue879',
        'material:expand': '\ue94f',
        'material:expand_all': '\ue946',
        'material:expand_circle_down': '\ue7cd',
        'material:expand_circle_right': '\uf591',
        'material:expand_circle_up': '\uf5d2',
        'material:expand_content': '\uf830',
        'material:expand_less': '\ue5ce',
        'material:expand_more': '\ue5cf',
        'material:expansion_panels': '\ue600',
        'material:experiment': '\ue686',
        'material:explicit': '\ue01e',
        'material:explore': '\ue87a',
        'material:explore_nearby': '\ue538',
        'material:explore_off': '\ue9a8',
        'material:explosion': '\uf685',
        'material:export_notes': '\ue0ac',
        'material:exposure': '\ue3ca',
        'material:exposure_neg_1': '\ue3cb',
        'material:exposure_neg_2': '\ue3cc',
        'material:exposure_plus_1': '\ue3cd',
        'material:exposure_plus_2': '\ue3ce',
        'material:exposure_zero': '\ue3cf',
        'material:extension': '\ue87b',
        'material:extension_off': '\ue4f5',
        'material:eye_tracking': '\uf4c9',
        'material:eyeglasses': '\uf6ee',
        'material:eyeglasses_2': '\uf2c7',
        'material:eyeglasses_2_sound': '\uf265',
        'material:face': '\ue87c',
        'material:face_2': '\uf8da',
        'material:face_3': '\uf8db',
        'material:face_4': '\uf8dc',
        'material:face_5': '\uf8dd',
        'material:face_6': '\uf8de',
        'material:face_down': '\uf402',
        'material:face_left': '\uf401',
        'material:face_nod': '\uf400',
        'material:face_retouching_natural': '\uef4e',
        'material:face_retouching_off': '\uf007',
        'material:face_right': '\uf3ff',
        'material:face_shake': '\uf3fe',
        'material:face_up': '\uf3fd',
        'material:fact_check': '\uf0c5',
        'material:factory': '\uebbc',
        'material:falling': '\uf60d',
        'material:familiar_face_and_zone': '\ue21c',
        'material:family_group': '\ueef2',
        'material:family_history': '\ue0ad',
        'material:family_home': '\ueb26',
        'material:family_link': '\ueb19',
        'material:family_restroom': '\uf1a2',
        'material:family_star': '\uf527',
        'material:fan_focus': '\uf334',
        'material:fan_indirect': '\uf333',
        'material:farsight_digital': '\uf559',
        'material:fast_forward': '\ue01f',
        'material:fast_rewind': '\ue020',
        'material:fastfood': '\ue57a',
        'material:faucet': '\ue278',
        'material:favorite': '\ue87d',
        'material:fax': '\uead8',
        'material:feature_search': '\ue9a9',
        'material:featured_play_list': '\ue06d',
        'material:featured_seasonal_and_gifts': '\uef91',
        'material:featured_video': '\ue06e',
        'material:feed': '\uf009',
        'material:female': '\ue590',
        'material:femur': '\uf891',
        'material:femur_alt': '\uf892',
        'material:fence': '\uf1f6',
        'material:fertile': '\uf6e5',
        'material:festival': '\uea68',
        'material:fiber_dvr': '\ue05d',
        'material:fiber_manual_record': '\ue061',
        'material:fiber_new': '\ue05e',
        'material:fiber_pin': '\ue06a',
        'material:fiber_smart_record': '\ue062',
        'material:file_copy': '\ue173',
        'material:file_copy_off': '\uf4d8',
        'material:file_download_off': '\ue4fe',
        'material:file_export': '\uf3b2',
        'material:file_json': '\uf3bb',
        'material:file_map': '\ue2c5',
        'material:file_map_stack': '\uf3e2',
        'material:file_open': '\ueaf3',
        'material:file_png': '\uf3bc',
        'material:file_present': '\uea0e',
        'material:file_save': '\uf17f',
        'material:file_save_off': '\ue505',
        'material:file_upload_off': '\uf886',
        'material:files': '\uea85',
        'material:filter': '\ue3b6',
        'material:filter_1': '\ue3d0',
        'material:filter_2': '\ue3d1',
        'material:filter_3': '\ue3d2',
        'material:filter_4': '\ue3d4',
        'material:filter_5': '\ue3d5',
        'material:filter_6': '\ue3d6',
        'material:filter_7': '\ue3d7',
        'material:filter_8': '\ue3d8',
        'material:filter_9': '\ue3d9',
        'material:filter_9_plus': '\ue3da',
        'material:filter_alt': '\uef4f',
        'material:filter_alt_off': '\ueb32',
        'material:filter_arrow_right': '\uf3d1',
        'material:filter_b_and_w': '\ue3db',
        'material:filter_center_focus': '\ue3dc',
        'material:filter_drama': '\ue3dd',
        'material:filter_frames': '\ue3de',
        'material:filter_hdr': '\ue3df',
        'material:filter_list': '\ue152',
        'material:filter_list_alt': '\ue94e',
        'material:filter_list_off': '\ueb57',
        'material:filter_none': '\ue3e0',
        'material:filter_retrolux': '\ue3e1',
        'material:filter_tilt_shift': '\ue3e2',
        'material:filter_vintage': '\ue3e3',
        'material:finance': '\ue6bf',
        'material:finance_chip': '\uf84e',
        'material:finance_mode': '\uef92',
        'material:find_in_page': '\ue880',
        'material:find_replace': '\ue881',
        'material:fingerprint': '\ue90d',
        'material:fingerprint_off': '\uf49d',
        'material:fire_extinguisher': '\uf1d8',
        'material:fire_hydrant': '\uf1a3',
        'material:fire_truck': '\uf8f2',
        'material:fireplace': '\uea43',
        'material:first_page': '\ue5dc',
        'material:fit_page': '\uf77a',
        'material:fit_page_height': '\uf397',
        'material:fit_page_width': '\uf396',
        'material:fit_screen': '\uea10',
        'material:fit_width': '\uf779',
        'material:fitness_center': '\ueb43',
        'material:fitness_tracker': '\uf463',
        'material:fitness_trackers': '\ueef1',
        'material:flag': '\ue153',
        'material:flag_2': '\uf40f',
        'material:flag_check': '\uf3d8',
        'material:flag_circle': '\ueaf8',
        'material:flaky': '\uef50',
        'material:flare': '\ue3e4',
        'material:flash_auto': '\ue3e5',
        'material:flash_off': '\ue3e6',
        'material:flash_on': '\ue3e7',
        'material:flashlight_off': '\uf00a',
        'material:flashlight_on': '\uf00b',
        'material:flatware': '\uf00c',
        'material:flex_direction': '\uf778',
        'material:flex_no_wrap': '\uf777',
        'material:flex_wrap': '\uf776',
        'material:flight': '\ue539',
        'material:flight_class': '\ue7cb',
        'material:flight_land': '\ue904',
        'material:flight_takeoff': '\ue905',
        'material:flights_and_hotels': '\ue9ab',
        'material:flip': '\ue3e8',
        'material:flip_camera_android': '\uea37',
        'material:flip_camera_ios': '\uea38',
        'material:flip_to_back': '\ue882',
        'material:flip_to_front': '\ue883',
        'material:float_landscape_2': '\uf45c',
        'material:float_portrait_2': '\uf45b',
        'material:flood': '\uebe6',
        'material:floor': '\uf6e4',
        'material:floor_lamp': '\ue21e',
        'material:flowchart': '\uf38d',
        'material:flowsheet': '\ue0ae',
        'material:fluid': '\ue483',
        'material:fluid_balance': '\uf80d',
        'material:fluid_med': '\uf80c',
        'material:flutter': '\uf1dd',
        'material:flutter_dash': '\ue00b',
        'material:flyover': '\uf478',
        'material:fmd_bad': '\uf00e',
        'material:foggy': '\ue818',
        'material:folded_hands': '\uf5ed',
        'material:folder': '\ue2c7',
        'material:folder_check': '\uf3d7',
        'material:folder_check_2': '\uf3d6',
        'material:folder_code': '\uf3c8',
        'material:folder_copy': '\uebbd',
        'material:folder_data': '\uf586',
        'material:folder_delete': '\ueb34',
        'material:folder_eye': '\uf3d5',
        'material:folder_info': '\uf395',
        'material:folder_limited': '\uf4e4',
        'material:folder_managed': '\uf775',
        'material:folder_match': '\uf3d4',
        'material:folder_off': '\ueb83',
        'material:folder_open': '\ue2c8',
        'material:folder_shared': '\ue2c9',
        'material:folder_special': '\ue617',
        'material:folder_supervised': '\uf774',
        'material:folder_zip': '\ueb2c',
        'material:follow_the_signs': '\uf222',
        'material:font_download': '\ue167',
        'material:font_download_off': '\ue4f9',
        'material:food_bank': '\uf1f2',
        'material:foot_bones': '\uf893',
        'material:footprint': '\uf87d',
        'material:for_you': '\ue9ac',
        'material:forest': '\uea99',
        'material:fork_left': '\ueba0',
        'material:fork_right': '\uebac',
        'material:fork_spoon': '\uf3e4',
        'material:forklift': '\uf868',
        'material:format_align_center': '\ue234',
        'material:format_align_justify': '\ue235',
        'material:format_align_left': '\ue236',
        'material:format_align_right': '\ue237',
        'material:format_bold': '\ue238',
        'material:format_clear': '\ue239',
        'material:format_color_fill': '\ue23a',
        'material:format_color_reset': '\ue23b',
        'material:format_color_text': '\ue23c',
        'material:format_h1': '\uf85d',
        'material:format_h2': '\uf85e',
        'material:format_h3': '\uf85f',
        'material:format_h4': '\uf860',
        'material:format_h5': '\uf861',
        'material:format_h6': '\uf862',
        'material:format_image_left': '\uf863',
        'material:format_image_right': '\uf864',
        'material:format_indent_decrease': '\ue23d',
        'material:format_indent_increase': '\ue23e',
        'material:format_ink_highlighter': '\uf82b',
        'material:format_italic': '\ue23f',
        'material:format_letter_spacing': '\uf773',
        'material:format_letter_spacing_2': '\uf618',
        'material:format_letter_spacing_standard': '\uf617',
        'material:format_letter_spacing_wide': '\uf616',
        'material:format_letter_spacing_wider': '\uf615',
        'material:format_line_spacing': '\ue240',
        'material:format_list_bulleted': '\ue241',
        'material:format_list_bulleted_add': '\uf849',
        'material:format_list_numbered': '\ue242',
        'material:format_list_numbered_rtl': '\ue267',
        'material:format_overline': '\ueb65',
        'material:format_paint': '\ue243',
        'material:format_paragraph': '\uf865',
        'material:format_quote': '\ue244',
        'material:format_quote_off': '\uf413',
        'material:format_shapes': '\ue25e',
        'material:format_size': '\ue245',
        'material:format_strikethrough': '\ue246',
        'material:format_text_clip': '\uf82a',
        'material:format_text_overflow': '\uf829',
        'material:format_text_wrap': '\uf828',
        'material:format_textdirection_l_to_r': '\ue247',
        'material:format_textdirection_r_to_l': '\ue248',
        'material:format_textdirection_vertical': '\uf4b8',
        'material:format_underlined': '\ue249',
        'material:format_underlined_squiggle': '\uf885',
        'material:forms_add_on': '\uf0c7',
        'material:forms_apps_script': '\uf0c8',
        'material:fort': '\ueaad',
        'material:forum': '\ue0bf',
        'material:forward': '\ue154',
        'material:forward_10': '\ue056',
        'material:forward_30': '\ue057',
        'material:forward_5': '\ue058',
        'material:forward_circle': '\uf6f5',
        'material:forward_media': '\uf6f4',
        'material:forward_to_inbox': '\uf187',
        'material:foundation': '\uf200',
        'material:fragrance': '\uf345',
        'material:frame_bug': '\ueeef',
        'material:frame_exclamation': '\ueeee',
        'material:frame_inspect': '\uf772',
        'material:frame_person': '\uf8a6',
        'material:frame_person_mic': '\uf4d5',
        'material:frame_person_off': '\uf7d1',
        'material:frame_reload': '\uf771',
        'material:frame_source': '\uf770',
        'material:free_cancellation': '\ue748',
        'material:front_hand': '\ue769',
        'material:front_loader': '\uf869',
        'material:full_coverage': '\ueb12',
        'material:full_hd': '\uf58b',
        'material:full_stacked_bar_chart': '\uf212',
        'material:fullscreen': '\ue5d0',
        'material:fullscreen_exit': '\ue5d1',
        'material:fullscreen_portrait': '\uf45a',
        'material:function': '\uf866',
        'material:functions': '\ue24a',
        'material:funicular': '\uf477',
        'material:g_mobiledata': '\uf010',
        'material:g_mobiledata_badge': '\uf7e1',
        'material:g_translate': '\ue927',
        'material:gallery_thumbnail': '\uf86f',
        'material:gamepad': '\ue021',
        'material:garage': '\uf011',
        'material:garage_check': '\uf28d',
        'material:garage_door': '\ue714',
        'material:garage_home': '\ue82d',
        'material:garage_money': '\uf28c',
        'material:garden_cart': '\uf8a9',
        'material:gas_meter': '\uec19',
        'material:gastroenterology': '\ue0f1',
        'material:gate': '\ue277',
        'material:gavel': '\ue90e',
        'material:general_device': '\ue6de',
        'material:generating_tokens': '\ue749',
        'material:genetics': '\ue0f3',
        'material:genres': '\ue022',
        'material:gesture': '\ue155',
        'material:gesture_select': '\uf657',
        'material:gif': '\ue908',
        'material:gif_2': '\uf40e',
        'material:gif_box': '\ue7a3',
        'material:girl': '\ueb68',
        'material:gite': '\ue58b',
        'material:glass_cup': '\uf6e3',
        'material:globe': '\ue64c',
        'material:globe_asia': '\uf799',
        'material:globe_book': '\uf3c9',
        'material:globe_location_pin': '\uf35d',
        'material:globe_uk': '\uf798',
        'material:glucose': '\ue4a0',
        'material:glyphs': '\uf8a3',
        'material:go_to_line': '\uf71d',
        'material:golf_course': '\ueb45',
        'material:gondola_lift': '\uf476',
        'material:google_home_devices': '\ue715',
        'material:google_tv_remote': '\uf129',
        'material:google_wifi': '\ue840',
        'material:gpp_bad': '\uf012',
        'material:gpp_maybe': '\uf014',
        'material:gradient': '\ue3e9',
        'material:grading': '\uea4f',
        'material:grain': '\ue3ea',
        'material:graph_1': '\uf3a0',
        'material:graph_2': '\uf39f',
        'material:graph_3': '\uf39e',
        'material:graph_4': '\uf39d',
        'material:graph_5': '\uf39c',
        'material:graph_6': '\uf39b',
        'material:graph_7': '\uf346',
        'material:graphic_eq': '\ue1b8',
        'material:grass': '\uf205',
        'material:grid_3x3': '\uf015',
        'material:grid_3x3_off': '\uf67c',
        'material:grid_4x4': '\uf016',
        'material:grid_goldenratio': '\uf017',
        'material:grid_guides': '\uf76f',
        'material:grid_off': '\ue3eb',
        'material:grid_on': '\ue3ec',
        'material:grid_view': '\ue9b0',
        'material:grocery': '\uef97',
        'material:group': '\ue7ef',
        'material:group_add': '\ue7f0',
        'material:group_off': '\ue747',
        'material:group_remove': '\ue7ad',
        'material:group_search': '\uf3ce',
        'material:group_work': '\ue886',
        'material:grouped_bar_chart': '\uf211',
        'material:groups': '\uf233',
        'material:groups_2': '\uf8df',
        'material:groups_3': '\uf8e0',
        'material:guardian': '\uf4c1',
        'material:gynecology': '\ue0f4',
        'material:h_mobiledata': '\uf018',
        'material:h_mobiledata_badge': '\uf7e0',
        'material:h_plus_mobiledata': '\uf019',
        'material:h_plus_mobiledata_badge': '\uf7df',
        'material:hail': '\ue9b1',
        'material:hallway': '\ue6f8',
        'material:hanami_dango': '\uf23f',
        'material:hand_bones': '\uf894',
        'material:hand_gesture': '\uef9c',
        'material:hand_gesture_off': '\uf3f3',
        'material:hand_meal': '\uf294',
        'material:hand_package': '\uf293',
        'material:handheld_controller': '\uf4c6',
        'material:handshake': '\uebcb',
        'material:handwriting_recognition': '\ueb02',
        'material:handyman': '\uf10b',
        'material:hangout_video': '\ue0c1',
        'material:hangout_video_off': '\ue0c2',
        'material:hard_disk': '\uf3da',
        'material:hard_drive': '\uf80e',
        'material:hard_drive_2': '\uf7a4',
        'material:hardware': '\uea59',
        'material:hd': '\ue052',
        'material:hdr_auto': '\uf01a',
        'material:hdr_auto_select': '\uf01b',
        'material:hdr_enhanced_select': '\uef51',
        'material:hdr_off': '\ue3ed',
        'material:hdr_off_select': '\uf01c',
        'material:hdr_on': '\ue3ee',
        'material:hdr_on_select': '\uf01d',
        'material:hdr_plus': '\uf01e',
        'material:hdr_plus_off': '\ue3ef',
        'material:hdr_strong': '\ue3f1',
        'material:hdr_weak': '\ue3f2',
        'material:head_mounted_device': '\uf4c5',
        'material:headphones': '\ue310',
        'material:headphones_battery': '\uf020',
        'material:headset_mic': '\ue311',
        'material:headset_off': '\ue33a',
        'material:healing': '\ue3f3',
        'material:health_and_beauty': '\uef9d',
        'material:health_and_safety': '\ue1d5',
        'material:health_cross': '\uf2c3',
        'material:health_metrics': '\uf6e2',
        'material:heap_snapshot_large': '\uf76e',
        'material:heap_snapshot_multiple': '\uf76d',
        'material:heap_snapshot_thumbnail': '\uf76c',
        'material:hearing': '\ue023',
        'material:hearing_aid': '\uf464',
        'material:hearing_aid_disabled': '\uf3b0',
        'material:hearing_aid_disabled_left': '\uf2ec',
        'material:hearing_aid_left': '\uf2ed',
        'material:hearing_disabled': '\uf104',
        'material:heart_broken': '\ueac2',
        'material:heart_check': '\uf60a',
        'material:heart_minus': '\uf883',
        'material:heart_plus': '\uf884',
        'material:heart_smile': '\uf292',
        'material:heat': '\uf537',
        'material:heat_pump': '\uec18',
        'material:heat_pump_balance': '\ue27e',
        'material:height': '\uea16',
        'material:helicopter': '\uf60c',
        'material:help': '\ue887',
        'material:help_center': '\uf1c0',
        'material:help_clinic': '\uf810',
        'material:hematology': '\ue0f6',
        'material:hevc': '\uf021',
        'material:hexagon': '\ueb39',
        'material:hide': '\uef9e',
        'material:hide_image': '\uf022',
        'material:hide_source': '\uf023',
        'material:high_chair': '\uf29a',
        'material:high_density': '\uf79c',
        'material:high_quality': '\ue024',
        'material:high_res': '\uf54b',
        'material:highlight': '\ue25f',
        'material:highlight_keyboard_focus': '\uf510',
        'material:highlight_mouse_cursor': '\uf511',
        'material:highlight_text_cursor': '\uf512',
        'material:highlighter_size_1': '\uf76b',
        'material:highlighter_size_2': '\uf76a',
        'material:highlighter_size_3': '\uf769',
        'material:highlighter_size_4': '\uf768',
        'material:highlighter_size_5': '\uf767',
        'material:hiking': '\ue50a',
        'material:history': '\ue28e',
        'material:history_2': '\uf3e6',
        'material:history_edu': '\uea3e',
        'material:history_off': '\uf4da',
        'material:history_toggle_off': '\uf17d',
        'material:hive': '\ueaa6',
        'material:hls': '\ueb8a',
        'material:hls_off': '\ueb8c',
        'material:holiday_village': '\ue58a',
        'material:home': '\ue88a',
        'material:home_and_garden': '\uef9f',
        'material:home_app_logo': '\ue295',
        'material:home_health': '\ue4b9',
        'material:home_improvement_and_tools': '\uefa0',
        'material:home_iot_device': '\ue283',
        'material:home_max': '\uf024',
        'material:home_max_dots': '\ue849',
        'material:home_mini': '\uf025',
        'material:home_pin': '\uf14d',
        'material:home_repair_service': '\uf100',
        'material:home_speaker': '\uf11c',
        'material:home_storage': '\uf86c',
        'material:home_work': '\uea09',
        'material:horizontal_distribute': '\ue014',
        'material:horizontal_rule': '\uf108',
        'material:horizontal_split': '\ue947',
        'material:host': '\uf3d9',
        'material:hot_tub': '\ueb46',
        'material:hotel': '\ue53a',
        'material:hotel_class': '\ue743',
        'material:hourglass': '\uebff',
        'material:hourglass_arrow_down': '\uf37e',
        'material:hourglass_arrow_up': '\uf37d',
        'material:hourglass_bottom': '\uea5c',
        'material:hourglass_disabled': '\uef53',
        'material:hourglass_empty': '\ue88b',
        'material:hourglass_full': '\ue88c',
        'material:hourglass_pause': '\uf38c',
        'material:hourglass_top': '\uea5b',
        'material:house': '\uea44',
        'material:house_siding': '\uf202',
        'material:house_with_shield': '\ue786',
        'material:houseboat': '\ue584',
        'material:household_supplies': '\uefa1',
        'material:hov': '\uf475',
        'material:how_to_reg': '\ue174',
        'material:how_to_vote': '\ue175',
        'material:hr_resting': '\uf6ba',
        'material:html': '\ueb7e',
        'material:http': '\ue902',
        'material:hub': '\ue9f4',
        'material:humerus': '\uf895',
        'material:humerus_alt': '\uf896',
        'material:humidity_high': '\uf163',
        'material:humidity_indoor': '\uf558',
        'material:humidity_low': '\uf164',
        'material:humidity_mid': '\uf165',
        'material:humidity_percentage': '\uf87e',
        'material:hvac': '\uf10e',
        'material:hvac_max_defrost': '\uf332',
        'material:ice_skating': '\ue50b',
        'material:icecream': '\uea69',
        'material:id_card': '\uf4ca',
        'material:identity_aware_proxy': '\ue2dd',
        'material:identity_platform': '\uebb7',
        'material:ifl': '\ue025',
        'material:iframe': '\uf71b',
        'material:iframe_off': '\uf71c',
        'material:image': '\ue251',
        'material:image_arrow_up': '\uf317',
        'material:image_aspect_ratio': '\ue3f5',
        'material:image_inset': '\uf247',
        'material:image_not_supported': '\uf116',
        'material:image_search': '\ue43f',
        'material:imagesearch_roller': '\ue9b4',
        'material:imagesmode': '\uefa2',
        'material:immunology': '\ue0fb',
        'material:import_contacts': '\ue0e0',
        'material:important_devices': '\ue912',
        'material:in_home_mode': '\ue833',
        'material:inactive_order': '\ue0fc',
        'material:inbox': '\ue156',
        'material:inbox_customize': '\uf859',
        'material:inbox_text': '\uf399',
        'material:inbox_text_asterisk': '\uf360',
        'material:inbox_text_person': '\uf35e',
        'material:inbox_text_share': '\uf35c',
        'material:incomplete_circle': '\ue79b',
        'material:indeterminate_check_box': '\ue909',
        'material:indeterminate_question_box': '\uf56d',
        'material:info': '\ue88e',
        'material:info_i': '\uf59b',
        'material:infrared': '\uf87c',
        'material:ink_eraser': '\ue6d0',
        'material:ink_eraser_off': '\ue7e3',
        'material:ink_highlighter': '\ue6d1',
        'material:ink_highlighter_move': '\uf524',
        'material:ink_marker': '\ue6d2',
        'material:ink_pen': '\ue6d3',
        'material:ink_selection': '\ue6d4',
        'material:inpatient': '\ue0fe',
        'material:input': '\ue890',
        'material:input_circle': '\uf71a',
        'material:insert_chart': '\ue24b',
        'material:insert_page_break': '\ueaca',
        'material:insert_text': '\uf827',
        'material:insights': '\uf092',
        'material:install_desktop': '\ueb71',
        'material:instant_mix': '\ue026',
        'material:integration_instructions': '\uef54',
        'material:interactive_space': '\uf7ff',
        'material:interests': '\ue7c8',
        'material:interpreter_mode': '\ue83b',
        'material:inventory': '\ue179',
        'material:inventory_2': '\ue1a1',
        'material:invert_colors': '\ue891',
        'material:invert_colors_off': '\ue0c4',
        'material:ios': '\ue027',
        'material:ios_share': '\ue6b8',
        'material:iron': '\ue583',
        'material:jamboard_kiosk': '\ue9b5',
        'material:japanese_curry': '\uf284',
        'material:japanese_flag': '\uf283',
        'material:javascript': '\ueb7c',
        'material:join': '\ueaeb',
        'material:join_inner': '\ueaf4',
        'material:join_left': '\ueaf2',
        'material:join_right': '\ueaea',
        'material:joystick': '\uf5ee',
        'material:jump_to_element': '\uf719',
        'material:kanji_alcohol': '\uf23e',
        'material:kayaking': '\ue50c',
        'material:kebab_dining': '\ue842',
        'material:keep': '\ue6aa',
        'material:keep_off': '\ue017',
        'material:keep_public': '\uf56f',
        'material:kettle': '\ue2b9',
        'material:key': '\ue73c',
        'material:key_off': '\ueb84',
        'material:key_vertical': '\uf51a',
        'material:key_visualizer': '\uf199',
        'material:keyboard': '\ue312',
        'material:keyboard_alt': '\uf028',
        'material:keyboard_arrow_down': '\ue313',
        'material:keyboard_arrow_left': '\ue314',
        'material:keyboard_arrow_right': '\ue315',
        'material:keyboard_arrow_up': '\ue316',
        'material:keyboard_backspace': '\ue317',
        'material:keyboard_capslock': '\ue318',
        'material:keyboard_capslock_badge': '\uf7de',
        'material:keyboard_command_key': '\ueae7',
        'material:keyboard_control_key': '\ueae6',
        'material:keyboard_double_arrow_down': '\uead0',
        'material:keyboard_double_arrow_left': '\ueac3',
        'material:keyboard_double_arrow_right': '\ueac9',
        'material:keyboard_double_arrow_up': '\ueacf',
        'material:keyboard_external_input': '\uf7dd',
        'material:keyboard_full': '\uf7dc',
        'material:keyboard_hide': '\ue31a',
        'material:keyboard_keys': '\uf67b',
        'material:keyboard_lock': '\uf492',
        'material:keyboard_lock_off': '\uf491',
        'material:keyboard_off': '\uf67a',
        'material:keyboard_onscreen': '\uf7db',
        'material:keyboard_option_key': '\ueae8',
        'material:keyboard_previous_language': '\uf7da',
        'material:keyboard_return': '\ue31b',
        'material:keyboard_tab': '\ue31c',
        'material:keyboard_tab_rtl': '\uec73',
        'material:kid_star': '\uf526',
        'material:king_bed': '\uea45',
        'material:kitchen': '\ueb47',
        'material:kitesurfing': '\ue50d',
        'material:lab_panel': '\ue103',
        'material:lab_profile': '\ue104',
        'material:lab_research': '\uf80b',
        'material:label': '\ue892',
        'material:label_important': '\ue937',
        'material:label_off': '\ue9b6',
        'material:labs': '\ue105',
        'material:lan': '\ueb2f',
        'material:landscape': '\ue3f7',
        'material:landscape_2': '\uf4c4',
        'material:landscape_2_edit': '\uf310',
        'material:landscape_2_off': '\uf4c3',
        'material:landslide': '\uebd7',
        'material:language': '\ue894',
        'material:language_chinese_array': '\uf766',
        'material:language_chinese_cangjie': '\uf765',
        'material:language_chinese_dayi': '\uf764',
        'material:language_chinese_pinyin': '\uf763',
        'material:language_chinese_quick': '\uf762',
        'material:language_chinese_wubi': '\uf761',
        'material:language_french': '\uf760',
        'material:language_gb_english': '\uf75f',
        'material:language_international': '\uf75e',
        'material:language_japanese_kana': '\uf513',
        'material:language_korean_latin': '\uf75d',
        'material:language_pinyin': '\uf75c',
        'material:language_spanish': '\uf5e9',
        'material:language_us': '\uf759',
        'material:language_us_colemak': '\uf75b',
        'material:language_us_dvorak': '\uf75a',
        'material:laps': '\uf6b9',
        'material:laptop_car': '\uf3cd',
        'material:laptop_chromebook': '\ue31f',
        'material:laptop_mac': '\ue320',
        'material:laptop_windows': '\ue321',
        'material:lasso_select': '\ueb03',
        'material:last_page': '\ue5dd',
        'material:laundry': '\ue2a8',
        'material:layers': '\ue53b',
        'material:layers_clear': '\ue53c',
        'material:lda': '\ue106',
        'material:leaderboard': '\uf20c',
        'material:leak_add': '\ue3f8',
        'material:leak_remove': '\ue3f9',
        'material:left_click': '\uf718',
        'material:left_panel_close': '\uf717',
        'material:left_panel_open': '\uf716',
        'material:legend_toggle': '\uf11b',
        'material:lens_blur': '\uf029',
        'material:letter_switch': '\uf758',
        'material:library_add': '\ue02e',
        'material:library_add_check': '\ue9b7',
        'material:library_books': '\ue02f',
        'material:library_music': '\ue030',
        'material:license': '\ueb04',
        'material:lift_to_talk': '\uefa3',
        'material:light': '\uf02a',
        'material:light_group': '\ue28b',
        'material:light_mode': '\ue518',
        'material:light_off': '\ue9b8',
        'material:lightbulb': '\ue0f0',
        'material:lightbulb_2': '\uf3e3',
        'material:lightbulb_circle': '\uebfe',
        'material:lightning_stand': '\uefa4',
        'material:line_axis': '\uea9a',
        'material:line_curve': '\uf757',
        'material:line_end': '\uf826',
        'material:line_end_arrow': '\uf81d',
        'material:line_end_arrow_notch': '\uf81c',
        'material:line_end_circle': '\uf81b',
        'material:line_end_diamond': '\uf81a',
        'material:line_end_square': '\uf819',
        'material:line_start': '\uf825',
        'material:line_start_arrow': '\uf818',
        'material:line_start_arrow_notch': '\uf817',
        'material:line_start_circle': '\uf816',
        'material:line_start_diamond': '\uf815',
        'material:line_start_square': '\uf814',
        'material:line_style': '\ue919',
        'material:line_weight': '\ue91a',
        'material:linear_scale': '\ue260',
        'material:link': '\ue157',
        'material:link_off': '\ue16f',
        'material:linked_camera': '\ue438',
        'material:linked_services': '\uf535',
        'material:liquor': '\uea60',
        'material:list': '\ue896',
        'material:list_alt': '\ue0ee',
        'material:list_alt_add': '\uf756',
        'material:list_alt_check': '\uf3de',
        'material:lists': '\ue9b9',
        'material:live_help': '\ue0c6',
        'material:live_tv': '\ue639',
        'material:living': '\uf02b',
        'material:local_activity': '\ue53f',
        'material:local_atm': '\ue53e',
        'material:local_bar': '\ue540',
        'material:local_cafe': '\ue541',
        'material:local_car_wash': '\ue542',
        'material:local_convenience_store': '\ue543',
        'material:local_drink': '\ue544',
        'material:local_fire_department': '\uef55',
        'material:local_florist': '\ue545',
        'material:local_gas_station': '\ue546',
        'material:local_hospital': '\ue548',
        'material:local_laundry_service': '\ue54a',
        'material:local_library': '\ue54b',
        'material:local_mall': '\ue54c',
        'material:local_parking': '\ue54f',
        'material:local_pharmacy': '\ue550',
        'material:local_pizza': '\ue552',
        'material:local_police': '\uef56',
        'material:local_post_office': '\ue554',
        'material:local_see': '\ue557',
        'material:local_shipping': '\ue558',
        'material:local_taxi': '\ue559',
        'material:location_automation': '\uf14f',
        'material:location_away': '\uf150',
        'material:location_chip': '\uf850',
        'material:location_city': '\ue7f1',
        'material:location_disabled': '\ue1b5',
        'material:location_home': '\uf152',
        'material:location_off': '\ue0c7',
        'material:location_searching': '\ue1b4',
        'material:lock': '\ue88d',
        'material:lock_clock': '\uef57',
        'material:lock_open': '\ue898',
        'material:lock_open_circle': '\uf361',
        'material:lock_open_right': '\uf656',
        'material:lock_person': '\uf8f3',
        'material:lock_reset': '\ueade',
        'material:login': '\uea77',
        'material:logo_dev': '\uead6',
        'material:logout': '\ue9ba',
        'material:looks': '\ue3fc',
        'material:looks_3': '\ue3fb',
        'material:looks_4': '\ue3fd',
        'material:looks_5': '\ue3fe',
        'material:looks_6': '\ue3ff',
        'material:looks_one': '\ue400',
        'material:looks_two': '\ue401',
        'material:loupe': '\ue402',
        'material:low_density': '\uf79b',
        'material:low_priority': '\ue16d',
        'material:lowercase': '\uf48a',
        'material:loyalty': '\ue89a',
        'material:lte_mobiledata': '\uf02c',
        'material:lte_mobiledata_badge': '\uf7d9',
        'material:lte_plus_mobiledata': '\uf02d',
        'material:lte_plus_mobiledata_badge': '\uf7d8',
        'material:luggage': '\uf235',
        'material:lunch_dining': '\uea61',
        'material:lyrics': '\uec0b',
        'material:macro_auto': '\uf6f2',
        'material:macro_off': '\uf8d2',
        'material:magic_button': '\uf136',
        'material:magic_exchange': '\uf7f4',
        'material:magic_tether': '\uf7d7',
        'material:magnification_large': '\uf83d',
        'material:magnification_small': '\uf83c',
        'material:magnify_docked': '\uf7d6',
        'material:magnify_fullscreen': '\uf7d5',
        'material:mail': '\ue0be',
        'material:mail_asterisk': '\ueef4',
        'material:mail_lock': '\uec0a',
        'material:mail_off': '\uf48b',
        'material:mail_shield': '\uf249',
        'material:male': '\ue58e',
        'material:man': '\ue4eb',
        'material:man_2': '\uf8e1',
        'material:man_3': '\uf8e2',
        'material:man_4': '\uf8e3',
        'material:manage_accounts': '\uf02e',
        'material:manage_history': '\uebe7',
        'material:manage_search': '\uf02f',
        'material:manga': '\uf5e3',
        'material:manufacturing': '\ue726',
        'material:map': '\ue55b',
        'material:map_pin_heart': '\uf298',
        'material:map_pin_review': '\uf297',
        'material:map_search': '\uf3ca',
        'material:maps_ugc': '\uef58',
        'material:margin': '\ue9bb',
        'material:mark_as_unread': '\ue9bc',
        'material:mark_chat_read': '\uf18b',
        'material:mark_chat_unread': '\uf189',
        'material:mark_email_read': '\uf18c',
        'material:mark_email_unread': '\uf18a',
        'material:mark_unread_chat_alt': '\ueb9d',
        'material:markdown': '\uf552',
        'material:markdown_copy': '\uf553',
        'material:markdown_paste': '\uf554',
        'material:markunread_mailbox': '\ue89b',
        'material:masked_transitions': '\ue72e',
        'material:masked_transitions_add': '\uf42b',
        'material:masks': '\uf218',
        'material:massage': '\uf2c2',
        'material:match_case': '\uf6f1',
        'material:match_case_off': '\uf36f',
        'material:match_word': '\uf6f0',
        'material:matter': '\ue907',
        'material:maximize': '\ue930',
        'material:meal_dinner': '\uf23d',
        'material:meal_lunch': '\uf23c',
        'material:measuring_tape': '\uf6af',
        'material:media_bluetooth_off': '\uf031',
        'material:media_bluetooth_on': '\uf032',
        'material:media_link': '\uf83f',
        'material:media_output': '\uf4f2',
        'material:media_output_off': '\uf4f3',
        'material:mediation': '\uefa7',
        'material:medical_information': '\uebed',
        'material:medical_mask': '\uf80a',
        'material:medical_services': '\uf109',
        'material:medication': '\uf033',
        'material:medication_liquid': '\uea87',
        'material:meeting_room': '\ueb4f',
        'material:memory': '\ue322',
        'material:memory_alt': '\uf7a3',
        'material:menstrual_health': '\uf6e1',
        'material:menu': '\ue5d2',
        'material:menu_book': '\uea19',
        'material:menu_book_2': '\uf291',
        'material:menu_open': '\ue9bd',
        'material:merge': '\ueb98',
        'material:merge_type': '\ue252',
        'material:metabolism': '\ue10b',
        'material:metro': '\uf474',
        'material:mfg_nest_yale_lock': '\uf11d',
        'material:mic': '\ue029',
        'material:mic_alert': '\uf392',
        'material:mic_double': '\uf5d1',
        'material:mic_external_off': '\uef59',
        'material:mic_external_on': '\uef5a',
        'material:mic_off': '\ue02b',
        'material:microbiology': '\ue10c',
        'material:microwave': '\uf204',
        'material:microwave_gen': '\ue847',
        'material:military_tech': '\uea3f',
        'material:mimo': '\ue9be',
        'material:mimo_disconnect': '\ue9bf',
        'material:mindfulness': '\uf6e0',
        'material:minimize': '\ue931',
        'material:minor_crash': '\uebf1',
        'material:mintmark': '\uefa9',
        'material:missed_video_call': '\ue073',
        'material:missing_controller': '\ue701',
        'material:mist': '\ue188',
        'material:mitre': '\uf547',
        'material:mixture_med': '\ue4c8',
        'material:mms': '\ue618',
        'material:mobile': '\ue0d4',
        'material:mobile_2': '\ue324',
        'material:mobile_3': '\ue325',
        'material:mobile_alert': '\ue0d6',
        'material:mobile_arrow_down': '\ue62a',
        'material:mobile_arrow_right': '\ue702',
        'material:mobile_arrow_up_right': '\ue1fe',
        'material:mobile_block': '\uef3f',
        'material:mobile_camera': '\uf2cf',
        'material:mobile_camera_front': '\ue3b1',
        'material:mobile_camera_rear': '\ue3b2',
        'material:mobile_cancel': '\ue0db',
        'material:mobile_cast': '\ue62b',
        'material:mobile_charge': '\uf19d',
        'material:mobile_chat': '\uf2ce',
        'material:mobile_check': '\ue200',
        'material:mobile_code': '\ue1b0',
        'material:mobile_dots': '\uf06b',
        'material:mobile_gear': '\ue0de',
        'material:mobile_hand': '\uf323',
        'material:mobile_hand_left': '\uf313',
        'material:mobile_hand_left_off': '\uf312',
        'material:mobile_hand_off': '\uf314',
        'material:mobile_info': '\ue8a5',
        'material:mobile_landscape': '\ue0d3',
        'material:mobile_layout': '\uf2bf',
        'material:mobile_lock_landscape': '\ue1be',
        'material:mobile_lock_portrait': '\ue0dc',
        'material:mobile_loupe': '\uf322',
        'material:mobile_menu': '\ue8bc',
        'material:mobile_off': '\ue201',
        'material:mobile_question': '\ue339',
        'material:mobile_rotate': '\ue1c1',
        'material:mobile_rotate_lock': '\ue1c0',
        'material:mobile_screensaver': '\uf321',
        'material:mobile_sensor_hi': '\uf005',
        'material:mobile_sensor_lo': '\uf006',
        'material:mobile_share': '\ue0e7',
        'material:mobile_share_stack': '\ue9c5',
        'material:mobile_sound': '\ue0dd',
        'material:mobile_sound_2': '\uf318',
        'material:mobile_sound_off': '\uf2e9',
        'material:mobile_speaker': '\uf320',
        'material:mobile_text': '\uef39',
        'material:mobile_text_2': '\uefda',
        'material:mobile_theft': '\uf2a9',
        'material:mobile_ticket': '\uf217',
        'material:mobile_vibrate': '\ue62d',
        'material:mobile_wrench': '\uf2b0',
        'material:mobiledata_off': '\uf034',
        'material:mode_comment': '\ue253',
        'material:mode_cool': '\uf166',
        'material:mode_cool_off': '\uf167',
        'material:mode_dual': '\uf557',
        'material:mode_fan': '\uf168',
        'material:mode_fan_off': '\uec17',
        'material:mode_heat': '\uf16a',
        'material:mode_heat_cool': '\uf16b',
        'material:mode_heat_off': '\uf16d',
        'material:mode_of_travel': '\ue7ce',
        'material:mode_off_on': '\uf16f',
        'material:mode_standby': '\uf037',
        'material:model_training': '\uf0cf',
        'material:modeling': '\uf3aa',
        'material:monetization_on': '\ue263',
        'material:money': '\ue57d',
        'material:money_bag': '\uf3ee',
        'material:money_off': '\ue25c',
        'material:money_range': '\uf245',
        'material:monitor': '\uef5b',
        'material:monitor_heart': '\ueaa2',
        'material:monitor_weight': '\uf039',
        'material:monitor_weight_gain': '\uf6df',
        'material:monitor_weight_loss': '\uf6de',
        'material:monitoring': '\uf190',
        'material:monochrome_photos': '\ue403',
        'material:monorail': '\uf473',
        'material:mood': '\ue24e',
        'material:mood_bad': '\ue7f3',
        'material:moon_stars': '\uf34f',
        'material:mop': '\ue28d',
        'material:moped': '\uea72',
        'material:moped_package': '\uf28b',
        'material:more': '\ue619',
        'material:more_down': '\uf196',
        'material:more_horiz': '\ue5d3',
        'material:more_time': '\uea5d',
        'material:more_up': '\uf197',
        'material:more_vert': '\ue5d4',
        'material:mosque': '\ueab2',
        'material:motion_blur': '\uf0d0',
        'material:motion_mode': '\uf842',
        'material:motion_photos_auto': '\uf03a',
        'material:motion_photos_off': '\ue9c0',
        'material:motion_photos_on': '\ue9c1',
        'material:motion_photos_paused': '\ue9c2',
        'material:motion_play': '\uf40b',
        'material:motion_sensor_active': '\ue792',
        'material:motion_sensor_alert': '\ue784',
        'material:motion_sensor_idle': '\ue783',
        'material:motion_sensor_urgent': '\ue78e',
        'material:motorcycle': '\ue91b',
        'material:mountain_flag': '\uf5e2',
        'material:mountain_steam': '\uf282',
        'material:mouse': '\ue323',
        'material:mouse_lock': '\uf490',
        'material:mouse_lock_off': '\uf48f',
        'material:move': '\ue740',
        'material:move_down': '\ueb61',
        'material:move_group': '\uf715',
        'material:move_item': '\uf1ff',
        'material:move_location': '\ue741',
        'material:move_selection_down': '\uf714',
        'material:move_selection_left': '\uf713',
        'material:move_selection_right': '\uf712',
        'material:move_selection_up': '\uf711',
        'material:move_to_inbox': '\ue168',
        'material:move_up': '\ueb64',
        'material:moved_location': '\ue594',
        'material:movie': '\ue02c',
        'material:movie_edit': '\uf840',
        'material:movie_filter': '\ue43a',
        'material:movie_info': '\ue02d',
        'material:movie_off': '\uf499',
        'material:movie_speaker': '\uf2a3',
        'material:moving': '\ue501',
        'material:moving_beds': '\ue73d',
        'material:moving_ministry': '\ue73e',
        'material:mp': '\ue9c3',
        'material:multicooker': '\ue293',
        'material:multiline_chart': '\ue6df',
        'material:multimodal_hand_eye': '\uf41b',
        'material:multiple_airports': '\uefab',
        'material:multiple_stop': '\uf1b9',
        'material:museum': '\uea36',
        'material:music_cast': '\ueb1a',
        'material:music_history': '\uf2c1',
        'material:music_note': '\ue3a1',
        'material:music_note_add': '\uf391',
        'material:music_off': '\ue440',
        'material:music_video': '\ue063',
        'material:my_location': '\ue1b3',
        'material:mystery': '\uf5e1',
        'material:nat': '\uef5c',
        'material:nature': '\ue406',
        'material:nature_people': '\ue407',
        'material:navigation': '\ue55d',
        'material:near_me': '\ue569',
        'material:near_me_disabled': '\uf1ef',
        'material:nearby': '\ue6b7',
        'material:nearby_error': '\uf03b',
        'material:nearby_off': '\uf03c',
        'material:nephrology': '\ue10d',
        'material:nest_audio': '\uebbf',
        'material:nest_cam_floodlight': '\uf8b7',
        'material:nest_cam_indoor': '\uf11e',
        'material:nest_cam_iq': '\uf11f',
        'material:nest_cam_iq_outdoor': '\uf120',
        'material:nest_cam_magnet_mount': '\uf8b8',
        'material:nest_cam_outdoor': '\uf121',
        'material:nest_cam_stand': '\uf8b9',
        'material:nest_cam_wall_mount': '\uf8ba',
        'material:nest_cam_wired_stand': '\uec16',
        'material:nest_clock_farsight_analog': '\uf8bb',
        'material:nest_clock_farsight_digital': '\uf8bc',
        'material:nest_connect': '\uf122',
        'material:nest_detect': '\uf123',
        'material:nest_display': '\uf124',
        'material:nest_display_max': '\uf125',
        'material:nest_doorbell_visitor': '\uf8bd',
        'material:nest_eco_leaf': '\uf8be',
        'material:nest_farsight_cool': '\uf27d',
        'material:nest_farsight_dual': '\uf27c',
        'material:nest_farsight_eco': '\uf27b',
        'material:nest_farsight_heat': '\uf27a',
        'material:nest_farsight_seasonal': '\uf279',
        'material:nest_farsight_weather': '\uf8bf',
        'material:nest_found_savings': '\uf8c0',
        'material:nest_heat_link_e': '\uf126',
        'material:nest_heat_link_gen_3': '\uf127',
        'material:nest_hello_doorbell': '\ue82c',
        'material:nest_mini': '\ue789',
        'material:nest_multi_room': '\uf8c2',
        'material:nest_protect': '\ue68e',
        'material:nest_remote_comfort_sensor': '\uf12a',
        'material:nest_secure_alarm': '\uf12b',
        'material:nest_sunblock': '\uf8c3',
        'material:nest_tag': '\ue28c',
        'material:nest_thermostat': '\ue68f',
        'material:nest_thermostat_e_eu': '\uf12d',
        'material:nest_thermostat_gen_3': '\uf12e',
        'material:nest_thermostat_sensor': '\uf12f',
        'material:nest_thermostat_sensor_eu': '\uf130',
        'material:nest_thermostat_zirconium_eu': '\uf131',
        'material:nest_true_radiant': '\uf8c4',
        'material:nest_wake_on_approach': '\uf8c5',
        'material:nest_wake_on_press': '\uf8c6',
        'material:nest_wifi_gale': '\uf132',
        'material:nest_wifi_point': '\ue83f',
        'material:nest_wifi_pro': '\uf56b',
        'material:nest_wifi_pro_2': '\uf56a',
        'material:nest_wifi_router': '\ue841',
        'material:network_cell': '\ue1b9',
        'material:network_check': '\ue640',
        'material:network_intel_node': '\uf371',
        'material:network_intelligence': '\uefac',
        'material:network_intelligence_history': '\uf5f6',
        'material:network_intelligence_update': '\uf5f5',
        'material:network_locked': '\ue61a',
        'material:network_manage': '\uf7ab',
        'material:network_node': '\uf56e',
        'material:network_ping': '\uebca',
        'material:network_wifi': '\ue1ba',
        'material:network_wifi_1_bar': '\uebe4',
        'material:network_wifi_1_bar_locked': '\uf58f',
        'material:network_wifi_2_bar': '\uebd6',
        'material:network_wifi_2_bar_locked': '\uf58e',
        'material:network_wifi_3_bar': '\uebe1',
        'material:network_wifi_3_bar_locked': '\uf58d',
        'material:network_wifi_locked': '\uf532',
        'material:neurology': '\ue10e',
        'material:new_label': '\ue609',
        'material:new_window': '\uf710',
        'material:news': '\ue032',
        'material:newsmode': '\uefad',
        'material:newspaper': '\ueb81',
        'material:newsstand': '\ue9c4',
        'material:next_plan': '\uef5d',
        'material:next_week': '\ue16a',
        'material:nfc': '\ue1bb',
        'material:nfc_off': '\uf369',
        'material:night_shelter': '\uf1f1',
        'material:night_sight_auto': '\uf1d7',
        'material:night_sight_auto_off': '\uf1f9',
        'material:night_sight_max': '\uf6c3',
        'material:nightlife': '\uea62',
        'material:nightlight': '\uef5e',
        'material:no_accounts': '\uf03e',
        'material:no_adult_content': '\uf8fe',
        'material:no_backpack': '\uf237',
        'material:no_crash': '\uebf0',
        'material:no_drinks': '\uf1a5',
        'material:no_encryption': '\ue641',
        'material:no_flash': '\uf1a6',
        'material:no_food': '\uf1a7',
        'material:no_luggage': '\uf23b',
        'material:no_meals': '\uf1d6',
        'material:no_meeting_room': '\ueb4e',
        'material:no_photography': '\uf1a8',
        'material:no_sim': '\ue0cc',
        'material:no_sound': '\ue710',
        'material:no_stroller': '\uf1af',
        'material:no_transfer': '\uf1d5',
        'material:noise_aware': '\uebec',
        'material:noise_control_off': '\uebf3',
        'material:noise_control_on': '\uf8a8',
        'material:nordic_walking': '\ue50e',
        'material:north': '\uf1e0',
        'material:north_east': '\uf1e1',
        'material:north_west': '\uf1e2',
        'material:not_accessible': '\uf0fe',
        'material:not_accessible_forward': '\uf54a',
        'material:not_listed_location': '\ue575',
        'material:not_started': '\uf0d1',
        'material:note': '\ue06f',
        'material:note_add': '\ue89c',
        'material:note_alt': '\uf040',
        'material:note_stack': '\uf562',
        'material:note_stack_add': '\uf563',
        'material:notes': '\ue26c',
        'material:notification_add': '\ue399',
        'material:notification_important': '\ue004',
        'material:notification_multiple': '\ue6c2',
        'material:notification_settings': '\uf367',
        'material:notification_sound': '\uf353',
        'material:notifications': '\ue7f4',
        'material:notifications_active': '\ue7f7',
        'material:notifications_off': '\ue7f6',
        'material:notifications_paused': '\ue7f8',
        'material:notifications_unread': '\uf4fe',
        'material:numbers': '\ueac7',
        'material:nutrition': '\ue110',
        'material:ods': '\ue6e8',
        'material:odt': '\ue6e9',
        'material:offline_bolt': '\ue932',
        'material:offline_pin': '\ue90a',
        'material:offline_pin_off': '\uf4d0',
        'material:oil_barrel': '\uec15',
        'material:okonomiyaki': '\uf281',
        'material:on_device_training': '\uebfd',
        'material:on_hub_device': '\ue6c3',
        'material:oncology': '\ue114',
        'material:online_prediction': '\uf0eb',
        'material:onsen': '\uf6f8',
        'material:opacity': '\ue91c',
        'material:open_in_browser': '\ue89d',
        'material:open_in_full': '\uf1ce',
        'material:open_in_new': '\ue895',
        'material:open_in_new_down': '\uf70f',
        'material:open_in_new_off': '\ue4f6',
        'material:open_jam': '\uefae',
        'material:open_run': '\uf4b7',
        'material:open_with': '\ue89f',
        'material:ophthalmology': '\ue115',
        'material:oral_disease': '\ue116',
        'material:orbit': '\uf426',
        'material:order_approve': '\uf812',
        'material:order_play': '\uf811',
        'material:orders': '\ueb14',
        'material:orthopedics': '\uf897',
        'material:other_admission': '\ue47b',
        'material:other_houses': '\ue58c',
        'material:outbound': '\ue1ca',
        'material:outbox': '\uef5f',
        'material:outbox_alt': '\ueb17',
        'material:outdoor_garden': '\ue205',
        'material:outdoor_grill': '\uea47',
        'material:outgoing_mail': '\uf0d2',
        'material:outlet': '\uf1d4',
        'material:outpatient': '\ue118',
        'material:outpatient_med': '\ue119',
        'material:output': '\uebbe',
        'material:output_circle': '\uf70e',
        'material:oven': '\ue9c7',
        'material:oven_gen': '\ue843',
        'material:overview': '\ue4a7',
        'material:overview_key': '\uf7d4',
        'material:owl': '\uf3b4',
        'material:oxygen_saturation': '\ue4de',
        'material:p2p': '\uf52a',
        'material:pace': '\uf6b8',
        'material:pacemaker': '\ue656',
        'material:package': '\ue48f',
        'material:package_2': '\uf569',
        'material:padding': '\ue9c8',
        'material:padel': '\uf2a7',
        'material:page_control': '\ue731',
        'material:page_footer': '\uf383',
        'material:page_header': '\uf384',
        'material:page_info': '\uf614',
        'material:page_menu_ios': '\ueefb',
        'material:pageless': '\uf509',
        'material:pages': '\ue7f9',
        'material:pageview': '\ue8a0',
        'material:paid': '\uf041',
        'material:palette': '\ue3b7',
        'material:pallet': '\uf86a',
        'material:pan_tool': '\ue925',
        'material:pan_tool_alt': '\uebb9',
        'material:pan_zoom': '\uf655',
        'material:panorama': '\ue40b',
        'material:panorama_fish_eye': '\ue40c',
        'material:panorama_horizontal': '\ue40d',
        'material:panorama_photosphere': '\ue9c9',
        'material:panorama_vertical': '\ue40e',
        'material:panorama_wide_angle': '\ue40f',
        'material:paragliding': '\ue50f',
        'material:parent_child_dining': '\uf22d',
        'material:park': '\uea63',
        'material:parking_meter': '\uf28a',
        'material:parking_sign': '\uf289',
        'material:parking_valet': '\uf288',
        'material:partly_cloudy_day': '\uf172',
        'material:partly_cloudy_night': '\uea46',
        'material:partner_exchange': '\uf7f9',
        'material:partner_heart': '\uef2e',
        'material:partner_reports': '\uefaf',
        'material:party_mode': '\ue7fa',
        'material:passkey': '\uf87f',
        'material:password': '\uf042',
        'material:password_2': '\uf4a9',
        'material:password_2_off': '\uf4a8',
        'material:patient_list': '\ue653',
        'material:pattern': '\uf043',
        'material:pause': '\ue034',
        'material:pause_circle': '\ue035',
        'material:pause_presentation': '\ue0ea',
        'material:payment_arrow_down': '\uf2c0',
        'material:payment_card': '\uf2a1',
        'material:payments': '\uef63',
        'material:pedal_bike': '\ueb29',
        'material:pediatrics': '\ue11d',
        'material:pen_size_1': '\uf755',
        'material:pen_size_2': '\uf754',
        'material:pen_size_3': '\uf753',
        'material:pen_size_4': '\uf752',
        'material:pen_size_5': '\uf751',
        'material:pending': '\uef64',
        'material:pending_actions': '\uf1bb',
        'material:pentagon': '\ueb50',
        'material:percent_discount': '\uf244',
        'material:performance_max': '\ue51a',
        'material:pergola': '\ue203',
        'material:perm_camera_mic': '\ue8a2',
        'material:perm_contact_calendar': '\ue8a3',
        'material:perm_data_setting': '\ue8a4',
        'material:perm_media': '\ue8a7',
        'material:perm_phone_msg': '\ue8a8',
        'material:perm_scan_wifi': '\ue8a9',
        'material:person': '\ue7fd',
        'material:person_2': '\uf8e4',
        'material:person_3': '\uf8e5',
        'material:person_4': '\uf8e6',
        'material:person_add': '\ue7fe',
        'material:person_add_disabled': '\ue9cb',
        'material:person_alert': '\uf567',
        'material:person_apron': '\uf5a3',
        'material:person_book': '\uf5e8',
        'material:person_cancel': '\uf566',
        'material:person_celebrate': '\uf7fe',
        'material:person_check': '\uf565',
        'material:person_edit': '\uf4fa',
        'material:person_heart': '\uf290',
        'material:person_off': '\ue510',
        'material:person_pin': '\ue55a',
        'material:person_pin_circle': '\ue56a',
        'material:person_play': '\uf7fd',
        'material:person_raised_hand': '\uf59a',
        'material:person_remove': '\uef66',
        'material:person_search': '\uf106',
        'material:person_shield': '\ue384',
        'material:personal_bag': '\ueb0e',
        'material:personal_bag_off': '\ueb0f',
        'material:personal_bag_question': '\ueb10',
        'material:personal_injury': '\ue6da',
        'material:personal_places': '\ue703',
        'material:pest_control': '\uf0fa',
        'material:pest_control_rodent': '\uf0fd',
        'material:pet_supplies': '\uefb1',
        'material:pets': '\ue91d',
        'material:phishing': '\uead7',
        'material:phone_bluetooth_speaker': '\ue61b',
        'material:phone_callback': '\ue649',
        'material:phone_disabled': '\ue9cc',
        'material:phone_enabled': '\ue9cd',
        'material:phone_forwarded': '\ue61c',
        'material:phone_in_talk': '\ue61d',
        'material:phone_locked': '\ue61e',
        'material:phone_missed': '\ue61f',
        'material:phone_paused': '\ue620',
        'material:photo': '\ue410',
        'material:photo_album': '\ue411',
        'material:photo_auto_merge': '\uf530',
        'material:photo_camera': '\ue3b0',
        'material:photo_camera_back': '\uef68',
        'material:photo_camera_front': '\uef69',
        'material:photo_filter': '\ue43b',
        'material:photo_frame': '\uf0d9',
        'material:photo_library': '\ue413',
        'material:photo_prints': '\uefb2',
        'material:photo_size_select_large': '\ue433',
        'material:photo_size_select_small': '\ue434',
        'material:php': '\ueb8f',
        'material:physical_therapy': '\ue11e',
        'material:piano': '\ue521',
        'material:piano_off': '\ue520',
        'material:pickleball': '\uf2a6',
        'material:picture_as_pdf': '\ue415',
        'material:picture_in_picture': '\ue8aa',
        'material:picture_in_picture_alt': '\ue911',
        'material:picture_in_picture_center': '\uf550',
        'material:picture_in_picture_large': '\uf54f',
        'material:picture_in_picture_medium': '\uf54e',
        'material:picture_in_picture_mobile': '\uf517',
        'material:picture_in_picture_off': '\uf52f',
        'material:picture_in_picture_small': '\uf54d',
        'material:pie_chart': '\ue6c4',
        'material:pill': '\ue11f',
        'material:pill_off': '\uf809',
        'material:pin': '\uf045',
        'material:pin_drop': '\ue55e',
        'material:pin_end': '\ue767',
        'material:pin_invoke': '\ue763',
        'material:pinboard': '\uf3ab',
        'material:pinboard_unread': '\uf3ac',
        'material:pinch': '\ueb38',
        'material:pinch_zoom_in': '\uf1fa',
        'material:pinch_zoom_out': '\uf1fb',
        'material:pip': '\uf64d',
        'material:pip_exit': '\uf70d',
        'material:pivot_table_chart': '\ue9ce',
        'material:place': '\ue0c8',
        'material:place_item': '\uf1f0',
        'material:plagiarism': '\uea5a',
        'material:plane_contrails': '\uf2ac',
        'material:planet': '\uf387',
        'material:planner_banner_ad_pt': '\ue692',
        'material:planner_review': '\ue694',
        'material:play_arrow': '\ue037',
        'material:play_circle': '\ue038',
        'material:play_disabled': '\uef6a',
        'material:play_for_work': '\ue906',
        'material:play_lesson': '\uf047',
        'material:play_pause': '\uf137',
        'material:play_shapes': '\uf7fc',
        'material:playground': '\uf28e',
        'material:playground_2': '\uf28f',
        'material:playing_cards': '\uf5dc',
        'material:playlist_add': '\ue03b',
        'material:playlist_add_check': '\ue065',
        'material:playlist_add_check_circle': '\ue7e6',
        'material:playlist_add_circle': '\ue7e5',
        'material:playlist_play': '\ue05f',
        'material:playlist_remove': '\ueb80',
        'material:plug_connect': '\uf35a',
        'material:plumbing': '\uf107',
        'material:podcasts': '\uf048',
        'material:podiatry': '\ue120',
        'material:podium': '\uf7fb',
        'material:point_of_sale': '\uf17e',
        'material:point_scan': '\uf70c',
        'material:poker_chip': '\uf49b',
        'material:policy': '\uea17',
        'material:policy_alert': '\uf407',
        'material:polyline': '\uebbb',
        'material:polymer': '\ue8ab',
        'material:pool': '\ueb48',
        'material:position_bottom_left': '\uf70b',
        'material:position_bottom_right': '\uf70a',
        'material:position_top_right': '\uf709',
        'material:post': '\ue705',
        'material:post_add': '\uea20',
        'material:potted_plant': '\uf8aa',
        'material:power': '\ue63c',
        'material:power_input': '\ue336',
        'material:power_off': '\ue646',
        'material:power_settings_circle': '\uf418',
        'material:power_settings_new': '\ue8ac',
        'material:prayer_times': '\uf838',
        'material:precision_manufacturing': '\uf049',
        'material:pregnancy': '\ue91e',
        'material:preliminary': '\ue7d8',
        'material:prescriptions': '\ue121',
        'material:present_to_all': '\ue0df',
        'material:preview': '\uf1c5',
        'material:preview_off': '\uf7af',
        'material:price_change': '\uf04a',
        'material:price_check': '\uf04b',
        'material:print': '\ue555',
        'material:print_add': '\uf7a2',
        'material:print_connect': '\uf7a1',
        'material:print_disabled': '\ue9cf',
        'material:print_error': '\uf7a0',
        'material:print_lock': '\uf651',
        'material:priority': '\ue19f',
        'material:priority_high': '\ue645',
        'material:privacy': '\uf148',
        'material:privacy_tip': '\uf0dc',
        'material:private_connectivity': '\ue744',
        'material:problem': '\ue122',
        'material:procedure': '\ue651',
        'material:process_chart': '\uf855',
        'material:production_quantity_limits': '\ue1d1',
        'material:productivity': '\ue296',
        'material:progress_activity': '\ue9d0',
        'material:prompt_suggestion': '\uf4f6',
        'material:propane': '\uec14',
        'material:propane_tank': '\uec13',
        'material:psychiatry': '\ue123',
        'material:psychology': '\uea4a',
        'material:psychology_alt': '\uf8ea',
        'material:public': '\ue80b',
        'material:public_off': '\uf1ca',
        'material:publish': '\ue255',
        'material:published_with_changes': '\uf232',
        'material:pulmonology': '\ue124',
        'material:pulse_alert': '\uf501',
        'material:punch_clock': '\ueaa8',
        'material:push_pin': '\uf10d',
        'material:qr_code': '\uef6b',
        'material:qr_code_2': '\ue00a',
        'material:qr_code_2_add': '\uf658',
        'material:qr_code_scanner': '\uf206',
        'material:query_stats': '\ue4fc',
        'material:question_exchange': '\uf7f3',
        'material:question_mark': '\ueb8b',
        'material:queue_music': '\ue03d',
        'material:queue_play_next': '\ue066',
        'material:quick_phrases': '\ue7d1',
        'material:quick_reference': '\ue46e',
        'material:quick_reference_all': '\uf801',
        'material:quick_reorder': '\ueb15',
        'material:quickreply': '\uef6c',
        'material:quiz': '\uf04c',
        'material:r_mobiledata': '\uf04d',
        'material:radar': '\uf04e',
        'material:radio': '\ue03e',
        'material:radio_button_checked': '\ue837',
        'material:radio_button_partial': '\uf560',
        'material:radio_button_unchecked': '\ue836',
        'material:radiology': '\ue125',
        'material:railway_alert': '\ue9d1',
        'material:railway_alert_2': '\uf461',
        'material:rainy': '\uf176',
        'material:rainy_heavy': '\uf61f',
        'material:rainy_light': '\uf61e',
        'material:rainy_snow': '\uf61d',
        'material:ramen_dining': '\uea64',
        'material:ramp_left': '\ueb9c',
        'material:ramp_right': '\ueb96',
        'material:range_hood': '\ue1ea',
        'material:rate_review': '\ue560',
        'material:rate_review_rtl': '\ue706',
        'material:raven': '\uf555',
        'material:raw_off': '\uf04f',
        'material:raw_on': '\uf050',
        'material:read_more': '\uef6d',
        'material:readiness_score': '\uf6dd',
        'material:real_estate_agent': '\ue73a',
        'material:rear_camera': '\uf6c2',
        'material:rebase': '\uf845',
        'material:rebase_edit': '\uf846',
        'material:receipt': '\ue8b0',
        'material:receipt_long': '\uef6e',
        'material:receipt_long_off': '\uf40a',
        'material:recent_actors': '\ue03f',
        'material:recent_patient': '\uf808',
        'material:recenter': '\uf4c0',
        'material:recommend': '\ue9d2',
        'material:record_voice_over': '\ue91f',
        'material:rectangle': '\ueb54',
        'material:recycling': '\ue760',
        'material:redeem': '\ue8b1',
        'material:redo': '\ue15a',
        'material:reduce_capacity': '\uf21c',
        'material:refresh': '\ue5d5',
        'material:regular_expression': '\uf750',
        'material:relax': '\uf6dc',
        'material:release_alert': '\uf654',
        'material:remember_me': '\uf051',
        'material:reminder': '\ue695',
        'material:remote_gen': '\ue83e',
        'material:remove': '\ue15b',
        'material:remove_done': '\ue9d3',
        'material:remove_from_queue': '\ue067',
        'material:remove_moderator': '\ue9d4',
        'material:remove_road': '\uebfc',
        'material:remove_selection': '\ue9d5',
        'material:remove_shopping_cart': '\ue928',
        'material:reopen_window': '\uf708',
        'material:reorder': '\ue8fe',
        'material:repartition': '\uf8e8',
        'material:repeat': '\ue040',
        'material:repeat_on': '\ue9d6',
        'material:repeat_one': '\ue041',
        'material:repeat_one_on': '\ue9d7',
        'material:replace_audio': '\uf451',
        'material:replace_image': '\uf450',
        'material:replace_video': '\uf44f',
        'material:replay': '\ue042',
        'material:replay_10': '\ue059',
        'material:replay_30': '\ue05a',
        'material:replay_5': '\ue05b',
        'material:replay_circle_filled': '\ue9d8',
        'material:reply': '\ue15e',
        'material:reply_all': '\ue15f',
        'material:report': '\ue160',
        'material:report_off': '\ue170',
        'material:request_page': '\uf22c',
        'material:request_quote': '\uf1b6',
        'material:reset_brightness': '\uf482',
        'material:reset_exposure': '\uf266',
        'material:reset_focus': '\uf481',
        'material:reset_image': '\uf824',
        'material:reset_iso': '\uf480',
        'material:reset_settings': '\uf47f',
        'material:reset_shadow': '\uf47e',
        'material:reset_shutter_speed': '\uf47d',
        'material:reset_tv': '\ue9d9',
        'material:reset_white_balance': '\uf47c',
        'material:reset_wrench': '\uf56c',
        'material:resize': '\uf707',
        'material:respiratory_rate': '\ue127',
        'material:responsive_layout': '\ue9da',
        'material:rest_area': '\uf22a',
        'material:restart_alt': '\uf053',
        'material:restaurant': '\ue56c',
        'material:restaurant_menu': '\ue556',
        'material:restore_from_trash': '\ue938',
        'material:restore_page': '\ue929',
        'material:resume': '\uf7d0',
        'material:reviews': '\uf054',
        'material:rewarded_ads': '\uefb6',
        'material:rheumatology': '\ue128',
        'material:rib_cage': '\uf898',
        'material:rice_bowl': '\uf1f5',
        'material:right_click': '\uf706',
        'material:right_panel_close': '\uf705',
        'material:right_panel_open': '\uf704',
        'material:ring_volume': '\ue0d1',
        'material:ripples': '\ue9db',
        'material:road': '\uf472',
        'material:robot': '\uf882',
        'material:robot_2': '\uf5d0',
        'material:rocket': '\ueba5',
        'material:rocket_launch': '\ueb9b',
        'material:roller_shades': '\uec12',
        'material:roller_shades_closed': '\uec11',
        'material:roller_skating': '\uebcd',
        'material:roofing': '\uf201',
        'material:room_preferences': '\uf1b8',
        'material:room_service': '\ueb49',
        'material:rotate_90_degrees_ccw': '\ue418',
        'material:rotate_90_degrees_cw': '\ueaab',
        'material:rotate_auto': '\uf417',
        'material:rotate_left': '\ue419',
        'material:rotate_right': '\ue41a',
        'material:roundabout_left': '\ueb99',
        'material:roundabout_right': '\ueba3',
        'material:rounded_corner': '\ue920',
        'material:route': '\ueacd',
        'material:router': '\ue328',
        'material:router_off': '\uf2f4',
        'material:routine': '\ue20c',
        'material:rowing': '\ue921',
        'material:rss_feed': '\ue0e5',
        'material:rsvp': '\uf055',
        'material:rtt': '\ue9ad',
        'material:rubric': '\ueb27',
        'material:rule': '\uf1c2',
        'material:rule_folder': '\uf1c9',
        'material:rule_settings': '\uf64c',
        'material:run_circle': '\uef6f',
        'material:running_with_errors': '\ue51d',
        'material:rv_hookup': '\ue642',
        'material:safety_check': '\uebef',
        'material:safety_check_off': '\uf59d',
        'material:safety_divider': '\ue1cc',
        'material:sailing': '\ue502',
        'material:salinity': '\uf876',
        'material:sanitizer': '\uf21d',
        'material:satellite': '\ue562',
        'material:satellite_alt': '\ueb3a',
        'material:sauna': '\uf6f7',
        'material:save': '\ue161',
        'material:save_as': '\ueb60',
        'material:save_clock': '\uf398',
        'material:saved_search': '\uea11',
        'material:savings': '\ue2eb',
        'material:scale': '\ueb5f',
        'material:scan': '\uf74e',
        'material:scan_delete': '\uf74f',
        'material:scanner': '\ue329',
        'material:scatter_plot': '\ue268',
        'material:scene': '\ue2a7',
        'material:schedule': '\ue192',
        'material:schedule_send': '\uea0a',
        'material:schema': '\ue4fd',
        'material:school': '\ue80c',
        'material:science': '\uea4b',
        'material:science_off': '\uf542',
        'material:scooter': '\uf471',
        'material:score': '\ue269',
        'material:scoreboard': '\uebd0',
        'material:screen_record': '\uf679',
        'material:screen_rotation_alt': '\uebee',
        'material:screen_rotation_up': '\uf678',
        'material:screen_search_desktop': '\uef70',
        'material:screen_share': '\ue0e2',
        'material:screenshot': '\uf056',
        'material:screenshot_frame': '\uf677',
        'material:screenshot_frame_2': '\uf374',
        'material:screenshot_keyboard': '\uf7d3',
        'material:screenshot_monitor': '\uec08',
        'material:screenshot_region': '\uf7d2',
        'material:screenshot_tablet': '\uf697',
        'material:script': '\uf45f',
        'material:scrollable_header': '\ue9dc',
        'material:scuba_diving': '\uebce',
        'material:sd': '\ue9dd',
        'material:sd_card': '\ue1c2',
        'material:sd_card_alert': '\ue624',
        'material:sdk': '\ue720',
        'material:search': '\ue8b6',
        'material:search_activity': '\uf3e5',
        'material:search_check': '\uf800',
        'material:search_check_2': '\uf469',
        'material:search_gear': '\ueefa',
        'material:search_hands_free': '\ue696',
        'material:search_insights': '\uf4bc',
        'material:search_off': '\uea76',
        'material:seat_cool_left': '\uf331',
        'material:seat_cool_right': '\uf330',
        'material:seat_heat_left': '\uf32f',
        'material:seat_heat_right': '\uf32e',
        'material:seat_vent_left': '\uf32d',
        'material:seat_vent_right': '\uf32c',
        'material:security': '\ue32a',
        'material:security_key': '\uf503',
        'material:segment': '\ue94b',
        'material:select': '\uf74d',
        'material:select_all': '\ue162',
        'material:select_check_box': '\uf1fe',
        'material:select_to_speak': '\uf7cf',
        'material:select_window': '\ue6fa',
        'material:select_window_2': '\uf4c8',
        'material:select_window_off': '\ue506',
        'material:self_care': '\uf86d',
        'material:self_improvement': '\uea78',
        'material:sell': '\ue54e',
        'material:send': '\ue163',
        'material:send_and_archive': '\uea0c',
        'material:send_money': '\ue8b7',
        'material:send_time_extension': '\ueadb',
        'material:sensor_door': '\uf1b5',
        'material:sensor_occupied': '\uec10',
        'material:sensor_window': '\uf1b4',
        'material:sensors': '\ue51e',
        'material:sensors_krx': '\uf556',
        'material:sensors_krx_off': '\uf515',
        'material:sensors_off': '\ue51f',
        'material:sentiment_calm': '\uf6a7',
        'material:sentiment_content': '\uf6a6',
        'material:sentiment_dissatisfied': '\ue811',
        'material:sentiment_excited': '\uf6a5',
        'material:sentiment_extremely_dissatisfied': '\uf194',
        'material:sentiment_frustrated': '\uf6a4',
        'material:sentiment_neutral': '\ue812',
        'material:sentiment_sad': '\uf6a3',
        'material:sentiment_satisfied': '\ue0ed',
        'material:sentiment_stressed': '\uf6a2',
        'material:sentiment_very_dissatisfied': '\ue814',
        'material:sentiment_very_satisfied': '\ue815',
        'material:sentiment_worried': '\uf6a1',
        'material:serif': '\uf4ac',
        'material:server_person': '\uf3bd',
        'material:service_toolbox': '\ue717',
        'material:set_meal': '\uf1ea',
        'material:settings': '\ue8b8',
        'material:settings_accessibility': '\uf05d',
        'material:settings_account_box': '\uf835',
        'material:settings_alert': '\uf143',
        'material:settings_applications': '\ue8b9',
        'material:settings_b_roll': '\uf625',
        'material:settings_backup_restore': '\ue8ba',
        'material:settings_bluetooth': '\ue8bb',
        'material:settings_brightness': '\ue8bd',
        'material:settings_cinematic_blur': '\uf624',
        'material:settings_ethernet': '\ue8be',
        'material:settings_heart': '\uf522',
        'material:settings_input_antenna': '\ue8bf',
        'material:settings_input_component': '\ue8c0',
        'material:settings_input_hdmi': '\ue8c2',
        'material:settings_input_svideo': '\ue8c3',
        'material:settings_motion_mode': '\uf833',
        'material:settings_night_sight': '\uf832',
        'material:settings_overscan': '\ue8c4',
        'material:settings_panorama': '\uf831',
        'material:settings_phone': '\ue8c5',
        'material:settings_photo_camera': '\uf834',
        'material:settings_power': '\ue8c6',
        'material:settings_remote': '\ue8c7',
        'material:settings_seating': '\uef2d',
        'material:settings_slow_motion': '\uf623',
        'material:settings_suggest': '\uf05e',
        'material:settings_system_daydream': '\ue1c3',
        'material:settings_timelapse': '\uf622',
        'material:settings_video_camera': '\uf621',
        'material:settings_voice': '\ue8c8',
        'material:settop_component': '\ue2ac',
        'material:severe_cold': '\uebd3',
        'material:shadow': '\ue9df',
        'material:shadow_add': '\uf584',
        'material:shadow_minus': '\uf583',
        'material:shape_line': '\uf8d3',
        'material:shape_recognition': '\ueb01',
        'material:shapes': '\ue602',
        'material:share': '\ue80d',
        'material:share_eta': '\ue5f7',
        'material:share_location': '\uf05f',
        'material:share_off': '\uf6cb',
        'material:share_reviews': '\uf8a4',
        'material:share_windows': '\uf613',
        'material:shaved_ice': '\uf225',
        'material:sheets_rtl': '\uf823',
        'material:shelf_auto_hide': '\uf703',
        'material:shelf_position': '\uf702',
        'material:shelves': '\uf86e',
        'material:shield': '\ue9e0',
        'material:shield_lock': '\uf686',
        'material:shield_locked': '\uf592',
        'material:shield_moon': '\ueaa9',
        'material:shield_person': '\uf650',
        'material:shield_question': '\uf529',
        'material:shield_toggle': '\uf2ad',
        'material:shield_watch': '\uf30f',
        'material:shield_with_heart': '\ue78f',
        'material:shield_with_house': '\ue78d',
        'material:shift': '\ue5f2',
        'material:shift_lock': '\uf7ae',
        'material:shift_lock_off': '\uf483',
        'material:shop': '\ue8c9',
        'material:shop_two': '\ue19e',
        'material:shopping_bag': '\uf1cc',
        'material:shopping_bag_speed': '\uf39a',
        'material:shopping_basket': '\ue8cb',
        'material:shopping_cart': '\ue547',
        'material:shopping_cart_checkout': '\ueb88',
        'material:shopping_cart_off': '\uf4f7',
        'material:shoppingmode': '\uefb7',
        'material:short_stay': '\ue4d0',
        'material:short_text': '\ue261',
        'material:show_chart': '\ue6e1',
        'material:shower': '\uf061',
        'material:shuffle': '\ue043',
        'material:shuffle_on': '\ue9e1',
        'material:shutter_speed': '\ue43d',
        'material:shutter_speed_add': '\uf57e',
        'material:shutter_speed_minus': '\uf57d',
        'material:sick': '\uf220',
        'material:side_navigation': '\ue9e2',
        'material:sign_language': '\uebe5',
        'material:sign_language_2': '\uf258',
        'material:signal_cellular_0_bar': '\uf0a8',
        'material:signal_cellular_1_bar': '\uf0a9',
        'material:signal_cellular_2_bar': '\uf0aa',
        'material:signal_cellular_3_bar': '\uf0ab',
        'material:signal_cellular_4_bar': '\ue1c8',
        'material:signal_cellular_add': '\uf7a9',
        'material:signal_cellular_alt': '\ue202',
        'material:signal_cellular_alt_1_bar': '\uebdf',
        'material:signal_cellular_alt_2_bar': '\uebe3',
        'material:signal_cellular_connected_no_internet_0_bar': '\uf0ac',
        'material:signal_cellular_connected_no_internet_4_bar': '\ue1cd',
        'material:signal_cellular_nodata': '\uf062',
        'material:signal_cellular_null': '\ue1cf',
        'material:signal_cellular_off': '\ue1d0',
        'material:signal_cellular_pause': '\uf5a7',
        'material:signal_disconnected': '\uf239',
        'material:signal_wifi_0_bar': '\uf0b0',
        'material:signal_wifi_4_bar': '\ue1d8',
        'material:signal_wifi_bad': '\uf063',
        'material:signal_wifi_off': '\ue1da',
        'material:signal_wifi_statusbar_not_connected': '\uf0ef',
        'material:signal_wifi_statusbar_null': '\uf067',
        'material:signature': '\uf74c',
        'material:signpost': '\ueb91',
        'material:sim_card': '\ue32b',
        'material:sim_card_download': '\uf068',
        'material:simulation': '\uf3e1',
        'material:single_bed': '\uea48',
        'material:sip': '\uf069',
        'material:siren': '\uf3a7',
        'material:siren_check': '\uf3a6',
        'material:siren_open': '\uf3a5',
        'material:siren_question': '\uf3a4',
        'material:skateboarding': '\ue511',
        'material:skeleton': '\uf899',
        'material:skillet': '\uf543',
        'material:skillet_cooktop': '\uf544',
        'material:skip_next': '\ue044',
        'material:skip_previous': '\ue045',
        'material:skull': '\uf89a',
        'material:skull_list': '\uf370',
        'material:slab_serif': '\uf4ab',
        'material:sledding': '\ue512',
        'material:sleep': '\ue213',
        'material:sleep_score': '\uf6b7',
        'material:slide_library': '\uf822',
        'material:sliders': '\ue9e3',
        'material:slideshow': '\ue41b',
        'material:slow_motion_video': '\ue068',
        'material:smart_button': '\uf1c1',
        'material:smart_card_reader': '\uf4a5',
        'material:smart_card_reader_off': '\uf4a6',
        'material:smart_display': '\uf06a',
        'material:smart_outlet': '\ue844',
        'material:smart_toy': '\uf06c',
        'material:smb_share': '\uf74b',
        'material:smoke_free': '\ueb4a',
        'material:smoking_rooms': '\ueb4b',
        'material:sms': '\ue0d8',
        'material:sms_failed': '\ue626',
        'material:snippet_folder': '\uf1c7',
        'material:snooze': '\ue046',
        'material:snowboarding': '\ue513',
        'material:snowing': '\ue80f',
        'material:snowing_heavy': '\uf61c',
        'material:snowmobile': '\ue503',
        'material:snowshoeing': '\ue514',
        'material:soap': '\uf1b2',
        'material:soba': '\uef36',
        'material:social_distance': '\ue1cb',
        'material:social_leaderboard': '\uf6a0',
        'material:solar_power': '\uec0f',
        'material:solo_dining': '\uef35',
        'material:sort': '\ue164',
        'material:sort_by_alpha': '\ue053',
        'material:sos': '\uebf7',
        'material:sound_detection_dog_barking': '\uf149',
        'material:sound_detection_glass_break': '\uf14a',
        'material:sound_detection_loud_sound': '\uf14b',
        'material:sound_sampler': '\uf6b4',
        'material:soup_kitchen': '\ue7d3',
        'material:source_environment': '\ue527',
        'material:source_notes': '\ue12d',
        'material:south': '\uf1e3',
        'material:south_america': '\ue7e4',
        'material:south_east': '\uf1e4',
        'material:south_west': '\uf1e5',
        'material:spa': '\ueb4c',
        'material:space_bar': '\ue256',
        'material:space_dashboard': '\ue66b',
        'material:spatial_audio': '\uebeb',
        'material:spatial_audio_off': '\uebe8',
        'material:spatial_speaker': '\uf4cf',
        'material:spatial_tracking': '\uebea',
        'material:speaker': '\ue32d',
        'material:speaker_group': '\ue32e',
        'material:speaker_notes': '\ue8cd',
        'material:speaker_notes_off': '\ue92a',
        'material:speaker_phone': '\ue0d2',
        'material:special_character': '\uf74a',
        'material:specific_gravity': '\uf872',
        'material:speech_to_text': '\uf8a7',
        'material:speed': '\ue9e4',
        'material:speed_0_25': '\uf4d4',
        'material:speed_0_2x': '\uf498',
        'material:speed_0_5': '\uf4e2',
        'material:speed_0_5x': '\uf497',
        'material:speed_0_75': '\uf4d3',
        'material:speed_0_7x': '\uf496',
        'material:speed_1_2': '\uf4e1',
        'material:speed_1_25': '\uf4d2',
        'material:speed_1_2x': '\uf495',
        'material:speed_1_5': '\uf4e0',
        'material:speed_1_5x': '\uf494',
        'material:speed_1_75': '\uf4d1',
        'material:speed_1_7x': '\uf493',
        'material:speed_2x': '\uf4eb',
        'material:speed_camera': '\uf470',
        'material:spellcheck': '\ue8ce',
        'material:split_scene': '\uf3bf',
        'material:split_scene_down': '\uf2ff',
        'material:split_scene_left': '\uf2fe',
        'material:split_scene_right': '\uf2fd',
        'material:split_scene_up': '\uf2fc',
        'material:splitscreen': '\uf06d',
        'material:splitscreen_add': '\uf4fd',
        'material:splitscreen_bottom': '\uf676',
        'material:splitscreen_landscape': '\uf459',
        'material:splitscreen_left': '\uf675',
        'material:splitscreen_portrait': '\uf458',
        'material:splitscreen_right': '\uf674',
        'material:splitscreen_top': '\uf673',
        'material:splitscreen_vertical_add': '\uf4fc',
        'material:spo2': '\uf6db',
        'material:spoke': '\ue9a7',
        'material:sports': '\uea30',
        'material:sports_and_outdoors': '\uefb8',
        'material:sports_bar': '\uf1f3',
        'material:sports_baseball': '\uea51',
        'material:sports_basketball': '\uea26',
        'material:sports_cricket': '\uea27',
        'material:sports_esports': '\uea28',
        'material:sports_football': '\uea29',
        'material:sports_golf': '\uea2a',
        'material:sports_gymnastics': '\uebc4',
        'material:sports_handball': '\uea33',
        'material:sports_hockey': '\uea2b',
        'material:sports_kabaddi': '\uea34',
        'material:sports_martial_arts': '\ueae9',
        'material:sports_mma': '\uea2c',
        'material:sports_motorsports': '\uea2d',
        'material:sports_rugby': '\uea2e',
        'material:sports_score': '\uf06e',
        'material:sports_soccer': '\uea2f',
        'material:sports_tennis': '\uea32',
        'material:sports_volleyball': '\uea31',
        'material:sprinkler': '\ue29a',
        'material:sprint': '\uf81f',
        'material:square': '\ueb36',
        'material:square_dot': '\uf3b3',
        'material:square_foot': '\uea49',
        'material:ssid_chart': '\ueb66',
        'material:stack': '\uf609',
        'material:stack_group': '\uf359',
        'material:stack_hexagon': '\uf41c',
        'material:stack_off': '\uf608',
        'material:stack_star': '\uf607',
        'material:stacked_bar_chart': '\ue9e6',
        'material:stacked_email': '\ue6c7',
        'material:stacked_inbox': '\ue6c9',
        'material:stacked_line_chart': '\uf22b',
        'material:stacks': '\uf500',
        'material:stadia_controller': '\uf135',
        'material:stadium': '\ueb90',
        'material:stairs': '\uf1a9',
        'material:stairs_2': '\uf46c',
        'material:star': '\ue838',
        'material:star_half': '\ue839',
        'material:star_rate': '\uf0ec',
        'material:star_rate_half': '\uec45',
        'material:star_shine': '\uf31d',
        'material:stars': '\ue8d0',
        'material:stars_2': '\uf31c',
        'material:start': '\ue089',
        'material:stat_0': '\ue697',
        'material:stat_1': '\ue698',
        'material:stat_2': '\ue699',
        'material:stat_3': '\ue69a',
        'material:stat_minus_1': '\ue69b',
        'material:stat_minus_2': '\ue69c',
        'material:stat_minus_3': '\ue69d',
        'material:steering_wheel_heat': '\uf32b',
        'material:step': '\uf6fe',
        'material:step_into': '\uf701',
        'material:step_out': '\uf700',
        'material:step_over': '\uf6ff',
        'material:steppers': '\ue9e7',
        'material:steps': '\uf6da',
        'material:stethoscope': '\uf805',
        'material:stethoscope_arrow': '\uf807',
        'material:stethoscope_check': '\uf806',
        'material:sticky_note': '\ue9e8',
        'material:sticky_note_2': '\uf1fc',
        'material:stock_media': '\uf570',
        'material:stockpot': '\uf545',
        'material:stop': '\ue047',
        'material:stop_circle': '\uef71',
        'material:stop_screen_share': '\ue0e3',
        'material:storage': '\ue1db',
        'material:store': '\ue563',
        'material:storefront': '\uea12',
        'material:storm': '\uf070',
        'material:straight': '\ueb95',
        'material:straighten': '\ue41c',
        'material:strategy': '\uf5df',
        'material:stream': '\ue9e9',
        'material:streetview': '\ue56e',
        'material:stress_management': '\uf6d9',
        'material:strikethrough_s': '\ue257',
        'material:stroke_full': '\uf749',
        'material:stroke_partial': '\uf748',
        'material:stroller': '\uf1ae',
        'material:style': '\ue41d',
        'material:styler': '\ue273',
        'material:stylus': '\uf604',
        'material:stylus_brush': '\uf366',
        'material:stylus_fountain_pen': '\uf365',
        'material:stylus_highlighter': '\uf364',
        'material:stylus_laser_pointer': '\uf747',
        'material:stylus_note': '\uf603',
        'material:stylus_pen': '\uf363',
        'material:stylus_pencil': '\uf362',
        'material:subdirectory_arrow_left': '\ue5d9',
        'material:subdirectory_arrow_right': '\ue5da',
        'material:subheader': '\ue9ea',
        'material:subject': '\ue8d2',
        'material:subscript': '\uf111',
        'material:subscriptions': '\ue064',
        'material:subtitles': '\ue048',
        'material:subtitles_gear': '\uf355',
        'material:subtitles_off': '\uef72',
        'material:subway': '\ue56f',
        'material:subway_walk': '\uf287',
        'material:summarize': '\uf071',
        'material:sunny': '\ue81a',
        'material:sunny_snowing': '\ue819',
        'material:superscript': '\uf112',
        'material:supervised_user_circle': '\ue939',
        'material:supervised_user_circle_off': '\uf60e',
        'material:supervisor_account': '\ue8d3',
        'material:support': '\uef73',
        'material:support_agent': '\uf0e2',
        'material:surfing': '\ue515',
        'material:surgical': '\ue131',
        'material:surround_sound': '\ue049',
        'material:swap_calls': '\ue0d7',
        'material:swap_driving_apps': '\ue69e',
        'material:swap_driving_apps_wheel': '\ue69f',
        'material:swap_horiz': '\ue8d4',
        'material:swap_horizontal_circle': '\ue933',
        'material:swap_vert': '\ue0c3',
        'material:swap_vertical_circle': '\ue8d6',
        'material:sweep': '\ue6ac',
        'material:swipe': '\ue9ec',
        'material:swipe_down': '\ueb53',
        'material:swipe_down_alt': '\ueb30',
        'material:swipe_left': '\ueb59',
        'material:swipe_left_alt': '\ueb33',
        'material:swipe_right': '\ueb52',
        'material:swipe_right_alt': '\ueb56',
        'material:swipe_up': '\ueb2e',
        'material:swipe_up_alt': '\ueb35',
        'material:swipe_vertical': '\ueb51',
        'material:switch': '\ue1f4',
        'material:switch_access': '\uf6fd',
        'material:switch_access_2': '\uf506',
        'material:switch_access_3': '\uf34d',
        'material:switch_access_shortcut': '\ue7e1',
        'material:switch_access_shortcut_add': '\ue7e2',
        'material:switch_account': '\ue9ed',
        'material:switch_camera': '\ue41e',
        'material:switch_left': '\uf1d1',
        'material:switch_right': '\uf1d2',
        'material:switch_video': '\ue41f',
        'material:switches': '\ue733',
        'material:sword_rose': '\uf5de',
        'material:swords': '\uf889',
        'material:symptoms': '\ue132',
        'material:synagogue': '\ueab0',
        'material:sync': '\ue627',
        'material:sync_alt': '\uea18',
        'material:sync_arrow_down': '\uf37c',
        'material:sync_arrow_up': '\uf37b',
        'material:sync_desktop': '\uf41a',
        'material:sync_disabled': '\ue628',
        'material:sync_lock': '\ueaee',
        'material:sync_problem': '\ue629',
        'material:sync_saved_locally': '\uf820',
        'material:sync_saved_locally_off': '\uf264',
        'material:syringe': '\ue133',
        'material:system_update_alt': '\ue8d7',
        'material:tab': '\ue8d8',
        'material:tab_close': '\uf745',
        'material:tab_close_inactive': '\uf3d0',
        'material:tab_close_right': '\uf746',
        'material:tab_duplicate': '\uf744',
        'material:tab_group': '\uf743',
        'material:tab_inactive': '\uf43b',
        'material:tab_move': '\uf742',
        'material:tab_new_right': '\uf741',
        'material:tab_recent': '\uf740',
        'material:tab_search': '\uf2f2',
        'material:tab_unselected': '\ue8d9',
        'material:table': '\uf191',
        'material:table_bar': '\uead2',
        'material:table_chart': '\ue265',
        'material:table_chart_view': '\uf6ef',
        'material:table_convert': '\uf3c7',
        'material:table_edit': '\uf3c6',
        'material:table_eye': '\uf466',
        'material:table_lamp': '\ue1f2',
        'material:table_large': '\uf299',
        'material:table_restaurant': '\ueac6',
        'material:table_rows': '\uf101',
        'material:table_rows_narrow': '\uf73f',
        'material:table_sign': '\uef2c',
        'material:table_view': '\uf1be',
        'material:tablet': '\ue32f',
        'material:tablet_android': '\ue330',
        'material:tablet_camera': '\uf44d',
        'material:tablet_mac': '\ue331',
        'material:tabs': '\ue9ee',
        'material:tactic': '\uf564',
        'material:tag': '\ue9ef',
        'material:takeout_dining': '\uea74',
        'material:takeout_dining_2': '\uef34',
        'material:tamper_detection_off': '\ue82e',
        'material:tamper_detection_on': '\uf8c8',
        'material:tapas': '\uf1e9',
        'material:target': '\ue719',
        'material:task': '\uf075',
        'material:task_alt': '\ue2e6',
        'material:tatami_seat': '\uef33',
        'material:taunt': '\uf69f',
        'material:taxi_alert': '\uef74',
        'material:team_dashboard': '\ue013',
        'material:temp_preferences_custom': '\uf8c9',
        'material:temp_preferences_eco': '\uf8ca',
        'material:temple_buddhist': '\ueab3',
        'material:temple_hindu': '\ueaaf',
        'material:tenancy': '\uf0e3',
        'material:terminal': '\ueb8e',
        'material:text_ad': '\ue728',
        'material:text_compare': '\uf3c5',
        'material:text_decrease': '\ueadd',
        'material:text_fields': '\ue262',
        'material:text_fields_alt': '\ue9f1',
        'material:text_format': '\ue165',
        'material:text_increase': '\ueae2',
        'material:text_rotate_up': '\ue93a',
        'material:text_rotate_vertical': '\ue93b',
        'material:text_rotation_angledown': '\ue93c',
        'material:text_rotation_angleup': '\ue93d',
        'material:text_rotation_down': '\ue93e',
        'material:text_rotation_none': '\ue93f',
        'material:text_select_end': '\uf73e',
        'material:text_select_jump_to_beginning': '\uf73d',
        'material:text_select_jump_to_end': '\uf73c',
        'material:text_select_move_back_character': '\uf73b',
        'material:text_select_move_back_word': '\uf73a',
        'material:text_select_move_down': '\uf739',
        'material:text_select_move_forward_character': '\uf738',
        'material:text_select_move_forward_word': '\uf737',
        'material:text_select_move_up': '\uf736',
        'material:text_select_start': '\uf735',
        'material:text_snippet': '\uf1c6',
        'material:text_to_speech': '\uf1bc',
        'material:text_up': '\ue6a7',
        'material:texture': '\ue421',
        'material:texture_add': '\uf57c',
        'material:texture_minus': '\uf57b',
        'material:theater_comedy': '\uea66',
        'material:theaters': '\ue54d',
        'material:thermometer': '\ue846',
        'material:thermometer_add': '\uf582',
        'material:thermometer_gain': '\uf6d8',
        'material:thermometer_loss': '\uf6d7',
        'material:thermometer_minus': '\uf581',
        'material:thermostat': '\uf076',
        'material:thermostat_arrow_down': '\uf37a',
        'material:thermostat_arrow_up': '\uf379',
        'material:thermostat_auto': '\uf077',
        'material:thermostat_carbon': '\uf178',
        'material:things_to_do': '\ueb2a',
        'material:thread_unread': '\uf4f9',
        'material:threat_intelligence': '\ueaed',
        'material:thumb_down': '\ue816',
        'material:thumb_up': '\ue817',
        'material:thumbnail_bar': '\uf734',
        'material:thumbs_up_double': '\ueefc',
        'material:thumbs_up_down': '\ue8dd',
        'material:thunderstorm': '\uebdb',
        'material:tibia': '\uf89b',
        'material:tibia_alt': '\uf89c',
        'material:tile_large': '\uf3c3',
        'material:tile_medium': '\uf3c2',
        'material:tile_small': '\uf3c1',
        'material:time_auto': '\uf0e4',
        'material:timelapse': '\ue422',
        'material:timeline': '\ue922',
        'material:timer': '\ue425',
        'material:timer_1': '\uf2af',
        'material:timer_10': '\ue423',
        'material:timer_10_alt_1': '\uefbf',
        'material:timer_10_select': '\uf07a',
        'material:timer_2': '\uf2ae',
        'material:timer_3': '\ue424',
        'material:timer_3_alt_1': '\uefc0',
        'material:timer_3_select': '\uf07b',
        'material:timer_5': '\uf4b1',
        'material:timer_5_shutter': '\uf4b2',
        'material:timer_arrow_down': '\uf378',
        'material:timer_arrow_up': '\uf377',
        'material:timer_off': '\ue426',
        'material:timer_pause': '\uf4bb',
        'material:timer_play': '\uf4ba',
        'material:tips_and_updates': '\ue79a',
        'material:tire_repair': '\uebc8',
        'material:title': '\ue264',
        'material:titlecase': '\uf489',
        'material:toast': '\uefc1',
        'material:toc': '\ue8de',
        'material:today': '\ue8df',
        'material:toggle_off': '\ue9f5',
        'material:toggle_on': '\ue9f6',
        'material:token': '\uea25',
        'material:toll': '\ue8e0',
        'material:tonality': '\ue427',
        'material:tonality_2': '\uf2b4',
        'material:toolbar': '\ue9f7',
        'material:tools_flat_head': '\uf8cb',
        'material:tools_installation_kit': '\ue2ab',
        'material:tools_ladder': '\ue2cb',
        'material:tools_level': '\ue77b',
        'material:tools_phillips': '\uf8cc',
        'material:tools_pliers_wire_stripper': '\ue2aa',
        'material:tools_power_drill': '\ue1e9',
        'material:tooltip': '\ue9f8',
        'material:tooltip_2': '\uf3ed',
        'material:top_panel_close': '\uf733',
        'material:top_panel_open': '\uf732',
        'material:topic': '\uf1c4',
        'material:tornado': '\ue199',
        'material:total_dissolved_solids': '\uf877',
        'material:touch_app': '\ue913',
        'material:touch_double': '\uf38b',
        'material:touch_long': '\uf38a',
        'material:touch_triple': '\uf389',
        'material:touchpad_mouse': '\uf687',
        'material:touchpad_mouse_off': '\uf4e6',
        'material:tour': '\uef75',
        'material:toys': '\ue332',
        'material:toys_and_games': '\uefc2',
        'material:toys_fan': '\uf887',
        'material:track_changes': '\ue8e1',
        'material:trackpad_input': '\uf4c7',
        'material:trackpad_input_2': '\uf409',
        'material:trackpad_input_3': '\uf408',
        'material:traffic': '\ue565',
        'material:traffic_jam': '\uf46f',
        'material:trail_length': '\ueb5e',
        'material:trail_length_medium': '\ueb63',
        'material:trail_length_short': '\ueb6d',
        'material:train': '\ue570',
        'material:tram': '\ue571',
        'material:transcribe': '\uf8ec',
        'material:transfer_within_a_station': '\ue572',
        'material:transform': '\ue428',
        'material:transgender': '\ue58d',
        'material:transit_enterexit': '\ue579',
        'material:transit_ticket': '\uf3f1',
        'material:transition_chop': '\uf50e',
        'material:transition_dissolve': '\uf50d',
        'material:transition_fade': '\uf50c',
        'material:transition_push': '\uf50b',
        'material:transition_slide': '\uf50a',
        'material:translate': '\ue8e2',
        'material:translate_indic': '\uf263',
        'material:transportation': '\ue21d',
        'material:travel': '\ue6ca',
        'material:travel_explore': '\ue2db',
        'material:travel_luggage_and_bags': '\uefc3',
        'material:trending_down': '\ue8e3',
        'material:trending_flat': '\ue8e4',
        'material:trending_up': '\ue8e5',
        'material:trip': '\ue6fb',
        'material:trip_origin': '\ue57b',
        'material:trolley': '\uf86b',
        'material:trolley_cable_car': '\uf46e',
        'material:trophy': '\ue71a',
        'material:troubleshoot': '\ue1d2',
        'material:tsunami': '\uebd8',
        'material:tsv': '\ue6d6',
        'material:tty': '\uf1aa',
        'material:tune': '\ue429',
        'material:turn_left': '\ueba6',
        'material:turn_right': '\uebab',
        'material:turn_sharp_left': '\ueba7',
        'material:turn_sharp_right': '\uebaa',
        'material:turn_slight_left': '\ueba4',
        'material:turn_slight_right': '\ueb9a',
        'material:tv': '\ue333',
        'material:tv_displays': '\uf3ec',
        'material:tv_gen': '\ue830',
        'material:tv_guide': '\ue1dc',
        'material:tv_next': '\uf3eb',
        'material:tv_off': '\ue647',
        'material:tv_options_edit_channels': '\ue1dd',
        'material:tv_options_input_settings': '\ue1de',
        'material:tv_remote': '\uf5d9',
        'material:tv_signin': '\ue71b',
        'material:tv_with_assistant': '\ue785',
        'material:two_pager': '\uf51f',
        'material:two_pager_store': '\uf3c4',
        'material:two_wheeler': '\ue9f9',
        'material:type_specimen': '\uf8f0',
        'material:u_turn_left': '\ueba1',
        'material:u_turn_right': '\ueba2',
        'material:udon': '\uef32',
        'material:ulna_radius': '\uf89d',
        'material:ulna_radius_alt': '\uf89e',
        'material:umbrella': '\uf1ad',
        'material:unarchive': '\ue169',
        'material:undo': '\ue166',
        'material:unfold_less': '\ue5d6',
        'material:unfold_less_double': '\uf8cf',
        'material:unfold_more': '\ue5d7',
        'material:unfold_more_double': '\uf8d0',
        'material:ungroup': '\uf731',
        'material:uni00A0': '\u00a0',
        'material:universal_currency': '\ue9fa',
        'material:universal_currency_alt': '\ue734',
        'material:universal_local': '\ue9fb',
        'material:unknown_5': '\ue6a5',
        'material:unknown_document': '\uf804',
        'material:unknown_med': '\ueabd',
        'material:unlicense': '\ueb05',
        'material:unpaved_road': '\uf46d',
        'material:unpublished': '\uf236',
        'material:unsubscribe': '\ue0eb',
        'material:upcoming': '\uf07e',
        'material:update': '\ue923',
        'material:update_disabled': '\ue075',
        'material:upgrade': '\uf0fb',
        'material:upi_pay': '\uf3cf',
        'material:upload': '\ue2c6',
        'material:upload_2': '\uf521',
        'material:upload_file': '\ue9fc',
        'material:uppercase': '\uf488',
        'material:urology': '\ue137',
        'material:usb': '\ue1e0',
        'material:usb_off': '\ue4fa',
        'material:user_attributes': '\ue708',
        'material:vaccines': '\ue138',
        'material:vacuum': '\uefc5',
        'material:valve': '\ue224',
        'material:vape_free': '\uebc6',
        'material:vaping_rooms': '\uebcf',
        'material:variable_add': '\uf51e',
        'material:variable_insert': '\uf51d',
        'material:variable_remove': '\uf51c',
        'material:variables': '\uf851',
        'material:ventilator': '\ue139',
        'material:verified': '\ue031',
        'material:verified_off': '\uf30e',
        'material:verified_user': '\ue8e8',
        'material:vertical_align_bottom': '\ue258',
        'material:vertical_align_center': '\ue259',
        'material:vertical_align_top': '\ue25a',
        'material:vertical_distribute': '\ue076',
        'material:vertical_shades': '\uec0e',
        'material:vertical_shades_closed': '\uec0d',
        'material:vertical_split': '\ue949',
        'material:video_call': '\ue070',
        'material:video_camera_back': '\uf07f',
        'material:video_camera_back_add': '\uf40c',
        'material:video_camera_front': '\uf080',
        'material:video_camera_front_off': '\uf83b',
        'material:video_chat': '\uf8a0',
        'material:video_file': '\ueb87',
        'material:video_label': '\ue071',
        'material:video_library': '\ue04a',
        'material:video_search': '\uefc6',
        'material:video_settings': '\uea75',
        'material:video_stable': '\uf081',
        'material:videocam': '\ue04b',
        'material:videocam_alert': '\uf390',
        'material:videocam_off': '\ue04c',
        'material:videogame_asset': '\ue338',
        'material:videogame_asset_off': '\ue500',
        'material:view_agenda': '\ue8e9',
        'material:view_apps': '\uf376',
        'material:view_array': '\ue8ea',
        'material:view_carousel': '\ue8eb',
        'material:view_column': '\ue8ec',
        'material:view_column_2': '\uf847',
        'material:view_comfy': '\ue42a',
        'material:view_comfy_alt': '\ueb73',
        'material:view_compact': '\ue42b',
        'material:view_compact_alt': '\ueb74',
        'material:view_cozy': '\ueb75',
        'material:view_day': '\ue8ed',
        'material:view_headline': '\ue8ee',
        'material:view_in_ar': '\ue9fe',
        'material:view_in_ar_off': '\uf61b',
        'material:view_kanban': '\ueb7f',
        'material:view_list': '\ue8ef',
        'material:view_module': '\ue8f0',
        'material:view_object_track': '\uf432',
        'material:view_quilt': '\ue8f1',
        'material:view_real_size': '\uf4c2',
        'material:view_sidebar': '\uf114',
        'material:view_stream': '\ue8f2',
        'material:view_timeline': '\ueb85',
        'material:view_week': '\ue8f3',
        'material:vignette': '\ue435',
        'material:vignette_2': '\uf2b3',
        'material:villa': '\ue586',
        'material:visibility': '\ue417',
        'material:visibility_lock': '\uf653',
        'material:visibility_off': '\ue8f5',
        'material:vital_signs': '\ue650',
        'material:vitals': '\ue13b',
        'material:vo2_max': '\uf4aa',
        'material:voice_chat': '\ue62e',
        'material:voice_over_off': '\ue94a',
        'material:voice_selection': '\uf58a',
        'material:voice_selection_off': '\uf42c',
        'material:voicemail': '\ue0d9',
        'material:voicemail_2': '\uf352',
        'material:volcano': '\uebda',
        'material:volume_down': '\ue04d',
        'material:volume_down_alt': '\ue79c',
        'material:volume_mute': '\ue04e',
        'material:volume_off': '\ue04f',
        'material:volume_up': '\ue050',
        'material:volunteer_activism': '\uea70',
        'material:voting_chip': '\uf852',
        'material:vpn_key': '\ue0da',
        'material:vpn_key_alert': '\uf6cc',
        'material:vpn_key_off': '\ueb7a',
        'material:vpn_lock': '\ue62f',
        'material:vpn_lock_2': '\uf350',
        'material:vr180_create2d': '\uefca',
        'material:vr180_create2d_off': '\uf571',
        'material:vrpano': '\uf082',
        'material:wall_art': '\uefcb',
        'material:wall_lamp': '\ue2b4',
        'material:wallet': '\uf8ff',
        'material:wallpaper': '\ue1bc',
        'material:wallpaper_slideshow': '\uf672',
        'material:wand_shine': '\uf31f',
        'material:wand_stars': '\uf31e',
        'material:ward': '\ue13c',
        'material:warehouse': '\uebb8',
        'material:warning': '\ue002',
        'material:warning_off': '\uf7ad',
        'material:wash': '\uf1b1',
        'material:washoku': '\uf280',
        'material:watch': '\ue334',
        'material:watch_arrow': '\uf2ca',
        'material:watch_button_press': '\uf6aa',
        'material:watch_check': '\uf468',
        'material:watch_off': '\ueae3',
        'material:watch_screentime': '\uf6ae',
        'material:watch_vibration': '\uf467',
        'material:watch_wake': '\uf6a9',
        'material:water': '\uf084',
        'material:water_bottle': '\uf69d',
        'material:water_bottle_large': '\uf69e',
        'material:water_damage': '\uf203',
        'material:water_do': '\uf870',
        'material:water_drop': '\ue798',
        'material:water_ec': '\uf875',
        'material:water_full': '\uf6d6',
        'material:water_heater': '\ue284',
        'material:water_lock': '\uf6ad',
        'material:water_loss': '\uf6d5',
        'material:water_lux': '\uf874',
        'material:water_medium': '\uf6d4',
        'material:water_orp': '\uf878',
        'material:water_ph': '\uf87a',
        'material:water_pump': '\uf5d8',
        'material:water_voc': '\uf87b',
        'material:waterfall_chart': '\uea00',
        'material:waves': '\ue176',
        'material:waving_hand': '\ue766',
        'material:wb_auto': '\ue42c',
        'material:wb_incandescent': '\ue42e',
        'material:wb_iridescent': '\ue436',
        'material:wb_shade': '\uea01',
        'material:wb_sunny': '\ue430',
        'material:wb_twilight': '\ue1c6',
        'material:wc': '\ue63d',
        'material:weather_hail': '\uf67f',
        'material:weather_mix': '\uf60b',
        'material:weather_snowy': '\ue2cd',
        'material:web': '\ue051',
        'material:web_asset': '\ue069',
        'material:web_asset_off': '\ue4f7',
        'material:web_stories': '\ue595',
        'material:web_traffic': '\uea03',
        'material:webhook': '\ueb92',
        'material:weekend': '\ue16b',
        'material:weight': '\ue13d',
        'material:west': '\uf1e6',
        'material:whatshot': '\ue80e',
        'material:wheelchair_pickup': '\uf1ab',
        'material:where_to_vote': '\ue177',
        'material:widget_medium': '\uf3ba',
        'material:widget_small': '\uf3b9',
        'material:widget_width': '\uf3b8',
        'material:widgets': '\ue1bd',
        'material:width': '\uf730',
        'material:width_full': '\uf8f5',
        'material:width_normal': '\uf8f6',
        'material:width_wide': '\uf8f7',
        'material:wifi': '\ue63e',
        'material:wifi_1_bar': '\ue4ca',
        'material:wifi_2_bar': '\ue4d9',
        'material:wifi_add': '\uf7a8',
        'material:wifi_calling': '\uef77',
        'material:wifi_calling_1': '\uf085',
        'material:wifi_calling_2': '\uf0f6',
        'material:wifi_calling_bar_1': '\uf44c',
        'material:wifi_calling_bar_2': '\uf44b',
        'material:wifi_calling_bar_3': '\uf44a',
        'material:wifi_channel': '\ueb6a',
        'material:wifi_find': '\ueb31',
        'material:wifi_home': '\uf671',
        'material:wifi_lock': '\ue1d9',
        'material:wifi_notification': '\uf670',
        'material:wifi_off': '\ue648',
        'material:wifi_password': '\ueb6b',
        'material:wifi_protected_setup': '\uf0fc',
        'material:wifi_proxy': '\uf7a7',
        'material:wifi_tethering': '\ue1e2',
        'material:wifi_tethering_error': '\uead9',
        'material:wifi_tethering_off': '\ue0ce',
        'material:wind_power': '\uec0c',
        'material:window': '\uf088',
        'material:window_closed': '\ue77e',
        'material:window_open': '\ue78c',
        'material:window_sensor': '\ue2bb',
        'material:windshield_defrost_auto': '\uf248',
        'material:windshield_defrost_front': '\uf32a',
        'material:windshield_defrost_rear': '\uf329',
        'material:windshield_heat_front': '\uf328',
        'material:wine_bar': '\uf1e8',
        'material:woman': '\ue13e',
        'material:woman_2': '\uf8e7',
        'material:work': '\ue8f9',
        'material:work_alert': '\uf5f7',
        'material:work_history': '\uec09',
        'material:work_off': '\ue942',
        'material:work_update': '\uf5f8',
        'material:workspace_premium': '\ue7af',
        'material:workspaces': '\ue1a0',
        'material:wounds_injuries': '\ue13f',
        'material:wrap_text': '\ue25b',
        'material:wrist': '\uf69c',
        'material:wrong_location': '\uef78',
        'material:wysiwyg': '\uf1c3',
        'material:yakitori': '\uef31',
        'material:yard': '\uf089',
        'material:yoshoku': '\uf27f',
        'material:your_trips': '\ueb2b',
        'material:youtube_activity': '\uf85a',
        'material:youtube_searched_for': '\ue8fa',
        'material:zone_person_alert': '\ue781',
        'material:zone_person_idle': '\ue77a',
        'material:zone_person_urgent': '\ue788',
        'material:zoom_in': '\ue8ff',
        'material:zoom_in_map': '\ueb2d',
        'material:zoom_out': '\ue900',
        'material:zoom_out_map': '\ue56b',
    },
} as const;
